import "core-js/modules/esnext.promise.all-settled.js";
import "core-js/modules/es.object.from-entries.js";
import e, { useState as t, useEffect as a, useRef as n, forwardRef as r, useImperativeHandle as l } from "react";
import i from "lodash/at";
import { useField as o, useFormikContext as s, Field as c, Formik as d, Form as u } from "formik";
import { TextField as m, FormControl as p, FormControlLabel as f, Checkbox as v, FormHelperText as g, InputLabel as h, Select as b, MenuItem as y, TextareaAutosize as x, RadioGroup as C, Radio as E, Box as w, Typography as k, Grid as N, Stepper as S, Step as I, StepLabel as D, Button as F, CircularProgress as T, Tooltip as P, Card as L, IconButton as A, Backdrop as _, CardContent as O, Accordion as M, AccordionSummary as B, AccordionDetails as z, List as W, ListItem as R, Divider as V, useTheme as j, useMediaQuery as H } from "@material-ui/core";
import U from "prop-types";
import q from "@material-ui/core/Grid";
import { MuiPickersUtilsProvider as K, DatePicker as J } from "@material-ui/pickers";
import $ from "@date-io/date-fns";
import { format as Y } from "date-fns";
import G from "@mui/material/Rating";
import Z from "@material-ui/core/TextField";
import { Loader as X } from "@googlemaps/js-api-loader";
import Q from "@material-ui/icons/Cancel";
import ee from "@material-ui/icons/LocationOn";
import te from "react-google-recaptcha";
import ae from "axios";
import * as ne from "yup";
import { KeyboardArrowUp as re, KeyboardArrowRight as le } from "@material-ui/icons";
import { makeStyles as ie } from "@material-ui/core/styles";
import { ApolloClient as oe, HttpLink as se, InMemoryCache as ce, gql as de } from "@apollo/client";
import ue from "@mui/material/CardActions";
import me from "@mui/material/CardContent";
import pe from "@mui/material/Button";
import fe from "@mui/material/Typography";
import ve from "@material-ui/icons/Straighten";
import ge from "@mui/material/SvgIcon";
import he from "@material-ui/icons/InfoOutlined";
import be from "@material-ui/core/Select";
import ye from "@material-ui/core/MenuItem";
import xe from "@material-ui/core/InputLabel";
import Ce from "@material-ui/core/FormControl";
import Ee from "@material-ui/icons/ArrowBack";
import we from "react-image-gallery";
import ke from "@material-ui/icons/KeyboardArrowDown";
import Ne from "@material-ui/icons/ArrowDropDown";
import Se from "@material-ui/icons/Lock";
import Ie from "@material-ui/icons/CalendarToday";
import De from "@material-ui/icons/RemoveCircleOutline";
import Fe from "@material-ui/icons/CheckCircle";
import Te from "@material-ui/icons/AddCircleOutline";
import Pe from "@material-ui/icons/RadioButtonUnchecked";
import Le from "@material-ui/icons/RadioButtonChecked";
import Ae from "@material-ui/icons/Delete";
import { useStripe as _e, useElements as Oe, CardNumberElement as Me, CardExpiryElement as Be, CardCvcElement as ze, Elements as We } from "@stripe/react-stripe-js";
import { loadStripe as Re } from "@stripe/stripe-js/pure";
import Ve from "react-modal";
import je from "@material-ui/icons/Error";
import He from "react-input-verification-code";
import { makeStyles as Ue } from "@material-ui/styles";

function qe(e, t) {
  var a = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), a.push.apply(a, n);
  }

  return a;
}

function Ke(e) {
  for (var t = 1; t < arguments.length; t++) {
    var a = null != arguments[t] ? arguments[t] : {};
    t % 2 ? qe(Object(a), !0).forEach(function (t) {
      Ze(e, t, a[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : qe(Object(a)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
    });
  }

  return e;
}

function Je() {
  Je = function Je() {
    return e;
  };

  var e = {},
      t = Object.prototype,
      a = t.hasOwnProperty,
      n = Object.defineProperty || function (e, t, a) {
    e[t] = a.value;
  },
      r = "function" == typeof Symbol ? Symbol : {},
      l = r.iterator || "@@iterator",
      i = r.asyncIterator || "@@asyncIterator",
      o = r.toStringTag || "@@toStringTag";

  function s(e, t, a) {
    return Object.defineProperty(e, t, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), e[t];
  }

  try {
    s({}, "");
  } catch (e) {
    s = function s(e, t, a) {
      return e[t] = a;
    };
  }

  function c(e, t, a, r) {
    var l = t && t.prototype instanceof m ? t : m,
        i = Object.create(l.prototype),
        o = new N(r || []);
    return n(i, "_invoke", {
      value: C(e, a, o)
    }), i;
  }

  function d(e, t, a) {
    try {
      return {
        type: "normal",
        arg: e.call(t, a)
      };
    } catch (e) {
      return {
        type: "throw",
        arg: e
      };
    }
  }

  e.wrap = c;
  var u = {};

  function m() {}

  function p() {}

  function f() {}

  var v = {};
  s(v, l, function () {
    return this;
  });
  var g = Object.getPrototypeOf,
      h = g && g(g(S([])));
  h && h !== t && a.call(h, l) && (v = h);
  var b = f.prototype = m.prototype = Object.create(v);

  function y(e) {
    ["next", "throw", "return"].forEach(function (t) {
      s(e, t, function (e) {
        return this._invoke(t, e);
      });
    });
  }

  function x(e, t) {
    function r(n, l, i, o) {
      var s = d(e[n], e, l);

      if ("throw" !== s.type) {
        var c = s.arg,
            u = c.value;
        return u && "object" == typeof u && a.call(u, "__await") ? t.resolve(u.__await).then(function (e) {
          r("next", e, i, o);
        }, function (e) {
          r("throw", e, i, o);
        }) : t.resolve(u).then(function (e) {
          c.value = e, i(c);
        }, function (e) {
          return r("throw", e, i, o);
        });
      }

      o(s.arg);
    }

    var l;
    n(this, "_invoke", {
      value: function value(e, a) {
        function n() {
          return new t(function (t, n) {
            r(e, a, t, n);
          });
        }

        return l = l ? l.then(n, n) : n();
      }
    });
  }

  function C(e, t, a) {
    var n = "suspendedStart";
    return function (r, l) {
      if ("executing" === n) throw new Error("Generator is already running");

      if ("completed" === n) {
        if ("throw" === r) throw l;
        return I();
      }

      for (a.method = r, a.arg = l;;) {
        var i = a.delegate;

        if (i) {
          var o = E(i, a);

          if (o) {
            if (o === u) continue;
            return o;
          }
        }

        if ("next" === a.method) a.sent = a._sent = a.arg;else if ("throw" === a.method) {
          if ("suspendedStart" === n) throw n = "completed", a.arg;
          a.dispatchException(a.arg);
        } else "return" === a.method && a.abrupt("return", a.arg);
        n = "executing";
        var s = d(e, t, a);

        if ("normal" === s.type) {
          if (n = a.done ? "completed" : "suspendedYield", s.arg === u) continue;
          return {
            value: s.arg,
            done: a.done
          };
        }

        "throw" === s.type && (n = "completed", a.method = "throw", a.arg = s.arg);
      }
    };
  }

  function E(e, t) {
    var a = t.method,
        n = e.iterator[a];
    if (void 0 === n) return t.delegate = null, "throw" === a && e.iterator.return && (t.method = "return", t.arg = void 0, E(e, t), "throw" === t.method) || "return" !== a && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + a + "' method")), u;
    var r = d(n, e.iterator, t.arg);
    if ("throw" === r.type) return t.method = "throw", t.arg = r.arg, t.delegate = null, u;
    var l = r.arg;
    return l ? l.done ? (t[e.resultName] = l.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, u) : l : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, u);
  }

  function w(e) {
    var t = {
      tryLoc: e[0]
    };
    1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
  }

  function k(e) {
    var t = e.completion || {};
    t.type = "normal", delete t.arg, e.completion = t;
  }

  function N(e) {
    this.tryEntries = [{
      tryLoc: "root"
    }], e.forEach(w, this), this.reset(!0);
  }

  function S(e) {
    if (e) {
      var t = e[l];
      if (t) return t.call(e);
      if ("function" == typeof e.next) return e;

      if (!isNaN(e.length)) {
        var n = -1,
            r = function t() {
          for (; ++n < e.length;) {
            if (a.call(e, n)) return t.value = e[n], t.done = !1, t;
          }

          return t.value = void 0, t.done = !0, t;
        };

        return r.next = r;
      }
    }

    return {
      next: I
    };
  }

  function I() {
    return {
      value: void 0,
      done: !0
    };
  }

  return p.prototype = f, n(b, "constructor", {
    value: f,
    configurable: !0
  }), n(f, "constructor", {
    value: p,
    configurable: !0
  }), p.displayName = s(f, o, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
    var t = "function" == typeof e && e.constructor;
    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
  }, e.mark = function (e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, f) : (e.__proto__ = f, s(e, o, "GeneratorFunction")), e.prototype = Object.create(b), e;
  }, e.awrap = function (e) {
    return {
      __await: e
    };
  }, y(x.prototype), s(x.prototype, i, function () {
    return this;
  }), e.AsyncIterator = x, e.async = function (t, a, n, r, l) {
    void 0 === l && (l = Promise);
    var i = new x(c(t, a, n, r), l);
    return e.isGeneratorFunction(a) ? i : i.next().then(function (e) {
      return e.done ? e.value : i.next();
    });
  }, y(b), s(b, o, "Generator"), s(b, l, function () {
    return this;
  }), s(b, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (e) {
    var t = Object(e),
        a = [];

    for (var n in t) {
      a.push(n);
    }

    return a.reverse(), function e() {
      for (; a.length;) {
        var n = a.pop();
        if (n in t) return e.value = n, e.done = !1, e;
      }

      return e.done = !0, e;
    };
  }, e.values = S, N.prototype = {
    constructor: N,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(k), !e) for (var t in this) {
        "t" === t.charAt(0) && a.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
      }
    },
    stop: function stop() {
      this.done = !0;
      var e = this.tryEntries[0].completion;
      if ("throw" === e.type) throw e.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var t = this;

      function n(a, n) {
        return i.type = "throw", i.arg = e, t.next = a, n && (t.method = "next", t.arg = void 0), !!n;
      }

      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var l = this.tryEntries[r],
            i = l.completion;
        if ("root" === l.tryLoc) return n("end");

        if (l.tryLoc <= this.prev) {
          var o = a.call(l, "catchLoc"),
              s = a.call(l, "finallyLoc");

          if (o && s) {
            if (this.prev < l.catchLoc) return n(l.catchLoc, !0);
            if (this.prev < l.finallyLoc) return n(l.finallyLoc);
          } else if (o) {
            if (this.prev < l.catchLoc) return n(l.catchLoc, !0);
          } else {
            if (!s) throw new Error("try statement without catch or finally");
            if (this.prev < l.finallyLoc) return n(l.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(e, t) {
      for (var n = this.tryEntries.length - 1; n >= 0; --n) {
        var r = this.tryEntries[n];

        if (r.tryLoc <= this.prev && a.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
          var l = r;
          break;
        }
      }

      l && ("break" === e || "continue" === e) && l.tryLoc <= t && t <= l.finallyLoc && (l = null);
      var i = l ? l.completion : {};
      return i.type = e, i.arg = t, l ? (this.method = "next", this.next = l.finallyLoc, u) : this.complete(i);
    },
    complete: function complete(e, t) {
      if ("throw" === e.type) throw e.arg;
      return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), u;
    },
    finish: function finish(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var a = this.tryEntries[t];
        if (a.finallyLoc === e) return this.complete(a.completion, a.afterLoc), k(a), u;
      }
    },
    catch: function _catch(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var a = this.tryEntries[t];

        if (a.tryLoc === e) {
          var n = a.completion;

          if ("throw" === n.type) {
            var r = n.arg;
            k(a);
          }

          return r;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, t, a) {
      return this.delegate = {
        iterator: S(e),
        resultName: t,
        nextLoc: a
      }, "next" === this.method && (this.arg = void 0), u;
    }
  }, e;
}

function $e(e) {
  return $e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, $e(e);
}

function Ye(e, t, a, n, r, l, i) {
  try {
    var o = e[l](i),
        s = o.value;
  } catch (e) {
    return void a(e);
  }

  o.done ? t(s) : Promise.resolve(s).then(n, r);
}

function Ge(e) {
  return function () {
    var t = this,
        a = arguments;
    return new Promise(function (n, r) {
      var l = e.apply(t, a);

      function i(e) {
        Ye(l, n, r, i, o, "next", e);
      }

      function o(e) {
        Ye(l, n, r, i, o, "throw", e);
      }

      i(void 0);
    });
  };
}

function Ze(e, t, a) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" != typeof e || null === e) return e;
      var a = e[Symbol.toPrimitive];

      if (void 0 !== a) {
        var n = a.call(e, t || "default");
        if ("object" != typeof n) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }

      return ("string" === t ? String : Number)(e);
    }(e, "string");

    return "symbol" == typeof t ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = a, e;
}

function Xe() {
  return Xe = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  }, Xe.apply(this, arguments);
}

function Qe(e, t) {
  if (null == e) return {};

  var a,
      n,
      r = function (e, t) {
    if (null == e) return {};
    var a,
        n,
        r = {},
        l = Object.keys(e);

    for (n = 0; n < l.length; n++) {
      a = l[n], t.indexOf(a) >= 0 || (r[a] = e[a]);
    }

    return r;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);

    for (n = 0; n < l.length; n++) {
      a = l[n], t.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (r[a] = e[a]);
    }
  }

  return r;
}

function et(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}

function tt(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var a = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

    if (null != a) {
      var n,
          r,
          l,
          i,
          o = [],
          s = !0,
          c = !1;

      try {
        if (l = (a = a.call(e)).next, 0 === t) {
          if (Object(a) !== a) return;
          s = !1;
        } else for (; !(s = (n = l.call(a)).done) && (o.push(n.value), o.length !== t); s = !0) {
          ;
        }
      } catch (e) {
        c = !0, r = e;
      } finally {
        try {
          if (!s && null != a.return && (i = a.return(), Object(i) !== i)) return;
        } finally {
          if (c) throw r;
        }
      }

      return o;
    }
  }(e, t) || nt(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function at(e) {
  return function (e) {
    if (Array.isArray(e)) return rt(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || nt(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function nt(e, t) {
  if (e) {
    if ("string" == typeof e) return rt(e, t);
    var a = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? Array.from(e) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? rt(e, t) : void 0;
  }
}

function rt(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var a = 0, n = new Array(t); a < t; a++) {
    n[a] = e[a];
  }

  return n;
}

var lt = ["errorText", "name", "label"];

function it(t) {
  t.errorText, t.name;
  var a = t.label,
      n = Qe(t, lt),
      r = tt(o(t), 2),
      l = r[0],
      c = r[1],
      d = s().submitCount,
      u = tt(i(c, "touched", "error"), 2),
      p = u[0],
      f = u[1];

  function v() {
    if ((p || d > 0) && f) return f;
  }

  return a ? e.createElement("div", {
    className: "ondeff-input-with-label"
  }, e.createElement(m, Xe({
    type: "text",
    variant: "outlined",
    error: (p || d > 0) && Boolean(f),
    helperText: v(),
    placeholder: !0
  }, l, n, {
    label: a
  }))) : e.createElement(m, Xe({
    type: "text",
    error: (p || d > 0) && Boolean(f),
    helperText: v(),
    placeholder: !0
  }, l, n));
}

var ot = ["label"];

function st(t) {
  var a = t.label,
      n = Qe(t, ot),
      r = tt(o(t), 3),
      l = r[0],
      c = r[1],
      d = r[2],
      u = s().submitCount,
      m = d.setValue;
  return e.createElement(p, n, e.createElement(f, {
    value: l.checked,
    checked: l.checked,
    control: e.createElement(v, Xe({}, l, {
      onChange: function onChange(e) {
        m(e.target.checked);
      }
    })),
    label: a
  }), function () {
    var t = tt(i(c, "touched", "error"), 2),
        a = t[0],
        n = t[1];
    if ((a || u > 0) && n) return e.createElement(g, null, n);
  }());
}

var ct = ["label", "data"];

function dt(t) {
  var a = t.label,
      n = t.data,
      r = Qe(t, ct),
      l = tt(o(t), 2),
      c = l[0],
      d = l[1],
      u = s().submitCount,
      m = c.value,
      f = tt(i(d, "touched", "error"), 2),
      v = f[0],
      x = f[1];
  return e.createElement(p, Xe({
    variant: "outlined-select" === t.className ? "outlined" : ""
  }, r), e.createElement(h, null, a), e.createElement(b, Xe({}, c, {
    value: m || ""
  }), n.map(function (t, a) {
    return e.createElement(y, {
      key: a,
      value: t.value
    }, t.label);
  })), function () {
    if ((v || u > 0) && x) return e.createElement(g, {
      error: !0
    }, x);
  }());
}

function ut(n) {
  var r = tt(o(n), 3),
      l = r[0],
      i = r[1],
      c = r[2],
      d = s().submitCount,
      u = i.touched,
      p = i.error,
      f = c.setValue,
      v = l.value,
      g = tt(t(null), 2),
      h = g[0],
      b = g[1];
  a(function () {
    if (v) {
      var e = new Date(v);
      b(e);
    }
  }, [v]);
  var y, x;
  return e.createElement(q, {
    container: !0
  }, e.createElement(K, {
    utils: $
  }, e.createElement(J, Xe({}, l, n, {
    className: "date-picker-class",
    value: h,
    onChange: function onChange(e) {
      if (e) {
        b(e);

        try {
          var t = new Date(e),
              a = Y(t, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
          f(a), n.onChangeValue && n.onChangeValue("alternate_dates", [a]);
        } catch (t) {
          f(e), n.onChangeValue && n.onChangeValue("alternate_dates", [e]);
        }
      } else f(e), n.onChangeValue && n.onChangeValue("alternate_dates", [e]);
    },
    error: !0,
    shouldDisableDate: n.disabledDates && function (e) {
      var t;
      return null === (t = n.disabledDates) || void 0 === t ? void 0 : t.includes(e.getDay());
    },
    invalidDateMessage: (u || d > 0) && p,
    autoOk: !0,
    format: n.format,
    DialogProps: {
      PaperProps: {
        className: h ? "" : (y = new Date(n.minDate), x = new Date(), x.setHours(0, 0, 0, 0), y.setHours(0, 0, 0, 0), x >= y ? "today-custom-date-picker-dialog" : "custom-date-picker-dialog")
      }
    },
    TextFieldComponent: function TextFieldComponent(t) {
      return e.createElement(m, Xe({}, t, {
        variant: "outlined",
        error: d > 0 && p,
        helperText: d > 0 && p
      }));
    }
  }))));
}

dt.defaultProps = {
  data: []
}, dt.propTypes = {
  data: U.array.isRequired
};
var mt = ["errorText"];

function pt(t) {
  t.errorText;
  var a = Qe(t, mt),
      n = tt(o(t), 2),
      r = n[0];
  return n[1], e.createElement(c, Xe({
    onChange: function onChange(e) {
      console.log(r.name + " cambió..."), formik.handleChange(r.name);
    },
    type: "hidden"
  }, r, a));
}

var ft = ["errorText", "name", "label", "className"];

function vt(t) {
  t.errorText;
  var a = t.name,
      n = t.label;
  t.className;
  var r = Qe(t, ft),
      l = tt(o(t), 2),
      c = l[0],
      d = l[1],
      u = s().submitCount,
      m = tt(i(d, "touched", "error"), 2),
      p = m[0],
      f = m[1];
  return e.createElement("div", {
    className: "ondeff-textarea-with-label"
  }, n && e.createElement("label", {
    htmlFor: a,
    dangerouslySetInnerHTML: {
      __html: n
    }
  }), e.createElement(x, Xe({
    type: "text",
    multiline: !0,
    maxRows: 8,
    minRows: 8,
    "aria-label": "maximum height",
    error: (p || u > 0) && Boolean(f)
  }, c, r)), function () {
    if ((p || u > 0) && f) return e.createElement(g, {
      error: !0
    }, f);
  }());
}

var gt = ["label", "data"];

function ht(t) {
  var a;
  t.label;
  var n = t.data,
      r = Qe(t, gt),
      l = tt(o(t), 3),
      c = l[0],
      d = l[1],
      u = l[2],
      m = s().submitCount;
  u.setValue;
  var v = tt(i(d, "touched", "error"), 2),
      h = v[0],
      b = v[1];
  return e.createElement(p, Xe({}, r, {
    error: (h || m > 0) && Boolean(b)
  }), e.createElement(C, Xe({}, c, {
    "aria-labelledby": "demo-controlled-radio-buttons-group"
  }), n.map(function (t, a) {
    return e.createElement(f, {
      key: a,
      value: t.value,
      control: e.createElement(E, null),
      label: t.label
    });
  })), e.createElement("p", {
    className: "quotes-message"
  }, (null == c ? void 0 : c.value) && (null === (a = n.find(function (e) {
    return e.value === c.value;
  })) || void 0 === a ? void 0 : a.message)), function () {
    if ((h || m > 0) && b) return e.createElement(g, null, b);
  }());
}

var bt = ["label", "data", "onChangeValue", "formValues"];

function yt(n) {
  var r = n.label;
  n.data;
  var l = n.onChangeValue,
      c = n.formValues,
      d = Qe(n, bt),
      u = tt(o(n), 2),
      m = u[0],
      f = u[1],
      v = s().submitCount,
      b = tt(t(0), 2),
      y = b[0],
      x = b[1],
      C = tt(i(f, "touched", "error"), 2),
      E = C[0],
      w = C[1],
      k = (E || v > 0) && w && !0;
  a(function () {
    null != c && c.rating && x(c.rating);
  }, []);
  return e.createElement(p, Xe({}, d, {
    error: k
  }), y && 0 !== y ? e.createElement(h, {
    className: n.className
  }, function (e) {
    var t = "";

    switch (e) {
      case 1:
        t = "Not good";
        break;

      case 2:
        t = "Below average";
        break;

      case 3:
        t = "Ok";
        break;

      case 4:
        t = "Good";
        break;

      case 5:
        t = "Great";
    }

    return t;
  }(y)) : r && e.createElement(h, {
    className: n.className
  }, r, " ", e.createElement("b", null, "*")), e.createElement(G, {
    name: m.name + "rtg",
    size: "large",
    value: y,
    onChange: function onChange(e, t) {
      console.log(t), x(t), l("rating", t);
    }
  }), function () {
    if (k) return e.createElement(g, null, w);
  }());
}

var xt,
    Ct = ["errorText", "dependencies", "label", "name"];

function Et(t) {
  var a, n, r, l, c, d, u, m;
  t.errorText, t.dependencies;
  var p = t.label;
  t.name;
  var f = Qe(t, Ct),
      v = tt(o(t), 3),
      g = v[0],
      h = v[1],
      b = v[2],
      y = s().submitCount,
      x = tt(i(h, "touched", "error"), 2),
      C = x[0],
      E = x[1];

  function w() {
    if ((C || y > 0) && E) return E;
  }

  var k = function k(e) {
    var t = "",
        a = e.target.value.replace(/[^0-9]/g, "");
    "1" === a[0] && (a = "");
    var n = a.substr(0, 3),
        r = a.substr(3, 3),
        l = a.substr(6, 4);
    0 === n.length ? t = "" : n.length < 3 ? t = "(" + n : 3 == n.length && r.length < 3 ? t = "(" + n + ") " + r : 3 == n.length && 3 == r.length && (t = "(" + n + ") " + r + "-" + l), b && b.setValue(t);
  };

  return p ? e.createElement("div", {
    className: "ondeff-input-with-label"
  }, e.createElement(Z, Xe({
    type: "tel",
    variant: "outlined",
    error: (C || y > 0) && Boolean(E),
    helperText: w(),
    placeholder: !0
  }, g, f, {
    label: p,
    onKeyUp: k,
    inputProps: {
      maxLength: null !== (c = g.value) && void 0 !== c && c.includes(" ") || null !== (d = g.value) && void 0 !== d && d.includes("(") || null !== (u = g.value) && void 0 !== u && u.includes(")") || null !== (m = g.value) && void 0 !== m && m.includes("-") ? 14 : 10
    }
  }))) : e.createElement(e.Fragment, null, e.createElement(Z, Xe({
    type: "tel",
    error: (C || y > 0) && Boolean(E),
    helperText: w(),
    placeholder: !0
  }, g, f, {
    onKeyUp: k,
    inputProps: {
      maxLength: null !== (a = g.value) && void 0 !== a && a.includes(" ") || null !== (n = g.value) && void 0 !== n && n.includes("(") || null !== (r = g.value) && void 0 !== r && r.includes(")") || null !== (l = g.value) && void 0 !== l && l.includes("-") ? 14 : 10
    }
  })));
}

var wt = function wt(e) {
  return xt || (xt = new X({
    apiKey: e,
    version: "weekly",
    libraries: ["places"]
  })), xt;
},
    kt = function kt(e) {
  var t = [],
      a = e.getPlace();
  return ["place_id", "address_components", "formatted_address"].map(function (e) {
    switch (e) {
      case "place_id":
        a.place_id && t.push(["place_id", a.place_id]);
        break;

      case "formatted_address":
        !function () {
          if (a.formatted_address) {
            var e = a.formatted_address.split(",");
            e.length > 0 && (t.push(["street", e[0]]), e.shift(), t.push(["street2", e.join().trim()]));
          }
        }();
        break;

      case "address_components":
        !function () {
          if (a.address_components) {
            var e = ["postal_code", "locality", "country", "administrative_area_level_1"],
                n = a.address_components;
            Object.keys(n).map(function (a) {
              var r = n[a].types[0],
                  l = n[a].long_name;
              e.map(function (e) {
                e === r && ("administrative_area_level_1" === r && (r = "state"), t.push([r, l]));
              });
            });
          }
        }();
    }
  }), t;
};

function Nt(r) {
  var l,
      i,
      o = r.apiKey,
      c = r.defaultValue,
      d = r.name,
      u = r.placeholder,
      m = r.resetError,
      p = r.onChange,
      f = r.onResetField,
      v = r.onChangeValue,
      g = r.formValues,
      h = r.label,
      b = r.size,
      y = void 0 === b ? "medium" : b,
      x = r.showSearchIcon,
      C = void 0 !== x && x,
      E = r.className,
      w = r.id,
      k = wt(o),
      N = n(),
      S = n(),
      I = n(),
      D = n(),
      F = n(""),
      T = tt(t(Math.floor(9999 * Math.random())), 2),
      P = T[0],
      L = T[1],
      A = tt(t(function () {}), 2);
  A[0];

  var _ = A[1],
      O = tt(t("google-place-autocomplete-input"), 2),
      M = O[0],
      B = O[1],
      z = tt(t(c || g && g.odf_street && g.odf_street + ", " + g.odf_street2), 2),
      W = z[0],
      R = z[1],
      V = s(),
      j = function j() {
    m && m(), p && (p(kt(I.current)), N.current.focus(), N.current.setSelectionRange(0, 0));
  };

  a(function () {
    "" !== v && function (e) {
      (null == e ? void 0 : e.length) > 0 && JSON.parse(e).map(function (e) {
        g["odf_" + e[0]] = e[1];
      });
    }(v);
  }, [v]);

  var H = function H() {
    "undefined" != typeof window && window.google.maps.event.removeListener(D.current), _(function () {});
    var e = N.current.value;
    L(Math.random()), N.current.value = e, m && m();
  };

  return a(function () {
    "undefined" != typeof window && (window.gm_authFailure = function () {
      console.log("Google Api Error"), B(d || "google-place-autocomplete-input"), H();
    }), m && m(), k.load().then(function (e) {
      I.current = new e.maps.places.Autocomplete(N.current, {
        types: ["address"],
        componentRestrictions: {
          country: ["US"]
        },
        fields: []
      }), D.current = I.current.addListener("place_changed", j);

      var t = function t() {
        setTimeout(function () {
          var e = N.current;

          if (e.value !== F.current) {
            e.focus();
            var t = new Event("input", {
              bubbles: !0
            });
            e.dispatchEvent(t);
            var a = e.value;
            e.value = "", e.value = a, F.current = a;
          }
        }, 500);
      },
          a = N.current;

      return a.addEventListener("input", t), a.addEventListener("change", t), function () {
        a.removeEventListener("input", t), a.removeEventListener("change", t);
      };
    }).catch(function (e) {
      console.log(e);
    });
  }, [P]), e.createElement("div", {
    className: "".concat(E, " google-place-autocomplete")
  }, e.createElement(Z, {
    id: w,
    disabled: !!r.disabled && r.disabled,
    defaultValue: W,
    className: E,
    variant: "outlined",
    size: y,
    error: (null == V ? void 0 : V.submitCount) > 0 && !(null !== (l = N.current) && void 0 !== l && l.value),
    helperText: (null == V ? void 0 : V.submitCount) > 0 && !(null !== (i = N.current) && void 0 !== i && i.value) && "Please enter an address",
    inputRef: N,
    label: h,
    InputProps: {
      key: P,
      placeholder: u,
      name: M,
      startAdornment: C ? e.createElement(ee, {
        style: {
          color: "#f58220"
        }
      }) : null,
      endAdornment: r.disabled ? e.createElement(e.Fragment, null) : e.createElement(Q, {
        className: "google-place-autocomplete-clear",
        ref: S,
        onClick: function onClick(e) {
          e.preventDefault(), R(""), Object.keys(g).map(function (e) {
            e.startsWith("odf_") && (g[e] = "");
          }), f(), H();
        }
      })
    }
  }));
}

var St = ["label", "data", "isError", "error", "defaultValue"];

function It(a) {
  var n = a.label,
      r = a.data,
      l = a.isError,
      i = a.error,
      o = a.defaultValue,
      s = Qe(a, St),
      c = tt(t(o), 2),
      d = c[0],
      u = c[1];
  return e.createElement(p, Xe({
    variant: "outlined"
  }, s, {
    error: l
  }), e.createElement(h, null, n), e.createElement(b, {
    value: d || "",
    onChange: function onChange(e) {
      a.onChange && a.onChange(e.target.value), u(e.target.value);
    },
    label: n
  }, r.map(function (t, a) {
    return e.createElement(y, {
      key: a,
      value: t.value
    }, t.label);
  })), function () {
    if (l) return e.createElement(g, null, i);
  }());
}

It.defaultProps = {
  data: []
}, It.propTypes = {
  data: U.array.isRequired
};
var Dt = ["label", "data"];

function Ft(t) {
  t.label;
  var a = t.data,
      n = Qe(t, Dt),
      r = tt(o(t), 3),
      l = r[0],
      c = r[1],
      d = r[2],
      u = s().submitCount,
      m = d.setValue;
  return e.createElement(p, n, a.map(function (t, a) {
    return e.createElement(f, {
      key: a,
      control: e.createElement(v, {
        checked: l.value.includes(t.value),
        onChange: function onChange(e) {
          return function (e, t) {
            var a = at(l.value);
            if (e.target.checked) a.push(t);else {
              var n = a.indexOf(t);
              n > -1 && a.splice(n, 1);
            }
            m(a);
          }(e, t.value);
        }
      }),
      label: e.createElement("span", {
        style: {
          fontSize: "2.2rem"
        }
      }, t.label)
    });
  }), function () {
    var t = tt(i(c, "touched", "error"), 2),
        a = t[0],
        n = t[1];
    if ((a || u > 0) && n) return e.createElement(g, {
      error: !0
    }, n);
  }());
}

function Tt(n) {
  var r = tt(t({
    id: "",
    show: !1
  }), 2),
      l = r[0],
      i = r[1];
  return a(function () {
    n.data.options && n.data.options.forEach(function (e, t) {
      e.options.find(function (e) {
        return e.value === n.formValues[n.data.name];
      }) && i({
        id: t,
        show: !0
      });
    });
  }, [n.formValues[n.data.name]]), n.data.options && n.data.options.map(function (t, a) {
    return e.createElement("div", {
      key: a
    }, e.createElement("h4", {
      onClick: function onClick(e) {
        return t = a, void (l.id === t ? i({
          id: t,
          show: !l.show
        }) : i({
          id: t,
          show: !0
        }));
        var t;
      },
      id: a
    }, e.createElement("span", null, t.label), l.id === a && l.show ? e.createElement(re, {
      style: {
        color: "#999"
      }
    }) : e.createElement(le, {
      style: {
        color: "#999"
      }
    })), e.createElement("div", null, l.id === a && l.show && e.createElement(ht, {
      className: "ondeff-radios",
      name: n.data.name,
      label: n.data.label,
      data: t.options,
      fullWidth: n.fullWidth
    })));
  });
}

function Pt(a) {
  var n = a.name,
      r = a.value,
      l = a.label,
      i = a.type,
      o = a.checked,
      s = a.onChange,
      c = tt(t(null), 2),
      d = (c[0], c[1]),
      u = function u(e) {
    if ("fancy-checkbox" === i) m();else {
      e.currentTarget, d(e.currentTarget), p(e);
    }
  },
      m = function m(e) {
    s(r, o ? "remove" : "add");
  },
      p = function p(e) {
    for (var t = document.getElementsByName(n), a = 2; a < t.length; a++) {
      t[a].parentElement.classList.remove("ondeff-fancy-stylized-checkbox-checked"), t[a].parentElement.classList.add("ondeff-fancy-stylized-checkbox");
    }

    e.currentTarget.classList.contains("checked") ? e.currentTarget.classList.remove("ondeff-fancy-stylized-checkbox-checked") : (e.currentTarget.classList.add("ondeff-fancy-stylized-checkbox-checked"), s(r, "add"));
  };

  return "fancy-checkbox" === i ? e.createElement("div", {
    className: o ? "ondeff-fancy-stylized-checkbox-checked" : "ondeff-fancy-stylized-checkbox",
    onClick: u,
    "data-status": o
  }, e.createElement("div", {
    className: "label"
  }, l)) : e.createElement("div", {
    className: o ? "ondeff-fancy-stylized-checkbox-checked" : "ondeff-fancy-stylized-checkbox",
    onClick: u
  }, e.createElement("input", {
    className: "input_" + n,
    type: "radio",
    name: n,
    value: r,
    checked: o
  }), e.createElement("div", {
    className: "label"
  }, l));
}

var Lt = ["name", "label", "options", "type", "formValues", "onChangeValue"];

function At(n) {
  var r,
      l = n.name,
      d = n.label,
      u = n.options,
      m = n.type,
      f = n.formValues,
      v = n.onChangeValue,
      h = Qe(n, Lt),
      b = tt(t(""), 2),
      y = b[0],
      x = b[1],
      C = tt(o(n), 2),
      E = C[0],
      w = C[1],
      k = s().submitCount,
      N = tt(i(w, "touched", "error"), 2),
      S = N[0],
      I = N[1],
      D = (S || k > 0) && I && !0;
  a(function () {
    "radio-custom" === m && v(l, f[l] ? f[l] : "1"), f[l] && x(f[l]);
  }, []);

  var F = function F(e, t) {
    var a = "" === y ? [] : "fancy-checkbox" === m ? y.split(",") : y;

    switch (t) {
      case "add":
        if ("fancy-checkbox" === m) {
          a.push(e.toString());
          break;
        }

        a = [e.toString()];
        break;

      case "remove":
        if ("fancy-checkbox" === m) {
          var n = a.indexOf(e.toString());
          n > -1 && a.splice(n, 1);
          break;
        }

        a = [e.toString()];
    }

    "fancy-checkbox" === m ? (x(a.join(",")), v(l, a.join(","))) : (x(a), v(l, a[0]));
  };

  return e.createElement(p, Xe({}, h, {
    error: D
  }), e.createElement(c, {
    type: "hidden",
    name: E.name,
    value: y
  }), e.createElement("div", {
    id: "radioContainer",
    className: "ondeff-fancy-checkbox"
  }, d && e.createElement("label", {
    htmlFor: l,
    dangerouslySetInnerHTML: {
      __html: d
    }
  }), e.createElement("input", {
    className: "input_" + l,
    type: "hidden",
    name: l,
    value: y
  }), e.createElement("div", {
    className: "ondeff-fancy-checkbox-group"
  }, null == u ? void 0 : u.map(function (t, a) {
    return r = !1, "radio-custom" === m && parseInt(f[l]) == u.length - a - 1 && (r = !0), "fancy-checkbox" === m && y.includes(t.value) && (r = !0), e.createElement(Pt, {
      name: l,
      value: t.value,
      type: m,
      label: t.label,
      onChange: F,
      checked: r
    });
  }))), function () {
    if (D) return e.createElement(g, null, I);
  }());
}

var _t = ["name", "label", "options", "formValues", "onChangeValue"],
    Ot = function Ot(t) {
  var a = t.label,
      n = t.message,
      r = t.image,
      l = t.selected,
      i = t.onSelect;
  return e.createElement(w, {
    onClick: i,
    sx: {
      display: "flex",
      alignItems: "center",
      padding: "10px",
      border: l ? "4px solid orange !important" : "1px solid #cccccc",
      borderRadius: "8px",
      backgroundColor: "#FFFFFF",
      cursor: "pointer",
      transition: "border 0.3s ease-in-out",
      marginBottom: "8px",
      "&:hover": {
        boxShadow: "0px 0px 5px 0px #c3c3c3"
      },
      "@media (max-width: 400px)": {
        "& label": {
          display: "none"
        }
      }
    }
  }, e.createElement(f, {
    control: e.createElement(E, {
      checked: l
    }),
    sx: {
      marginRight: "10px",
      "& .MuiSvgIcon-root": {
        fontSize: 20
      },
      "& .Mui-checked": {
        color: "orange"
      }
    },
    style: {
      width: "50px"
    },
    onClick: i
  }), e.createElement(w, {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "calc(100% - 50px)",
      flexDirection: "column",
      "@media (max-width: 400px)": {
        width: "100%"
      },
      "& p": {
        fontWeight: l ? "700" : "400"
      }
    }
  }, r && e.createElement(w, {
    component: "img",
    src: r,
    alt: a,
    sx: {
      width: "100%",
      height: "auto",
      aspectRatio: "4/3",
      maxWidth: "200px"
    }
  }), e.createElement(k, {
    variant: "body1",
    sx: {
      marginBottom: "10px"
    }
  }, a), n && e.createElement(k, {
    variant: "body1",
    sx: {
      marginBottom: "10px"
    }
  }, n)));
};

function Mt(t) {
  var a = t.name;
  t.label;
  var n = t.options;
  t.formValues;
  var r = t.onChangeValue,
      l = Qe(t, _t),
      c = tt(o(t), 2),
      d = c[0],
      u = c[1],
      m = s().submitCount,
      f = tt(i(u, "touched", "error"), 2),
      v = f[0],
      h = f[1];
  return e.createElement(p, l, e.createElement(w, null, n.map(function (t, n) {
    return e.createElement(Ot, {
      key: n,
      label: t.label,
      image: t.image,
      message: t.message,
      selected: d.value === t.value,
      onSelect: function onSelect() {
        return e = t.value, void r(a, e);
        var e;
      }
    });
  })), function () {
    if ((v || m > 0) && h) return e.createElement(g, {
      error: !0
    }, h);
  }());
}

var Bt = function Bt(e) {
  var t = ("" + e).replace(/\D/g, "").match(/^(\d{3})(\d{3})(\d{4})$/);
  return t ? "(" + t[1] + ") " + t[2] + "-" + t[3] : "";
};

function zt(a) {
  var n = a.formField,
      r = a.handleChangeFields,
      l = a.formValues,
      i = a.googleApiKey,
      o = tt(t(""), 2),
      s = o[0],
      c = o[1];

  Date.prototype.addDays = function (e) {
    var t = new Date(this.valueOf());
    return t.setDate(t.getDate() + e), t;
  };

  var d = function d(e) {
    return e ? e.startsWith("+") || e.startsWith("-") ? new Date().addDays(parseInt(e)) : new Date(e) : new Date();
  },
      u = function u(e) {
    if ("alternate_dates" !== e.name) return e.options;

    if (l.delivery_date) {
      var t = function (e, t) {
        function a(e) {
          return 0 === e.getDay();
        }

        function n(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
              n = new Date(e);

          for (n.setDate(n.getDate() + t); a(n);) {
            n.setDate(n.getDate() + (t > 0 ? 1 : -1));
          }

          return n;
        }

        var r,
            l = new Date(),
            i = t.getHours() >= 12,
            o = e.toDateString() === l.toDateString(),
            s = e.toDateString() === n(l).toDateString(),
            c = function c(e) {
          return e.toLocaleDateString("en-US", {
            weekday: "short",
            month: "short",
            day: "numeric"
          });
        };

        if (o || s && i) {
          var d = n(e, 1),
              u = n(e, 2);
          c(d) === c(u) && (u = n(e, 3)), r = [{
            value: e.toISOString(),
            label: "".concat(c(e), " (Preferred)")
          }, {
            value: d.toISOString(),
            label: c(d)
          }, {
            value: u.toISOString(),
            label: c(u)
          }];
        } else {
          var m = n(e, -1),
              p = n(e, 1);
          r = [{
            value: m.toISOString(),
            label: c(m)
          }, {
            value: e.toISOString(),
            label: "".concat(c(e), " (Preferred)")
          }, {
            value: p.toISOString(),
            label: c(p)
          }];
        }

        return r;
      }(new Date(l.delivery_date), new Date());

      return t;
    }
  };

  return e.createElement(e.Fragment, null, e.createElement(N, {
    container: !0,
    spacing: 3
  }, n.map(function (t) {
    if ("paragraph" === t.type) {
      var a,
          n,
          o,
          m,
          p,
          f,
          v,
          g = e.createElement(e.Fragment, null);

      if (null !== (a = t.preConditions) && void 0 !== a && a.name || null !== (n = t.preConditions) && void 0 !== n && n.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var h, b, y, x, C;
          g = e.createElement(N, {
            key: t.name ? t.name : (1e4 * Math.random()).toFixed(0),
            item: !0,
            xs: null !== (h = t.gridCols) && void 0 !== h && h.xs ? t.gridCols.xs : 12,
            sm: null !== (b = t.gridCols) && void 0 !== b && b.sm ? t.gridCols.sm : 12,
            md: null !== (y = t.gridCols) && void 0 !== y && y.md ? t.gridCols.md : 12,
            lg: null !== (x = t.gridCols) && void 0 !== x && x.lg ? t.gridCols.lg : 12,
            xl: null !== (C = t.gridCols) && void 0 !== C && C.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement("div", {
            className: "accept-terms-message" === t.className ? "accept-terms-message" : "ondeff-paragraph",
            dangerouslySetInnerHTML: {
              __html: t.value
            }
          }));
        }
      } else g = e.createElement(N, {
        key: t.name ? t.name : (1e4 * Math.random()).toFixed(0),
        item: !0,
        xs: null !== (o = t.gridCols) && void 0 !== o && o.xs ? t.gridCols.xs : 12,
        sm: null !== (m = t.gridCols) && void 0 !== m && m.sm ? t.gridCols.sm : 12,
        md: null !== (p = t.gridCols) && void 0 !== p && p.md ? t.gridCols.md : 12,
        lg: null !== (f = t.gridCols) && void 0 !== f && f.lg ? t.gridCols.lg : 12,
        xl: null !== (v = t.gridCols) && void 0 !== v && v.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement("div", {
        className: "accept-terms-message" === t.className ? "accept-terms-message" : "ondeff-paragraph",
        dangerouslySetInnerHTML: {
          __html: t.value
        }
      }));

      return g;
    }

    if ("hidden" === t.type) {
      var E,
          w,
          k,
          S,
          I,
          D,
          F,
          T = e.createElement(e.Fragment, null);

      if (null !== (E = t.preConditions) && void 0 !== E && E.name || null !== (w = t.preConditions) && void 0 !== w && w.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var P, L, A, _, O;

          T = e.createElement(N, {
            key: t.name,
            item: !0,
            xs: null !== (P = t.gridCols) && void 0 !== P && P.xs ? t.gridCols.xs : 12,
            sm: null !== (L = t.gridCols) && void 0 !== L && L.sm ? t.gridCols.sm : 12,
            md: null !== (A = t.gridCols) && void 0 !== A && A.md ? t.gridCols.md : 12,
            lg: null !== (_ = t.gridCols) && void 0 !== _ && _.lg ? t.gridCols.lg : 12,
            xl: null !== (O = t.gridCols) && void 0 !== O && O.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(pt, {
            name: t.name,
            label: t.label
          }));
        }
      } else T = e.createElement(N, {
        key: t.name,
        item: !0,
        xs: null !== (k = t.gridCols) && void 0 !== k && k.xs ? t.gridCols.xs : 12,
        sm: null !== (S = t.gridCols) && void 0 !== S && S.sm ? t.gridCols.sm : 12,
        md: null !== (I = t.gridCols) && void 0 !== I && I.md ? t.gridCols.md : 12,
        lg: null !== (D = t.gridCols) && void 0 !== D && D.lg ? t.gridCols.lg : 12,
        xl: null !== (F = t.gridCols) && void 0 !== F && F.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(pt, {
        name: t.name,
        label: t.label
      }));

      return T;
    }

    if ("mobile" === t.type) {
      var M,
          B,
          z,
          W,
          R,
          V,
          j,
          H = e.createElement(e.Fragment, null);

      if (null !== (M = t.preConditions) && void 0 !== M && M.name || null !== (B = t.preConditions) && void 0 !== B && B.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var U, q, K, J, $;
          H = e.createElement(N, {
            key: t.name,
            item: !0,
            xs: null !== (U = t.gridCols) && void 0 !== U && U.xs ? t.gridCols.xs : 12,
            sm: null !== (q = t.gridCols) && void 0 !== q && q.sm ? t.gridCols.sm : 12,
            md: null !== (K = t.gridCols) && void 0 !== K && K.md ? t.gridCols.md : 12,
            lg: null !== (J = t.gridCols) && void 0 !== J && J.lg ? t.gridCols.lg : 12,
            xl: null !== ($ = t.gridCols) && void 0 !== $ && $.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(Et, {
            key: "key.name_1",
            className: "ondeff-text ".concat(t.className || ""),
            name: t.name,
            label: t.label,
            placeholder: t.placeholder
          }));
        }
      } else H = e.createElement(N, {
        key: t.name,
        item: !0,
        xs: null !== (z = t.gridCols) && void 0 !== z && z.xs ? t.gridCols.xs : 12,
        sm: null !== (W = t.gridCols) && void 0 !== W && W.sm ? t.gridCols.sm : 12,
        md: null !== (R = t.gridCols) && void 0 !== R && R.md ? t.gridCols.md : 12,
        lg: null !== (V = t.gridCols) && void 0 !== V && V.lg ? t.gridCols.lg : 12,
        xl: null !== (j = t.gridCols) && void 0 !== j && j.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(Et, {
        key: "key.name_1",
        className: "ondeff-text ".concat(t.className || ""),
        name: t.name,
        label: t.label,
        placeholder: t.placeholder
      }));

      return H;
    }

    if ("textarea" === t.type) {
      var Y,
          G,
          Z,
          X,
          Q,
          ee,
          te,
          ae = e.createElement(e.Fragment, null);

      if (null !== (Y = t.preConditions) && void 0 !== Y && Y.name || null !== (G = t.preConditions) && void 0 !== G && G.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var ne, re, le, ie, oe;
          ae = e.createElement(N, {
            key: t.name,
            item: !0,
            xs: null !== (ne = t.gridCols) && void 0 !== ne && ne.xs ? t.gridCols.xs : 12,
            sm: null !== (re = t.gridCols) && void 0 !== re && re.sm ? t.gridCols.sm : 12,
            md: null !== (le = t.gridCols) && void 0 !== le && le.md ? t.gridCols.md : 12,
            lg: null !== (ie = t.gridCols) && void 0 !== ie && ie.lg ? t.gridCols.lg : 12,
            xl: null !== (oe = t.gridCols) && void 0 !== oe && oe.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(vt, {
            name: t.name,
            label: t.label,
            className: t.className,
            placeholder: t.placeholder
          }));
        }
      } else ae = e.createElement(N, {
        key: t.name,
        item: !0,
        xs: null !== (Z = t.gridCols) && void 0 !== Z && Z.xs ? t.gridCols.xs : 12,
        sm: null !== (X = t.gridCols) && void 0 !== X && X.sm ? t.gridCols.sm : 12,
        md: null !== (Q = t.gridCols) && void 0 !== Q && Q.md ? t.gridCols.md : 12,
        lg: null !== (ee = t.gridCols) && void 0 !== ee && ee.lg ? t.gridCols.lg : 12,
        xl: null !== (te = t.gridCols) && void 0 !== te && te.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(vt, {
        name: t.name,
        label: t.label,
        className: t.className,
        placeholder: t.placeholder
      }));

      return ae;
    }

    if ("text" === t.type) {
      var se,
          ce,
          de,
          ue,
          me,
          pe,
          fe,
          ve = e.createElement(e.Fragment, null);

      if (null !== (se = t.preConditions) && void 0 !== se && se.name || null !== (ce = t.preConditions) && void 0 !== ce && ce.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var ge, he, be, ye, xe;
          ve = e.createElement(N, {
            key: t.name,
            item: !0,
            xs: null !== (ge = t.gridCols) && void 0 !== ge && ge.xs ? t.gridCols.xs : 12,
            sm: null !== (he = t.gridCols) && void 0 !== he && he.sm ? t.gridCols.sm : 12,
            md: null !== (be = t.gridCols) && void 0 !== be && be.md ? t.gridCols.md : 12,
            lg: null !== (ye = t.gridCols) && void 0 !== ye && ye.lg ? t.gridCols.lg : 12,
            xl: null !== (xe = t.gridCols) && void 0 !== xe && xe.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(it, {
            className: "ondeff-text ".concat(t.className || ""),
            name: t.name,
            label: t.label,
            fullWidth: !0,
            placeholder: t.placeholder
          }));
        }
      } else ve = e.createElement(N, {
        key: t.name,
        item: !0,
        xs: null !== (de = t.gridCols) && void 0 !== de && de.xs ? t.gridCols.xs : 12,
        sm: null !== (ue = t.gridCols) && void 0 !== ue && ue.sm ? t.gridCols.sm : 12,
        md: null !== (me = t.gridCols) && void 0 !== me && me.md ? t.gridCols.md : 12,
        lg: null !== (pe = t.gridCols) && void 0 !== pe && pe.lg ? t.gridCols.lg : 12,
        xl: null !== (fe = t.gridCols) && void 0 !== fe && fe.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(it, {
        className: "ondeff-text ".concat(t.className || ""),
        name: t.name,
        label: t.label,
        fullWidth: !0,
        placeholder: t.placeholder
      }));

      return ve;
    }

    if ("select" === t.type) {
      var Ce,
          Ee,
          we,
          ke,
          Ne,
          Se,
          Ie,
          De = e.createElement(e.Fragment, null);

      if (null !== (Ce = t.preConditions) && void 0 !== Ce && Ce.name || null !== (Ee = t.preConditions) && void 0 !== Ee && Ee.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var Fe, Te, Pe, Le, Ae;
          De = e.createElement(N, {
            key: t.name,
            item: !0,
            xs: null !== (Fe = t.gridCols) && void 0 !== Fe && Fe.xs ? t.gridCols.xs : 12,
            sm: null !== (Te = t.gridCols) && void 0 !== Te && Te.sm ? t.gridCols.sm : 12,
            md: null !== (Pe = t.gridCols) && void 0 !== Pe && Pe.md ? t.gridCols.md : 12,
            lg: null !== (Le = t.gridCols) && void 0 !== Le && Le.lg ? t.gridCols.lg : 12,
            xl: null !== (Ae = t.gridCols) && void 0 !== Ae && Ae.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(dt, {
            className: t.className ? t.className : "ondeff-select",
            name: t.name,
            label: t.label,
            data: t.options,
            fullWidth: !0
          }));
        }
      } else De = e.createElement(N, {
        key: t.name,
        item: !0,
        xs: null !== (we = t.gridCols) && void 0 !== we && we.xs ? t.gridCols.xs : 12,
        sm: null !== (ke = t.gridCols) && void 0 !== ke && ke.sm ? t.gridCols.sm : 12,
        md: null !== (Ne = t.gridCols) && void 0 !== Ne && Ne.md ? t.gridCols.md : 12,
        lg: null !== (Se = t.gridCols) && void 0 !== Se && Se.lg ? t.gridCols.lg : 12,
        xl: null !== (Ie = t.gridCols) && void 0 !== Ie && Ie.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(dt, {
        className: t.className ? t.className : "ondeff-select",
        name: t.name,
        label: t.label,
        data: t.options,
        fullWidth: !0
      }));

      return De;
    }

    if ("options" === t.type) {
      var _e,
          Oe,
          Me,
          Be,
          ze,
          We,
          Re,
          Ve = e.createElement(e.Fragment, null);

      if (null !== (_e = t.preConditions) && void 0 !== _e && _e.name || null !== (Oe = t.preConditions) && void 0 !== Oe && Oe.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var je, He, Ue, qe, Ke;
          Ve = e.createElement(N, {
            key: t.name,
            item: !0,
            xs: null !== (je = t.gridCols) && void 0 !== je && je.xs ? t.gridCols.xs : 12,
            sm: null !== (He = t.gridCols) && void 0 !== He && He.sm ? t.gridCols.sm : 12,
            md: null !== (Ue = t.gridCols) && void 0 !== Ue && Ue.md ? t.gridCols.md : 12,
            lg: null !== (qe = t.gridCols) && void 0 !== qe && qe.lg ? t.gridCols.lg : 12,
            xl: null !== (Ke = t.gridCols) && void 0 !== Ke && Ke.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(Mt, {
            className: "ondeff-options",
            name: t.name,
            label: t.label,
            options: t.options,
            fullWidth: !0,
            onChangeValue: r,
            formValues: l
          }));
        }
      } else Ve = e.createElement(N, {
        key: t.name,
        item: !0,
        xs: null !== (Me = t.gridCols) && void 0 !== Me && Me.xs ? t.gridCols.xs : 12,
        sm: null !== (Be = t.gridCols) && void 0 !== Be && Be.sm ? t.gridCols.sm : 12,
        md: null !== (ze = t.gridCols) && void 0 !== ze && ze.md ? t.gridCols.md : 12,
        lg: null !== (We = t.gridCols) && void 0 !== We && We.lg ? t.gridCols.lg : 12,
        xl: null !== (Re = t.gridCols) && void 0 !== Re && Re.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(Mt, {
        className: "ondeff-options",
        name: t.name,
        label: t.label,
        options: t.options,
        fullWidth: !0,
        onChangeValue: r,
        formValues: l
      }));

      return Ve;
    }

    if ("radio" === t.type) {
      var Je,
          $e,
          Ye,
          Ge,
          Ze,
          Xe,
          Qe,
          et = e.createElement(e.Fragment, null);

      if (null !== (Je = t.preConditions) && void 0 !== Je && Je.name || null !== ($e = t.preConditions) && void 0 !== $e && $e.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var tt, at, nt, rt, lt;
          et = e.createElement(N, {
            key: t.name,
            item: !0,
            xs: null !== (tt = t.gridCols) && void 0 !== tt && tt.xs ? t.gridCols.xs : 12,
            sm: null !== (at = t.gridCols) && void 0 !== at && at.sm ? t.gridCols.sm : 12,
            md: null !== (nt = t.gridCols) && void 0 !== nt && nt.md ? t.gridCols.md : 12,
            lg: null !== (rt = t.gridCols) && void 0 !== rt && rt.lg ? t.gridCols.lg : 12,
            xl: null !== (lt = t.gridCols) && void 0 !== lt && lt.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(ht, {
            className: "ondeff-radios",
            name: t.name,
            label: t.label,
            data: t.options,
            fullWidth: !0
          }));
        }
      } else et = e.createElement(N, {
        key: t.name,
        item: !0,
        xs: null !== (Ye = t.gridCols) && void 0 !== Ye && Ye.xs ? t.gridCols.xs : 12,
        sm: null !== (Ge = t.gridCols) && void 0 !== Ge && Ge.sm ? t.gridCols.sm : 12,
        md: null !== (Ze = t.gridCols) && void 0 !== Ze && Ze.md ? t.gridCols.md : 12,
        lg: null !== (Xe = t.gridCols) && void 0 !== Xe && Xe.lg ? t.gridCols.lg : 12,
        xl: null !== (Qe = t.gridCols) && void 0 !== Qe && Qe.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(ht, {
        className: "ondeff-radios",
        name: t.name,
        label: t.label,
        data: t.options,
        fullWidth: !0
      }));

      return et;
    }

    if ("multi-select" === t.type) {
      var ot,
          ct,
          mt,
          ft,
          gt,
          bt,
          xt,
          Ct = e.createElement(e.Fragment, null),
          wt = u(t);

      if (null !== (ot = t.preConditions) && void 0 !== ot && ot.name || null !== (ct = t.preConditions) && void 0 !== ct && ct.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var kt, St, It, Dt, Pt;
          Ct = e.createElement(N, {
            key: t.name,
            item: !0,
            xs: null !== (kt = t.gridCols) && void 0 !== kt && kt.xs ? t.gridCols.xs : 12,
            sm: null !== (St = t.gridCols) && void 0 !== St && St.sm ? t.gridCols.sm : 12,
            md: null !== (It = t.gridCols) && void 0 !== It && It.md ? t.gridCols.md : 12,
            lg: null !== (Dt = t.gridCols) && void 0 !== Dt && Dt.lg ? t.gridCols.lg : 12,
            xl: null !== (Pt = t.gridCols) && void 0 !== Pt && Pt.xl ? t.gridCols.xl : 12,
            className: t.className
          }, wt && e.createElement(Ft, {
            className: "ondeff-radios",
            name: t.name,
            label: t.label,
            data: wt,
            fullWidth: !0
          }));
        }
      } else Ct = e.createElement(N, {
        key: t.name,
        item: !0,
        xs: null !== (mt = t.gridCols) && void 0 !== mt && mt.xs ? t.gridCols.xs : 12,
        sm: null !== (ft = t.gridCols) && void 0 !== ft && ft.sm ? t.gridCols.sm : 12,
        md: null !== (gt = t.gridCols) && void 0 !== gt && gt.md ? t.gridCols.md : 12,
        lg: null !== (bt = t.gridCols) && void 0 !== bt && bt.lg ? t.gridCols.lg : 12,
        xl: null !== (xt = t.gridCols) && void 0 !== xt && xt.xl ? t.gridCols.xl : 12,
        className: t.className
      }, wt && e.createElement(Ft, {
        className: "ondeff-radios",
        name: t.name,
        label: t.label,
        data: wt,
        fullWidth: !0
      }));

      return Ct;
    }

    if ("funcy-radio" === t.type) {
      var Lt,
          _t,
          Ot,
          Bt,
          zt,
          Wt,
          Rt,
          Vt = e.createElement(e.Fragment, null);

      if (null !== (Lt = t.preConditions) && void 0 !== Lt && Lt.name || null !== (_t = t.preConditions) && void 0 !== _t && _t.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var jt, Ht, Ut, qt, Kt;
          Vt = e.createElement(N, {
            key: t.name,
            item: !0,
            xs: null !== (jt = t.gridCols) && void 0 !== jt && jt.xs ? t.gridCols.xs : 12,
            sm: null !== (Ht = t.gridCols) && void 0 !== Ht && Ht.sm ? t.gridCols.sm : 12,
            md: null !== (Ut = t.gridCols) && void 0 !== Ut && Ut.md ? t.gridCols.md : 12,
            lg: null !== (qt = t.gridCols) && void 0 !== qt && qt.lg ? t.gridCols.lg : 12,
            xl: null !== (Kt = t.gridCols) && void 0 !== Kt && Kt.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(Tt, {
            data: t,
            fullWidth: !0,
            formValues: l
          }));
        }
      } else Vt = e.createElement(N, {
        key: t.name,
        item: !0,
        xs: null !== (Ot = t.gridCols) && void 0 !== Ot && Ot.xs ? t.gridCols.xs : 12,
        sm: null !== (Bt = t.gridCols) && void 0 !== Bt && Bt.sm ? t.gridCols.sm : 12,
        md: null !== (zt = t.gridCols) && void 0 !== zt && zt.md ? t.gridCols.md : 12,
        lg: null !== (Wt = t.gridCols) && void 0 !== Wt && Wt.lg ? t.gridCols.lg : 12,
        xl: null !== (Rt = t.gridCols) && void 0 !== Rt && Rt.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(Tt, {
        data: t,
        fullWidth: !0,
        formValues: l
      }));

      return Vt;
    }

    if ("checkbox" === t.type) {
      var Jt,
          $t,
          Yt,
          Gt,
          Zt,
          Xt,
          Qt,
          ea = e.createElement(e.Fragment, null);

      if (null !== (Jt = t.preConditions) && void 0 !== Jt && Jt.name || null !== ($t = t.preConditions) && void 0 !== $t && $t.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var ta, aa, na, ra, la;
          ea = e.createElement(N, {
            key: t.name,
            item: !0,
            xs: null !== (ta = t.gridCols) && void 0 !== ta && ta.xs ? t.gridCols.xs : 12,
            sm: null !== (aa = t.gridCols) && void 0 !== aa && aa.sm ? t.gridCols.sm : 12,
            md: null !== (na = t.gridCols) && void 0 !== na && na.md ? t.gridCols.md : 12,
            lg: null !== (ra = t.gridCols) && void 0 !== ra && ra.lg ? t.gridCols.lg : 12,
            xl: null !== (la = t.gridCols) && void 0 !== la && la.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(st, {
            className: "ondeff-checkbox",
            name: t.name,
            label: t.label
          }));
        }
      } else ea = e.createElement(N, {
        key: t.name,
        item: !0,
        xs: null !== (Yt = t.gridCols) && void 0 !== Yt && Yt.xs ? t.gridCols.xs : 12,
        sm: null !== (Gt = t.gridCols) && void 0 !== Gt && Gt.sm ? t.gridCols.sm : 12,
        md: null !== (Zt = t.gridCols) && void 0 !== Zt && Zt.md ? t.gridCols.md : 12,
        lg: null !== (Xt = t.gridCols) && void 0 !== Xt && Xt.lg ? t.gridCols.lg : 12,
        xl: null !== (Qt = t.gridCols) && void 0 !== Qt && Qt.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(st, {
        className: "ondeff-checkbox",
        name: t.name,
        label: t.label
      }));

      return ea;
    }

    if ("rating" === t.type) {
      var ia,
          oa,
          sa,
          ca,
          da,
          ua,
          ma,
          pa = e.createElement(e.Fragment, null);

      if (null !== (ia = t.preConditions) && void 0 !== ia && ia.name || null !== (oa = t.preConditions) && void 0 !== oa && oa.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var fa, va, ga, ha, ba;
          pa = e.createElement(N, {
            key: t.name,
            item: !0,
            xs: null !== (fa = t.gridCols) && void 0 !== fa && fa.xs ? t.gridCols.xs : 12,
            sm: null !== (va = t.gridCols) && void 0 !== va && va.sm ? t.gridCols.sm : 12,
            md: null !== (ga = t.gridCols) && void 0 !== ga && ga.md ? t.gridCols.md : 12,
            lg: null !== (ha = t.gridCols) && void 0 !== ha && ha.lg ? t.gridCols.lg : 12,
            xl: null !== (ba = t.gridCols) && void 0 !== ba && ba.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(yt, {
            className: "ondeff-rating",
            name: t.name + "rto",
            label: t.label,
            onChangeValue: r,
            formValues: l
          }));
        }
      } else pa = e.createElement(N, {
        key: t.name,
        item: !0,
        xs: null !== (sa = t.gridCols) && void 0 !== sa && sa.xs ? t.gridCols.xs : 12,
        sm: null !== (ca = t.gridCols) && void 0 !== ca && ca.sm ? t.gridCols.sm : 12,
        md: null !== (da = t.gridCols) && void 0 !== da && da.md ? t.gridCols.md : 12,
        lg: null !== (ua = t.gridCols) && void 0 !== ua && ua.lg ? t.gridCols.lg : 12,
        xl: null !== (ma = t.gridCols) && void 0 !== ma && ma.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(yt, {
        className: t.className ? t.className : "ondeff-rating",
        name: t.name + "rto",
        label: t.label,
        onChangeValue: r,
        formValues: l
      }));

      return pa;
    }

    if ("date" === t.type) {
      var ya,
          xa,
          Ca,
          Ea,
          wa,
          ka,
          Na,
          Sa = e.createElement(e.Fragment, null);

      if (null !== (ya = t.preConditions) && void 0 !== ya && ya.name || null !== (xa = t.preConditions) && void 0 !== xa && xa.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var Ia, Da, Fa, Ta, Pa;
          Sa = e.createElement(N, {
            key: t.name,
            item: !0,
            xs: null !== (Ia = t.gridCols) && void 0 !== Ia && Ia.xs ? t.gridCols.xs : 12,
            sm: null !== (Da = t.gridCols) && void 0 !== Da && Da.sm ? t.gridCols.sm : 12,
            md: null !== (Fa = t.gridCols) && void 0 !== Fa && Fa.md ? t.gridCols.md : 12,
            lg: null !== (Ta = t.gridCols) && void 0 !== Ta && Ta.lg ? t.gridCols.lg : 12,
            xl: null !== (Pa = t.gridCols) && void 0 !== Pa && Pa.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(ut, {
            key: "key.name_1",
            name: t.name,
            label: t.label,
            value: t.value,
            format: t.format,
            views: ["year", "month", "date"],
            minDate: d(t.minDate),
            maxDate: d(t.maxDate),
            disabledDates: t.disabledDates,
            fullWidth: !0,
            placeholder: t.placeholder,
            onChangeValue: r
          }));
        }
      } else Sa = e.createElement(N, {
        key: t.name,
        item: !0,
        xs: null !== (Ca = t.gridCols) && void 0 !== Ca && Ca.xs ? t.gridCols.xs : 12,
        sm: null !== (Ea = t.gridCols) && void 0 !== Ea && Ea.sm ? t.gridCols.sm : 12,
        md: null !== (wa = t.gridCols) && void 0 !== wa && wa.md ? t.gridCols.md : 12,
        lg: null !== (ka = t.gridCols) && void 0 !== ka && ka.lg ? t.gridCols.lg : 12,
        xl: null !== (Na = t.gridCols) && void 0 !== Na && Na.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(ut, {
        key: "key.name_1",
        name: t.name,
        label: t.label,
        value: t.value,
        format: t.format,
        views: ["year", "month", "date"],
        minDate: d(t.minDate),
        maxDate: d(t.maxDate),
        disabledDates: t.disabledDates,
        fullWidth: !0,
        placeholder: t.placeholder,
        onChangeValue: r
      }));

      return Sa;
    }

    if ("google-address" === t.type) {
      var La,
          Aa,
          _a,
          Oa,
          Ma,
          Ba,
          za,
          Wa = e.createElement(e.Fragment, null);

      if (null !== (La = t.preConditions) && void 0 !== La && La.name || null !== (Aa = t.preConditions) && void 0 !== Aa && Aa.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var Ra, Va, ja, Ha, Ua;
          Wa = e.createElement(N, {
            key: t.name,
            item: !0,
            xs: null !== (Ra = t.gridCols) && void 0 !== Ra && Ra.xs ? t.gridCols.xs : 12,
            sm: null !== (Va = t.gridCols) && void 0 !== Va && Va.sm ? t.gridCols.sm : 12,
            md: null !== (ja = t.gridCols) && void 0 !== ja && ja.md ? t.gridCols.md : 12,
            lg: null !== (Ha = t.gridCols) && void 0 !== Ha && Ha.lg ? t.gridCols.lg : 12,
            xl: null !== (Ua = t.gridCols) && void 0 !== Ua && Ua.xl ? t.gridCols.xl : 12,
            className: t.className
          }, i && e.createElement(Nt, {
            id: "ondeff-address",
            name: t.name,
            label: t.label,
            fieldName: t.name,
            placeholder: "enter an address",
            apiKey: i,
            resetError: function resetError() {},
            onResetField: function onResetField() {
              c("");
            },
            onChange: function onChange(e) {
              c(JSON.stringify(e));
            },
            onChangeValue: r,
            formValues: l,
            fullWidth: !0,
            showSearchIcon: !0
          }));
        }
      } else Wa = e.createElement(N, {
        key: t.name,
        item: !0,
        xs: null !== (_a = t.gridCols) && void 0 !== _a && _a.xs ? t.gridCols.xs : 12,
        sm: null !== (Oa = t.gridCols) && void 0 !== Oa && Oa.sm ? t.gridCols.sm : 12,
        md: null !== (Ma = t.gridCols) && void 0 !== Ma && Ma.md ? t.gridCols.md : 12,
        lg: null !== (Ba = t.gridCols) && void 0 !== Ba && Ba.lg ? t.gridCols.lg : 12,
        xl: null !== (za = t.gridCols) && void 0 !== za && za.xl ? t.gridCols.xl : 12,
        className: t.className
      }, i && e.createElement(Nt, {
        id: "ondeff-address",
        name: t.name,
        label: t.label,
        fieldName: t.name,
        placeholder: t.placeholder,
        apiKey: i,
        resetError: function resetError() {},
        onResetField: function onResetField() {
          c("");
        },
        onChange: function onChange(e) {
          c(JSON.stringify(e));
        },
        onChangeValue: s,
        formValues: l,
        fullWidth: !0
      }));

      return Wa;
    }

    if ("fancy-checkbox" === t.type || "radio-custom" === t.type) {
      var qa,
          Ka,
          Ja,
          $a,
          Ya,
          Ga,
          Za,
          Xa = e.createElement(e.Fragment, null);

      if (null !== (qa = t.preConditions) && void 0 !== qa && qa.name || null !== (Ka = t.preConditions) && void 0 !== Ka && Ka.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var Qa, en, tn, an, nn;
          Xa = e.createElement(N, {
            key: t.name,
            item: !0,
            xs: null !== (Qa = t.gridCols) && void 0 !== Qa && Qa.xs ? t.gridCols.xs : 12,
            sm: null !== (en = t.gridCols) && void 0 !== en && en.sm ? t.gridCols.sm : 12,
            md: null !== (tn = t.gridCols) && void 0 !== tn && tn.md ? t.gridCols.md : 12,
            lg: null !== (an = t.gridCols) && void 0 !== an && an.lg ? t.gridCols.lg : 12,
            xl: null !== (nn = t.gridCols) && void 0 !== nn && nn.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(At, {
            type: t.type,
            name: t.name,
            label: t.label,
            options: t.options,
            formValues: l,
            onChangeValue: r
          }));
        }
      } else Xa = e.createElement(N, {
        key: t.name,
        item: !0,
        xs: null !== (Ja = t.gridCols) && void 0 !== Ja && Ja.xs ? t.gridCols.xs : 12,
        sm: null !== ($a = t.gridCols) && void 0 !== $a && $a.sm ? t.gridCols.sm : 12,
        md: null !== (Ya = t.gridCols) && void 0 !== Ya && Ya.md ? t.gridCols.md : 12,
        lg: null !== (Ga = t.gridCols) && void 0 !== Ga && Ga.lg ? t.gridCols.lg : 12,
        xl: null !== (Za = t.gridCols) && void 0 !== Za && Za.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(At, {
        type: t.type,
        name: t.name,
        label: t.label,
        options: t.options,
        formValues: l,
        onChangeValue: r
      }));

      return Xa;
    }
  })));
}

function Wt(e, t, a, n) {
  function r(e, t) {
    return "notRequired" === e.validationType ? t = t.notRequired() : "defined" === e.validationType ? t = t.defined() : "required" === e.validationType ? t = t.required(e.message) : "typeError" === e.validationType ? t = t.typeError(e.message) : "nullable" === e.validationType ? t = t.nullable(1 === e.value) : "oneOf" === e.validationType && (t = t.nullable(e.value, e.message)), t;
  }

  e.map(function (e) {
    if (e.name && e.validations && (null == e.preConditions || null == e.preConditions.value) || e.name && e.validations && e.preConditions && null != n && e.preConditions.value == n[e.preConditions.name]) {
      var a = ne.string();

      switch (e.yupType) {
        case "string":
          e.validations.map(function (e) {
            a = r(e, a), "min" === e.validationType ? a = a.min(e.value, e.message) : "max" === e.validationType ? a = a.max(e.value, e.message) : "email" === e.validationType ? a = a.email(e.message) : "url" === e.validationType ? a = a.url(e.value, e.message) : "matches" === e.validationType && (a = a.matches(new RegExp(e.regex), {
              message: e.message,
              excludeEmptyString: !0
            }));
          });
          break;

        case "number":
          a = ne.number(), e.validations.map(function (e) {
            a = r(e, a), "positive" === e.validationType ? a = a.positive(e.message) : "negative" === e.validationType ? a = a.negative(e.message) : "integer" === e.validationType ? a = a.integer(e.message) : "min" === e.validationType ? a = a.min(e.value, e.message) : "max" === e.validationType && (a = a.max(e.value, e.message));
          });
          break;

        case "boolean":
          a = ne.boolean(), e.validations.map(function (e) {
            a = r(e, a);
          });
          break;

        case "date":
          a = ne.date(), e.validations.map(function (e) {
            a = r(e, a), "min" === e.validationType ? a = a.min(Date.parse(e.value), e.message) : "max" === e.validationType && (a = a.max(Date.parse(e.value), e.message));
          });
          break;

        case "array":
          a = ne.array(), e.validations.map(function (e) {
            a = r(e, a), "min" === e.validationType ? a = a.min(e.value, e.message) : "max" === e.validationType && (a = a.max(e.value, e.message));
          });
      }

      t[e.ondeffStepsCode][e.name] = a;
    }
  });
  var l = 0;
  return Object.keys(t).map(function (e) {
    a[l] = ne.object().shape(t[e]), l++;
  }), a;
}

var Rt,
    Vt = ie(function (e) {
  return {
    stepper: {
      padding: e.spacing(3, 0, 5)
    },
    buttons: {
      display: "flex",
      justifyContent: "flex-end"
    },
    button: {
      marginTop: e.spacing(3),
      marginLeft: e.spacing(1)
    },
    wrapper: {
      margin: e.spacing(1),
      position: "relative",
      marginRight: "0px"
    },
    buttonProgress: {
      position: "absolute",
      top: "50%",
      left: "50%"
    },
    centeredBtn: {
      display: "flex",
      justifyContent: "center"
    }
  };
}),
    jt = [],
    Ht = {},
    Ut = [],
    qt = {
  watchQuery: {
    fetchPolicy: "no-cache",
    errorPolicy: "ignore"
  },
  query: {
    fetchPolicy: "no-cache",
    errorPolicy: "all"
  }
},
    Kt = r(function (n, r) {
  var i = n.apikeycaptcha,
      o = n.requireCaptcha,
      c = n.showStepper,
      m = n.showSuccessfulMessageAfterSubmit,
      p = n.handleAfterSubmit,
      f = n.handleAfterErrorOnSubmit,
      v = n.apolloUrl,
      g = n.googlePlaceAutocompleteApiKey,
      h = n.initialData,
      b = n.onSubmitFunction,
      y = tt(t({}), 2),
      x = y[0],
      C = y[1],
      E = Vt(),
      w = tt(t(null), 2),
      P = w[0],
      L = w[1],
      A = tt(t(0), 2),
      _ = A[0],
      O = A[1],
      M = tt(t(0), 2),
      B = M[0],
      z = M[1],
      W = tt(t(), 2),
      R = W[0],
      V = W[1],
      j = _ === jt.length - 1,
      H = tt(t(null), 2);
  H[0];
  var U = H[1],
      q = tt(t(null), 2),
      K = q[0],
      J = q[1],
      $ = tt(t(null), 2),
      Y = $[0],
      G = $[1],
      Z = tt(t(o), 2),
      X = Z[0],
      Q = Z[1],
      ee = tt(t(i), 2),
      ne = ee[0],
      re = ee[1],
      le = tt(t(g), 2),
      ie = le[0],
      ue = le[1],
      me = tt(t(), 2),
      pe = me[0],
      fe = me[1],
      ve = {
    "Ocp-Apim-Subscription-Key": "30ca1663de42420bb4a9894d1898e91e"
  },
      ge = new oe({
    link: new se({
      uri: v,
      headers: ve
    }),
    cache: new ce(),
    defaultOptions: qt
  });

  function he() {
    return (he = Ge(Je().mark(function e(t, a) {
      var n, r, l, i, o;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (a.setSubmitting(!1), e.prev = 1, b(), n = JSON.stringify(t, null, 2), !Ht.ondeff.action) {
                e.next = 12;
                break;
              }

              return l = {}, (null === (r = Ht.ondeff.headers) || void 0 === r ? void 0 : r.length) > 0 && Ht.ondeff.headers.forEach(function (e) {
                l[e.key] = e.value;
              }), i = {
                headers: l
              }, e.next = 10, ae.post(Ht.ondeff.action, n, i).then(function (e) {
                var t,
                    a,
                    r = null === (t = Ht.ondeff) || void 0 === t ? void 0 : t.succesMessage;
                if (null != e && null !== (a = e.data) && void 0 !== a && a.availabilityRequestId) if (e.data.availablePros > 0) {
                  var l;
                  r = null === (l = Ht.ondeff) || void 0 === l ? void 0 : l.succesMessage.replace("<a class='availability-submit'", "<a href='/book?av=".concat(e.data.availabilityRequestId, "' class='availability-submit'"));
                } else {
                  r = "<p class='submitMessageGA' style=\"font-size: 1.7rem;line-height: 2rem;\">We're sorry. We were unable to match your request to any service pros.  We are not able to help with your request.</p>";
                  var i = JSON.parse(n);
                  i = Ke(Ke({}, i), {}, {
                    isPoolProviderEmpty: !0
                  }), n = JSON.stringify(i, null, 2);
                }
                V(r), m && O(_ + 1), p(n);
              }).catch(function (e) {
                var t = Ht.ondeff.failMessage.find(function (t) {
                  return +t.code === e.response.status;
                });
                if (t) V(t.message);else {
                  var a = Ht.ondeff.failMessage.find(function (e) {
                    return "default" === e.code;
                  });
                  V(a.message);
                }
                m && O(_ + 1), f();
              });

            case 10:
              e.next = 13;
              break;

            case 12:
              p(n);

            case 13:
              e.next = 22;
              break;

            case 15:
              e.prev = 15, e.t0 = e.catch(1), console.log(e.t0), o = Ht.ondeff.failMessage.find(function (e) {
                return "default" === e.code;
              }), V(o.message), m && O(_ + 1), f();

            case 22:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[1, 15]]);
    }))).apply(this, arguments);
  }

  var be = function be(e) {
    L(e);
  },
      ye = {
    ondeffCode: n.formCode
  };

  0 === B && null != n.formCode && ge.query({
    query: de(Rt || (Rt = et(["query Query($ondeffCode: String) {\n        ondeffDefinition(ondeffCode: $ondeffCode) {\n          ondeff {\n            code\n            name\n            succesMessage\n            failMessage {\n              code\n              message\n            }\n            action\n            nextLabel\n            previousLabel\n            headers {\n              key\n              value\n            }\n            requireCaptcha\n            apikeycaptcha\n            googlePlaceAutocompleteApiKey\n          }\n          steps {\n            code\n            name\n            ondeffCode\n            previousLabel\n            nextLabel\n            bottomMessage\n            weight\n          }\n          fields {\n            type\n            name\n            label\n            value\n            format\n            minDate\n            maxDate\n            disabledDates\n            options {\n              value\n              label\n              image\n              message\n              options {\n                value\n                label\n              }\n            }\n            preConditions {\n              value\n              name\n            }\n            validations {\n              validationType\n              value\n              message\n              regex\n            }\n            gridCols {\n                xs\n                sm\n                md\n                lg\n                xl\n            }\n            className\n            ondeffCode\n            ondeffStepsCode\n            weight\n            yupType\n            placeholder\n          }\n        }\n      }"]))),
    variables: ye
  }).then(function (e) {
    z(1);
    var t = e.data.ondeffDefinition.steps.sort(function (e, t) {
      return e.weight - t.weight;
    }),
        a = e.data.ondeffDefinition.fields.sort(function (e, t) {
      return e.weight - t.weight;
    }),
        r = 0,
        l = {};
    Ht = e.data.ondeffDefinition, jt = [], Ut = [], t.map(function (e) {
      e.stepNumber = r, jt.push(e.name), r++, l[e.code] = {};
    }), Ut = Wt(a, l, Ut, n.values);
    var s = Ke({}, n.values);
    h && h.map(function (e) {
      s[e.key] = e.value;
    });
    var c = Ke(Ke({}, function (e) {
      var t = {};
      return null != e && e.map(function (e) {
        e.name && e.value && "paragraph" !== e.type && (t[e.name] = e.value);
      }), t;
    }(Ht.fields)), s);
    Q(!1 === o || !0 === o ? o : e.data.ondeffDefinition.ondeff.requireCaptcha), re(i || e.data.ondeffDefinition.ondeff.apikeycaptcha), ue(g || e.data.ondeffDefinition.ondeff.googlePlaceAutocompleteApiKey), C(c), U(t), J(a), G(l);
  }), a(function () {
    U(null), J(null), G(null), z(0);
  }, [n.formCode]);

  var xe = function xe() {
    var e = s().values;
    return a(function () {
      K && Y && e && (Object.keys(Y).map(function (e) {
        Y[e] = [];
      }), Ut = Wt(K, Y, [], e));
    }, [e]), null;
  };

  l(r, function () {
    return {
      getCurrentValues: function getCurrentValues() {
        return pe;
      }
    };
  });
  var Ce = n.formTitle ? n.formTitle : Ht.ondeff && Ht.ondeff.name,
      Ee = Ht.steps && Ht.steps,
      we = _ === jt.length ? "" : Ee && _ && null !== Ee[_].nextLabel && void 0 !== Ee[_].nextLabel ? Ee[_].nextLabel : Ht.ondeff && null !== Ht.ondeff.nextLabel && void 0 !== Ht.ondeff.nextLabel ? Ht.ondeff.nextLabel : j ? "Submit" : _ === jt.length ? "" : "Next",
      ke = _ === jt.length ? "" : Ee && null !== Ee[_].previousLabel ? Ee[_].previousLabel : Ht.ondeff && null !== Ht.ondeff.previousLabel ? Ht.ondeff.previousLabel : _ === jt.length ? "" : "Previous";
  return 1 === B && null != n.formCode ? e.createElement("div", {
    className: "ondeff-form"
  }, e.createElement(e.Fragment, null, e.createElement(k, {
    component: "h1",
    variant: "h4",
    align: "center"
  }, Ce), c && _ !== jt.length && e.createElement(S, {
    activeStep: _,
    className: E.stepper
  }, jt.map(function (t) {
    return e.createElement(I, {
      key: t
    }, e.createElement(D, null, t));
  })), e.createElement(e.Fragment, null, _ === jt.length && R ? e.createElement(e.Fragment, null, e.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: R
    }
  })) : e.createElement(d, {
    initialValues: x,
    validationSchema: Ut[_],
    onSubmit: function onSubmit(e, t) {
      var a = Ke(Ke({}, e), x);
      console.log(a), fe(a), j ? !1 === X || X && null !== P ? function (e, t) {
        he.apply(this, arguments);
      }(a, t) : (t.setTouched({}), t.setSubmitting(!1)) : (O(_ + 1), t.setTouched({}), t.setSubmitting(!1), t.resetForm({
        values: a
      }));
    }
  }, function (t) {
    var a;
    return e.createElement(u, {
      id: Ht.ondeff && "form-".concat(Ht.ondeff.code)
    }, function (t, a, n) {
      if (Ht.steps) {
        var r,
            l = Ht.steps.filter(function (e) {
          return e.stepNumber === t;
        });
        return r = Ht.fields.filter(function (e) {
          return e.ondeffStepsCode === l[0].code;
        }), e.createElement(zt, {
          key: "ondeff-step-" + l,
          formField: r,
          handleChangeFields: a,
          formValues: n,
          googleApiKey: ie
        });
      }
    }(_, t.setFieldValue, t.values), e.createElement(xe, null), j && X && e.createElement(N, {
      key: "captcha-ondeff"
    }, e.createElement("div", {
      key: "captcha-ondeff-1"
    }, e.createElement("span", null, "Verification *"), e.createElement(te, {
      key: "captcha-ondeff-cpt",
      sitekey: ne,
      onChange: be
    }))), e.createElement("div", {
      className: "ondeff-actions-wrapper ".concat(E.buttons, " ").concat(j && "last-step-buttons")
    }, 0 !== _ && e.createElement(F, {
      onClick: function onClick() {
        return e = t.values, a = t, n = Ke(Ke({}, e), x), O(_ - 1), void a.resetForm({
          values: n
        });
        var e, a, n;
      },
      className: E.button
    }, ke && ke), e.createElement("div", {
      className: E.wrapper
    }, e.createElement(F, {
      disabled: t.isSubmitting,
      type: "submit",
      variant: "contained",
      color: "primary",
      className: E.button
    }, we && we), t.isSubmitting && e.createElement(T, {
      size: 24,
      className: E.buttonProgress
    }))), (null === (a = Ht) || void 0 === a || null === (a = a.steps) || void 0 === a || null === (a = a.find(function (e) {
      return e.stepNumber === _;
    })) || void 0 === a ? void 0 : a.bottomMessage) && e.createElement(N, {
      key: (1e4 * Math.random()).toFixed(0),
      item: !0,
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12
    }, e.createElement("div", {
      className: "ondeff-paragraph",
      dangerouslySetInnerHTML: {
        __html: Ht.steps.find(function (e) {
          return e.stepNumber === _;
        }).bottomMessage
      }
    })));
  })))) : e.createElement(e.Fragment, null);
});

function Jt(t) {
  var a = t.price ? t.price : "_____";
  return e.createElement(e.Fragment, null, e.createElement("div", {
    className: "priceContainer"
  }, e.createElement("span", {
    className: t.placeId ? "priceTextFirst" : "priceTextFirst priceTextGrey"
  }, "$"), e.createElement("span", {
    className: t.placeId ? "priceTextSecond" : "priceTextSecond priceTextGrey"
  }, a), t.price && !t.placeId && e.createElement("span", {
    className: "priceRef",
    onClick: function onClick(e) {
      e.stopPropagation(), t.handleGoBack && t.handleGoBack(), setTimeout(function () {
        var e = document.getElementById("online-booking-address");
        e && (window.scrollTo(0, 0), e.focus());
      }, 0);
    }
  }, "Add address for price")));
}

var $t = {
  weight: "M6.99992 0.800781C7.70716 0.800781 8.38544 1.08173 8.88554 1.58183C9.38563 2.08193 9.66659 2.7602 9.66659 3.46745C9.66659 3.95411 9.53992 4.40745 9.30659 4.80078H10.9999C11.6333 4.80078 12.1666 5.24745 12.2999 5.84078C13.6399 11.1808 13.6666 11.3208 13.6666 11.4674C13.6666 11.8211 13.5261 12.1602 13.2761 12.4103C13.026 12.6603 12.6869 12.8008 12.3333 12.8008H1.66659C1.31296 12.8008 0.973825 12.6603 0.723776 12.4103C0.473728 12.1602 0.333252 11.8211 0.333252 11.4674C0.333252 11.3208 0.359919 11.1808 1.69992 5.84078C1.83325 5.24745 2.36659 4.80078 2.99992 4.80078H4.69325C4.45992 4.40745 4.33325 3.95411 4.33325 3.46745C4.33325 2.7602 4.6142 2.08193 5.1143 1.58183C5.6144 1.08173 6.29268 0.800781 6.99992 0.800781ZM6.99992 2.13411C6.6463 2.13411 6.30716 2.27459 6.05711 2.52464C5.80706 2.77469 5.66659 3.11383 5.66659 3.46745C5.66659 3.82107 5.80706 4.16021 6.05711 4.41026C6.30716 4.66031 6.6463 4.80078 6.99992 4.80078C7.35354 4.80078 7.69268 4.66031 7.94273 4.41026C8.19278 4.16021 8.33325 3.82107 8.33325 3.46745C8.33325 3.11383 8.19278 2.77469 7.94273 2.52464C7.69268 2.27459 7.35354 2.13411 6.99992 2.13411Z",
  days: "M10.6563 12.1445V4.80078L1.34375 4.80078L1.34375 12.1445L10.6563 12.1445ZM10.6562 1.45703C11.0104 1.45703 11.3229 1.59245 11.5938 1.86328C11.8646 2.13411 12 2.44661 12 2.80078L12 12.1445C12 12.4987 11.8646 12.8112 11.5938 13.082C11.3229 13.332 11.0104 13.457 10.6563 13.457L1.34375 13.457C0.96875 13.457 0.645833 13.332 0.375 13.082C0.125 12.832 0 12.5195 0 12.1445L0 2.80078C0 2.44661 0.125 2.13411 0.375 1.86328C0.645833 1.59245 0.96875 1.45703 1.34375 1.45703H2V0.144531L3.34375 0.144531V1.45703L8.65625 1.45703V0.144531L10 0.144531V1.45703L10.6562 1.45703ZM9.34375 6.14453V7.45703H8V6.14453H9.34375ZM6.65625 6.14453V7.45703H5.34375L5.34375 6.14453L6.65625 6.14453ZM4 6.14453L4 7.45703L2.65625 7.45703L2.65625 6.14453H4Z"
};

function Yt(t) {
  var a = t.detail,
      n = t.detail.text1.split(". <br>");
  return a.text2 = n[1], a.text3 = n[0], e.createElement(e.Fragment, null, e.createElement("div", {
    className: "detailContainer"
  }, e.createElement(ge, {
    sx: {
      color: "#546E7A",
      verticalAlign: "top"
    },
    className: "detailIcon"
  }, e.createElement("path", {
    d: 0 === (null == a ? void 0 : a.id) ? $t.weight : $t.days
  })), e.createElement("span", {
    className: "detailText"
  }, a.text3, 0 === (null == a ? void 0 : a.id) && e.createElement(P, {
    className: "tooltip",
    enterDelay: 300,
    leaveDelay: 200,
    enterTouchDelay: 10,
    leaveTouchDelay: 3500,
    disableTouchListener: !1,
    title: "1 ton = 2000 lbs. Waste facilities weigh your debris and charge by the ton. The customer is responsible for any debris weight over and above the included weight."
  }, e.createElement(he, {
    className: "tooltip-icon",
    color: "action"
  })), e.createElement("br", null), a.text2)));
}

var Gt = function Gt(t) {
  var a = t.reviews,
      n = t.calculated,
      r = function r() {
    for (var t = [], a = !1, r = 1; r <= 5; r++) {
      var l = {
        width: "0%"
      };
      if (!a) if (r <= n) l.width = "100%";else {
        var i = 100 * (n - Math.floor(n));
        l.width = i + "%", a = !0;
      }
      t.push(e.createElement("div", {
        key: r,
        className: "starbg-profile"
      }, e.createElement("div", {
        style: l,
        className: "star-profile on"
      })));
    }

    return t;
  },
      l = function l() {
    return e.createElement("div", {
      className: "rating"
    }, e.createElement("div", {
      className: "number"
    }, n), e.createElement("div", {
      className: "stars"
    }, e.createElement(r, null)), a && e.createElement("div", {
      className: "reviews"
    }, e.createElement("p", {
      onClick: i
    }, "(", e.createElement("span", null, "".concat(t.reviews).concat(t.hidePhrase ? "" : t.reviews > 1 ? " reviews" : " review")), ")")));
  },
      i = function i() {
    if (!t.hideCallToAction) if (t.url) window.location.href = t.url;else {
      var e = document.getElementsByName("reviews");
      window.scrollTo({
        top: e[0].offsetTop - 150,
        behavior: "smooth"
      });
    }
  };

  return e.createElement(l, null);
};

function Zt(t) {
  var a,
      n,
      r,
      l,
      i,
      o,
      s,
      c,
      d,
      u,
      m = t.service,
      p = t.callbackFunction,
      f = t.imageStaticEnv,
      v = t.finalData,
      g = t.placeId,
      h = t.profileData ? t.profileData : null === (a = t.listOfPublishedPros) || void 0 === a ? void 0 : a.find(function (e) {
    return +e._attributes_id == +m.proId;
  }),
      b = function b() {
    var e = [].concat(at(v), [{
      key: "service",
      value: m
    }, {
      key: "profileData",
      value: h
    }, {
      key: "dumpsterSize",
      value: t.selectedDumpsterSize
    }]);
    t.customerData && e.push(t.customerData), p(e);
  };

  return e.createElement(e.Fragment, null, e.createElement("div", {
    "data-testid": "service",
    className: "cardContainer"
  }, e.createElement(L, {
    className: "card"
  }, e.createElement(me, {
    onClick: function onClick() {
      return t.handleServiceClick(m);
    },
    className: "cardPointer"
  }, m.availableDates && m.availableDates.length > 0 && m.showBanner && e.createElement("div", {
    className: "service-card-header green-header"
  }, e.createElement(fe, {
    sx: {
      mb: 1
    },
    style: {
      fontSize: "18px",
      marginBottom: "0px",
      color: "#FFFFFF"
    },
    color: "text.secondary"
  }, "Available for delivery ", e.createElement("br", null), " ", m.availableDates.map(function (e) {
    return new Date(e);
  }).sort(function (e, t) {
    return e - t;
  }).map(function (e) {
    var t = new Intl.DateTimeFormat("en-US", {
      weekday: "short",
      timeZone: "UTC"
    }).format(e),
        a = new Intl.DateTimeFormat("en-US", {
      month: "numeric",
      day: "numeric",
      timeZone: "UTC"
    }).format(e);
    return "".concat(t, " ").concat(a);
  }).join(", "))), e.createElement("div", {
    className: "imageContainer"
  }, e.createElement("img", {
    className: "service-image",
    src: f + ((null === (n = m.images) || void 0 === n ? void 0 : n.length) > 0 ? m.images[0] : m.image),
    alt: m.title,
    loading: "lazy"
  })), e.createElement("div", {
    className: "cardPadding"
  }, e.createElement("div", {
    className: "title"
  }, m.title), e.createElement("div", {
    className: "subtitle"
  }, (c = "", d = null !== (o = m.details[0]) && void 0 !== o && o.text3 ? m.details[0].text3 : m.details[0].text1.split(". <br>")[0], u = null !== (s = m.details[1]) && void 0 !== s && s.text3 ? m.details[1].text3 : m.details[1].text1.split(". <br>")[0], d && u && (c = "Includes ".concat(u.replace(" included", ""), " and ").concat(d.replace("included", ""), " of waste, by ").concat(null == h ? void 0 : h.n)), c)), (null == h ? void 0 : h.r) > 0 && e.createElement("div", {
    className: "card-reviews"
  }, e.createElement(Gt, {
    reviews: h.r,
    calculated: h.rt && parseFloat(h.rt).toFixed(1).toString(),
    hideCallToAction: !0,
    hidePhrase: !0
  })), e.createElement(Jt, {
    price: m.price,
    placeId: g
  }), e.createElement("div", {
    className: "subtitleContainer"
  }, e.createElement(ve, {
    className: "iconColor"
  }), e.createElement("div", {
    className: "dimension-container"
  }, e.createElement("span", {
    className: "detailText"
  }, m.subtitle), e.createElement("span", {
    className: "detailText"
  }, (r = m.title, (i = null === (l = r.match(/\d+/)) || void 0 === l ? void 0 : l[0]) ? "Holds ".concat(6 * i, " trash bags") : "")))), m.details.map(function (t) {
    var a,
        n = Ke(Ke({}, a = t), {}, {
      text1: null == a ? void 0 : a.text1.replace("additional", "extra")
    });
    return e.createElement(Yt, {
      key: t.id,
      detail: n
    });
  }))), e.createElement(ue, {
    className: (null == h ? void 0 : h.r) > 0 ? "buttonContainer" : "buttonContainer marginButtonContainer"
  }, !1 === m.allowBookingOnline ? (null == h ? void 0 : h.ph) && e.createElement(pe, {
    variant: "contained",
    className: "phoneButton"
  }, e.createElement("a", {
    className: "phone-text pro-phone-cont",
    "data-proid": m.proId,
    href: "tel://" + h.ph
  }, e.createElement("span", null, "Call ", Bt(h.ph)))) : m.price ? e.createElement(pe, {
    disabled: !g,
    onClick: b,
    variant: "contained",
    className: "bookButton"
  }, "Book now") : e.createElement(pe, {
    onClick: b,
    variant: "contained",
    className: "availabilityButton"
  }, "Get pricing & availability")))));
}

function Xt(a) {
  var n = a.cards,
      r = void 0 === n ? [] : n,
      l = a.finalData,
      i = a.onCardActionClick,
      o = void 0 === i ? function () {} : i,
      s = a.onSeeMoreClick,
      c = void 0 === s ? function () {} : s,
      d = a.showSeeMoreButton,
      u = void 0 !== d && d,
      m = a.imageStaticEnv;
  a.isLoadingServices;

  var p = a.placeId,
      f = a.profileData,
      v = a.listOfPublishedPros,
      g = a.selectedDumpsterSize,
      h = a.customerData,
      b = tt(t(!1), 2),
      y = b[0],
      x = b[1],
      C = function () {
    var e = Ge(Je().mark(function e() {
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, x(!0), e.next = 4, c();

            case 4:
              e.next = 9;
              break;

            case 6:
              throw e.prev = 6, e.t0 = e.catch(0), e.t0;

            case 9:
              return e.prev = 9, x(!1), e.finish(9);

            case 12:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 6, 9, 12]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }();

  return e.createElement(e.Fragment, null, e.createElement(N, {
    container: !0,
    direction: "row"
  }, r.map(function (t, n) {
    return e.createElement(e.Fragment, {
      key: "card-".concat(t.title, "-").concat(n)
    }, e.createElement(N, {
      xs: 12,
      sm: 12,
      md: 4,
      lg: 4,
      xl: 4,
      className: "gridContainer"
    }, e.createElement(Zt, {
      finalData: l,
      service: t,
      callbackFunction: o,
      imageStaticEnv: m,
      placeId: p,
      handleServiceClick: a.handleServiceClick,
      profileData: f,
      listOfPublishedPros: v,
      selectedDumpsterSize: g,
      customerData: h
    })));
  })), u && e.createElement(e.Fragment, null, e.createElement("br", null), e.createElement(N, {
    container: !0,
    direction: "row",
    justifyContent: "center",
    alignItems: "center"
  }, e.createElement(F, {
    className: "seeMoreButton",
    variant: "contained",
    disabled: y,
    onClick: C
  }, y ? e.createElement(T, {
    size: 24,
    className: "white-loader"
  }) : "See More"))));
}

Xt.propTypes = {
  cards: U.array.isRequired,
  onCardActionClick: U.func,
  onSeeMoreClick: U.func,
  showSeeMoreButton: U.bool,
  imageStaticEnv: U.string.isRequired
};
var Qt = ae.create();
Qt.defaults.headers.common["Ocp-Apim-Subscription-Key"] = "30ca1663de42420bb4a9894d1898e91e";

var ea,
    ta,
    aa = function aa(e, t, a) {
  var n = arguments;
  return Ge(Je().mark(function r() {
    var l, i, o, s;
    return Je().wrap(function (r) {
      for (;;) {
        switch (r.prev = r.next) {
          case 0:
            return l = n.length > 3 && void 0 !== n[3] ? n[3] : "", (i = {})["Ocp-Apim-Subscription-Key"] = "30ca1663de42420bb4a9894d1898e91e", r.prev = 3, o = l ? "/".concat(l) : "", r.next = 7, Qt.get("".concat(e, "/place-by-zip-and-name/").concat(t, "/").concat(a).concat(o), {
              headers: i
            });

          case 7:
            return s = r.sent, r.abrupt("return", s);

          case 11:
            throw r.prev = 11, r.t0 = r.catch(3), r.t0;

          case 14:
          case "end":
            return r.stop();
        }
      }
    }, r, null, [[3, 11]]);
  }))();
},
    na = {
  watchQuery: {
    fetchPolicy: "no-cache",
    errorPolicy: "ignore"
  },
  query: {
    fetchPolicy: "no-cache",
    errorPolicy: "all"
  }
},
    ra = {
  "Ocp-Apim-Subscription-Key": "30ca1663de42420bb4a9894d1898e91e"
},
    la = function la(e) {
  return new oe({
    link: new se({
      uri: e,
      headers: ra
    }),
    cache: new ce(),
    ssrMode: !0,
    defaultOptions: na
  });
},
    ia = function ia(e) {
  return e.filter(function (e) {
    return e.active && e.currentValue;
  }).reduce(function (e, t) {
    return e[t.id] = t.currentValue, e;
  }, {});
},
    oa = {
  name: "servicesAPI",
  get: function get(e) {
    var t = arguments;
    return Ge(Je().mark(function a() {
      var n, r, l, i, o, s, c;
      return Je().wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return n = t.length > 1 && void 0 !== t[1] ? t[1] : 0, r = t.length > 2 && void 0 !== t[2] ? t[2] : 1e4, l = t.length > 3 ? t[3] : void 0, i = t.length > 4 ? t[4] : void 0, o = la(e), s = ia(l), a.prev = 6, a.next = 9, o.query({
                query: de(ea || (ea = et(["\n          query HtServices($idBaseService: String!, $wasteType: [Int], $dumpsterType: Int, $dumpsterSize: String, $proId: Int, $placesId: [Int], $skip: Int, $limit: Int, $event: event){\n            htServices(idBaseService: $idBaseService, wasteType: $wasteType, dumpsterType: $dumpsterType, dumpsterSize: $dumpsterSize, proId: $proId, placesId: $placesId, skip: $skip, limit: $limit, event: $event) {\n              nodes {\n                _id\n                idBaseService\n                price\n                proId\n                description\n                areaId\n                dumpsterId\n                placesId {\n                  placeId\n                  distanceFee\n                }\n                dimensions\n                wasteType\n                dumpsterSize\n                dumpsterType\n                details {\n                  details\n                }\n                image\n                images\n                suggestedPros {\n                  _attributes_id\n                  n\n                  ur\n                }\n              }\n              pageInfo {\n                currentPage\n                hasNextPage\n                perPage\n                totalCount\n                hasPreviousPage\n                pageCount\n                itemCount\n              }\n            }\n          }\n        "]))),
                variables: Ke(Ke({}, i), {}, {
                  skip: n,
                  limit: r
                }, s)
              });

            case 9:
              return c = a.sent, a.abrupt("return", {
                data: {
                  data: c.data.htServices.nodes,
                  pageInfo: c.data.htServices.pageInfo
                }
              });

            case 13:
              throw a.prev = 13, a.t0 = a.catch(6), a.t0;

            case 16:
            case "end":
              return a.stop();
          }
        }
      }, a, null, [[6, 13]]);
    }))();
  },
  getServicePrice: function getServicePrice(e, t) {
    return Ge(Je().mark(function a() {
      var n;
      return Je().wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.prev = 0, a.next = 3, Qt.post("".concat(e, "/service-price"), t);

            case 3:
              return n = a.sent, a.abrupt("return", n);

            case 7:
              throw a.prev = 7, a.t0 = a.catch(0), a.t0;

            case 10:
            case "end":
              return a.stop();
          }
        }
      }, a, null, [[0, 7]]);
    }))();
  },
  getServiceById: function getServiceById(e, t, a) {
    return Ge(Je().mark(function n() {
      var r;
      return Je().wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, n.next = 3, Qt.get("".concat(e, "/pros/").concat(t, "/services/").concat(a));

            case 3:
              return r = n.sent, n.abrupt("return", r);

            case 7:
              throw n.prev = 7, n.t0 = n.catch(0), n.t0;

            case 10:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 7]]);
    }))();
  },
  getServiceByIdWithEvent: function getServiceByIdWithEvent(e, t, a, n) {
    return Ge(Je().mark(function r() {
      var l;
      return Je().wrap(function (r) {
        for (;;) {
          switch (r.prev = r.next) {
            case 0:
              return r.prev = 0, r.next = 3, Qt.post("".concat(e, "/pros/").concat(t, "/services/").concat(a), n);

            case 3:
              return l = r.sent, r.abrupt("return", l);

            case 7:
              throw r.prev = 7, r.t0 = r.catch(0), r.t0;

            case 10:
            case "end":
              return r.stop();
          }
        }
      }, r, null, [[0, 7]]);
    }))();
  },
  getProAreaSegment: function getProAreaSegment(e, t) {
    return Ge(Je().mark(function a() {
      var n;
      return Je().wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.prev = 0, a.next = 3, Qt.get("".concat(e, "/pros/").concat(t, "/default-area-segments"));

            case 3:
              return n = a.sent, a.abrupt("return", n);

            case 7:
              throw a.prev = 7, a.t0 = a.catch(0), a.t0;

            case 10:
            case "end":
              return a.stop();
          }
        }
      }, a, null, [[0, 7]]);
    }))();
  },
  generateShortUrl: function generateShortUrl(e, t, a) {
    return Ge(Je().mark(function n() {
      var r;
      return Je().wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, n.next = 3, Qt.post("".concat(e, "/generate-short-url"), a, {
                headers: {
                  "X-Gatsby-Header": t
                }
              });

            case 3:
              return r = n.sent, n.abrupt("return", r);

            case 7:
              throw n.prev = 7, n.t0 = n.catch(0), n.t0;

            case 10:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 7]]);
    }))();
  },
  getShortUrl: function getShortUrl(e, t, a) {
    return Ge(Je().mark(function n() {
      var r;
      return Je().wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, n.next = 3, Qt.get("".concat(e, "/short-url/").concat(a), {
                headers: {
                  "X-Gatsby-Header": t
                }
              });

            case 3:
              return r = n.sent, n.abrupt("return", r);

            case 7:
              throw n.prev = 7, n.t0 = n.catch(0), n.t0;

            case 10:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 7]]);
    }))();
  }
},
    sa = function sa(e, t, a) {
  return Ge(Je().mark(function n() {
    var r, l;
    return Je().wrap(function (n) {
      for (;;) {
        switch (n.prev = n.next) {
          case 0:
            return n.prev = 0, r = la(e), n.next = 4, r.query({
              query: de(ta || (ta = et(["\n          query HtAvailableFiltersPerPro($idBaseService: String, $proId: Int) {\n            htAvailableFiltersPerPro(idBaseService: $idBaseService, proId: $proId) {\n              filter {\n                _id\n                name\n                supportedValues {\n                  id\n                  value\n                  parentFilter\n                  parentValue\n                  code\n                }\n                type\n                exposed\n                defaultValue\n                label\n                weight\n                active\n              }\n            }\n          }\n        "]))),
              variables: {
                idBaseService: t,
                proId: a
              }
            });

          case 4:
            return l = n.sent, n.abrupt("return", {
              data: {
                data: l.data.htAvailableFiltersPerPro.filter
              }
            });

          case 8:
            throw n.prev = 8, n.t0 = n.catch(0), n.t0;

          case 11:
          case "end":
            return n.stop();
        }
      }
    }, n, null, [[0, 8]]);
  }))();
},
    ca = {
  name: "stripeAPI",
  createPaymentIntent: function createPaymentIntent(e, t, a, n, r, l) {
    return Ge(Je().mark(function i() {
      var o;
      return Je().wrap(function (i) {
        for (;;) {
          switch (i.prev = i.next) {
            case 0:
              return i.prev = 0, i.next = 3, Qt.post("".concat(e, "/create-payment"), {
                serviceId: t,
                proId: a,
                startDate: n,
                endDate: r,
                placeId: l
              });

            case 3:
              return o = i.sent, i.abrupt("return", o);

            case 7:
              throw i.prev = 7, i.t0 = i.catch(0), i.t0;

            case 10:
            case "end":
              return i.stop();
          }
        }
      }, i, null, [[0, 7]]);
    }))();
  },
  addPaymentMethodToPaymentIntent: function addPaymentMethodToPaymentIntent(e, t, a) {
    return Ge(Je().mark(function n() {
      var r;
      return Je().wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, n.next = 3, Qt.post("".concat(e, "/add-payment-method"), {
                methodId: t,
                intentId: a
              });

            case 3:
              return r = n.sent, n.abrupt("return", r);

            case 7:
              throw n.prev = 7, n.t0 = n.catch(0), n.t0;

            case 10:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 7]]);
    }))();
  },
  attachPaymentMethodToCustomer: function attachPaymentMethodToCustomer(e, t, a) {
    return Ge(Je().mark(function n() {
      var r;
      return Je().wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, n.next = 3, Qt.post("".concat(e, "/attach-payment-method"), {
                methodId: t,
                customerId: a
              });

            case 3:
              return r = n.sent, n.abrupt("return", r);

            case 7:
              throw n.prev = 7, n.t0 = n.catch(0), n.t0;

            case 10:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 7]]);
    }))();
  },
  addFullCheckout: function addFullCheckout(e, t) {
    return Ge(Je().mark(function a() {
      var n;
      return Je().wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.prev = 0, a.next = 3, Qt.post("".concat(e, "/full-checkout"), t);

            case 3:
              return n = a.sent, a.abrupt("return", n);

            case 7:
              throw a.prev = 7, a.t0 = a.catch(0), a.t0;

            case 10:
            case "end":
              return a.stop();
          }
        }
      }, a, null, [[0, 7]]);
    }))();
  },
  completeCheckout: function completeCheckout(e, t) {
    return Ge(Je().mark(function a() {
      var n;
      return Je().wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.prev = 0, a.next = 3, Qt.post("".concat(e, "/confirmed-payment-checkout"), t);

            case 3:
              return n = a.sent, a.abrupt("return", n);

            case 7:
              throw a.prev = 7, a.t0 = a.catch(0), a.t0;

            case 10:
            case "end":
              return a.stop();
          }
        }
      }, a, null, [[0, 7]]);
    }))();
  },
  deleteCard: function deleteCard(e, t) {
    return Ge(Je().mark(function a() {
      var n;
      return Je().wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.prev = 0, a.next = 3, Qt.post("".concat(e, "/dettach-payment-method"), t);

            case 3:
              return n = a.sent, a.abrupt("return", n);

            case 7:
              throw a.prev = 7, a.t0 = a.catch(0), a.t0;

            case 10:
            case "end":
              return a.stop();
          }
        }
      }, a, null, [[0, 7]]);
    }))();
  }
},
    da = {
  name: "customersAPI",
  addCustomer: function addCustomer(e, t, a) {
    return Ge(Je().mark(function n() {
      var r, l, i, o, s;
      return Je().wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return r = a.customerEmail, l = a.customerName, i = a.customerSurname, o = a.customerPhone, n.prev = 1, n.next = 4, Qt.post("".concat(e, "/add-customer"), {
                intentId: t,
                customerEmail: r,
                customerName: l,
                customerSurname: i,
                customerPhone: o
              });

            case 4:
              return s = n.sent, n.abrupt("return", s);

            case 8:
              throw n.prev = 8, n.t0 = n.catch(1), n.t0;

            case 11:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[1, 8]]);
    }))();
  },
  getCustomerList: function getCustomerList(e, t) {
    return Ge(Je().mark(function a() {
      var n;
      return Je().wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.prev = 0, a.next = 3, Qt.post("".concat(e, "/list-customer-pms"), {
                customerId: t
              });

            case 3:
              return n = a.sent, a.abrupt("return", n);

            case 7:
              throw a.prev = 7, a.t0 = a.catch(0), a.t0;

            case 10:
            case "end":
              return a.stop();
          }
        }
      }, a, null, [[0, 7]]);
    }))();
  },
  checkCustomer: function checkCustomer(e, t) {
    return Ge(Je().mark(function a() {
      var n;
      return Je().wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.prev = 0, a.next = 3, Qt.post("".concat(e, "/check-customer"), {
                customerPhone: t
              });

            case 3:
              return n = a.sent, a.abrupt("return", n);

            case 7:
              throw a.prev = 7, a.t0 = a.catch(0), a.t0;

            case 10:
            case "end":
              return a.stop();
          }
        }
      }, a, null, [[0, 7]]);
    }))();
  },
  generateCode: function generateCode(e, t) {
    return Ge(Je().mark(function a() {
      var n;
      return Je().wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.prev = 0, a.next = 3, Qt.post("".concat(e, "/generate-code-customer"), t);

            case 3:
              return n = a.sent, a.abrupt("return", n);

            case 7:
              throw a.prev = 7, a.t0 = a.catch(0), a.t0;

            case 10:
            case "end":
              return a.stop();
          }
        }
      }, a, null, [[0, 7]]);
    }))();
  },
  validateCode: function validateCode(e, t) {
    return Ge(Je().mark(function a() {
      var n;
      return Je().wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.prev = 0, a.next = 3, Qt.post("".concat(e, "/validate-code-customer"), t);

            case 3:
              return n = a.sent, a.abrupt("return", n);

            case 7:
              throw a.prev = 7, a.t0 = a.catch(0), a.t0;

            case 10:
            case "end":
              return a.stop();
          }
        }
      }, a, null, [[0, 7]]);
    }))();
  }
},
    ua = {
  name: "bookingRequestsAPI",
  getBookingById: function getBookingById(e, t) {
    return Ge(Je().mark(function a() {
      var n;
      return Je().wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.prev = 0, a.next = 3, Qt.get("".concat(e, "/job-request/").concat(t));

            case 3:
              return n = a.sent, a.abrupt("return", n);

            case 7:
              throw a.prev = 7, a.t0 = a.catch(0), a.t0;

            case 10:
            case "end":
              return a.stop();
          }
        }
      }, a, null, [[0, 7]]);
    }))();
  },
  getWasteTreatmentByPro: function getWasteTreatmentByPro(e, t, a) {
    return Ge(Je().mark(function n() {
      var r;
      return Je().wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, n.next = 3, Qt.get("".concat(e, "/pros/").concat(a, "/waste-treatment"), {
                headers: {
                  "X-Gatsby-Header": t
                }
              });

            case 3:
              return r = n.sent, n.abrupt("return", r);

            case 7:
              throw n.prev = 7, n.t0 = n.catch(0), n.t0;

            case 10:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 7]]);
    }))();
  }
},
    ma = {
  name: "dumpsterAPI",
  getSizes: function getSizes(e) {
    return Ge(Je().mark(function t() {
      var a;
      return Je().wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.prev = 0, t.next = 3, Qt.get("".concat(e, "/dumpster-sizes"));

            case 3:
              return a = t.sent, t.abrupt("return", a);

            case 7:
              throw t.prev = 7, t.t0 = t.catch(0), t.t0;

            case 10:
            case "end":
              return t.stop();
          }
        }
      }, t, null, [[0, 7]]);
    }))();
  },
  getTypes: function getTypes(e) {
    return Ge(Je().mark(function t() {
      var a;
      return Je().wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.prev = 0, t.next = 3, Qt.get("".concat(e, "/dumpster-types"));

            case 3:
              return a = t.sent, t.abrupt("return", a);

            case 7:
              throw t.prev = 7, t.t0 = t.catch(0), t.t0;

            case 10:
            case "end":
              return t.stop();
          }
        }
      }, t, null, [[0, 7]]);
    }))();
  },
  getWasteTypes: function getWasteTypes(e) {
    return Ge(Je().mark(function t() {
      var a;
      return Je().wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.prev = 0, t.next = 3, Qt.get("".concat(e, "/waste-types"));

            case 3:
              return a = t.sent, t.abrupt("return", a);

            case 7:
              throw t.prev = 7, t.t0 = t.catch(0), t.t0;

            case 10:
            case "end":
              return t.stop();
          }
        }
      }, t, null, [[0, 7]]);
    }))();
  }
},
    pa = {
  name: "prosAPI",
  getDumpsterPublishedPros: function getDumpsterPublishedPros(e, t, a) {
    return Ge(Je().mark(function n() {
      var r, l;
      return Je().wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, r = "", a && (r = "?proId=".concat(a)), n.next = 5, Qt.get("".concat(e, "/get-list-of-published-pros").concat(r), {
                headers: {
                  "X-Gatsby-Header": t
                }
              });

            case 5:
              return l = n.sent, n.abrupt("return", l);

            case 9:
              throw n.prev = 9, n.t0 = n.catch(0), n.t0;

            case 12:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 9]]);
    }))();
  }
},
    fa = function fa(e, t) {
  return Ge(Je().mark(function a() {
    var n;
    return Je().wrap(function (a) {
      for (;;) {
        switch (a.prev = a.next) {
          case 0:
            return a.prev = 0, a.next = 3, Qt.get("".concat(e, "/availability-request/").concat(t));

          case 3:
            return n = a.sent, a.abrupt("return", n);

          case 7:
            throw a.prev = 7, a.t0 = a.catch(0), a.t0;

          case 10:
          case "end":
            return a.stop();
        }
      }
    }, a, null, [[0, 7]]);
  }))();
},
    va = function va(e, t, a) {
  return Ge(Je().mark(function n() {
    var r;
    return Je().wrap(function (n) {
      for (;;) {
        switch (n.prev = n.next) {
          case 0:
            return n.prev = 0, n.next = 3, Qt.get("".concat(e, "/availability-request-response/").concat(t), {
              headers: {
                "X-Gatsby-Header": a
              }
            });

          case 3:
            return r = n.sent, n.abrupt("return", r);

          case 7:
            throw n.prev = 7, n.t0 = n.catch(0), n.t0;

          case 10:
          case "end":
            return n.stop();
        }
      }
    }, n, null, [[0, 7]]);
  }))();
};

function ga(a) {
  var n,
      r = a.filters,
      l = void 0 === r ? [] : r,
      i = a.onChange,
      o = void 0 === i ? function () {} : i,
      s = a.googlePlaceAutocompleteApiKey,
      c = a.onResetServices,
      d = void 0 === c ? function () {} : c,
      u = tt(t(""), 2),
      m = u[0];
  u[1];

  var p = function p(e, t, a) {
    var n;
    o(null === (n = e.target) || void 0 === n ? void 0 : n.value, t, a);
  },
      f = null == l || null === (n = l.filter(function (e) {
    return e.exposed;
  })) || void 0 === n ? void 0 : n.length;

  return e.createElement(e.Fragment, null, e.createElement(q, {
    container: !0,
    justifyContent: "flex-start",
    alignItems: "center",
    className: "ss-filters-wrapper",
    spacing: 2
  }, l.filter(function (e) {
    return e.exposed;
  }).map(function (t, a) {
    return e.createElement(e.Fragment, {
      key: "filter-".concat(a)
    }, "googleAddress" === t.type ? e.createElement(q, {
      xs: 12,
      sm: 12,
      md: 2 === f ? 6 : 4,
      lg: 2 === f ? 6 : 4,
      xl: 2 === f ? 6 : 4
    }, e.createElement("div", {
      "data-testid": "filter-input",
      className: "inputContainer marginBottom"
    }, e.createElement(Nt, {
      id: "online-booking-address",
      apiKey: s,
      defaultValue: t.currentValue,
      name: t.name,
      label: t.label,
      className: "fill-available",
      fieldName: "c",
      placeholder: "Enter an address",
      resetError: function resetError() {},
      onResetField: function onResetField() {
        return d();
      },
      onChange: function onChange(e) {
        p(e, a, JSON.stringify(e));
      },
      onChangeValue: m,
      formValues: [],
      size: "small",
      fullWidth: !0,
      showSearchIcon: !0
    }))) : "select" === t.type ? e.createElement(q, {
      xs: 12,
      sm: 12,
      md: 2,
      lg: 2,
      xl: 2
    }, e.createElement("div", {
      className: "inputContainer marginBottom"
    }, e.createElement(Ce, {
      variant: "outlined",
      size: "small",
      className: "filterInput"
    }, e.createElement(xe, {
      htmlFor: "outlined-age-native-simple"
    }, t.label), e.createElement(be, {
      value: t.currentValue,
      onChange: function onChange(e) {
        p(e, a);
      },
      labelId: "demo-simple-select-outlined-label",
      id: "demo-simple-select-outlined",
      label: t.label,
      inputProps: {
        "data-testid": "filter-input"
      }
    }, e.createElement(ye, {
      value: "",
      disabled: !0
    }, e.createElement("em", null, "None")), t.options.map(function (t) {
      return e.createElement(ye, {
        key: "option-".concat(t.value),
        value: t.value
      }, e.createElement("em", null, t.label));
    }))))) : e.createElement(q, {
      xs: 12,
      sm: 12,
      md: 4,
      lg: 4,
      xl: 4
    }, e.createElement("div", {
      className: "inputContainer marginBottom"
    }, e.createElement(Z, {
      onChange: function onChange(e) {
        p(e, a);
      },
      id: t.id,
      className: "form-online-control-date",
      value: t.currentValue,
      label: t.label,
      type: "date",
      variant: "outlined",
      size: "small",
      inputProps: {
        "data-testid": "filter-input",
        placeholder: "when",
        min: new Date().toISOString().split("T")[0]
      },
      InputLabelProps: {
        shrink: !0
      }
    }))));
  })));
}

ga.propTypes = {
  filters: U.array.isRequired,
  onChange: U.func,
  googlePlaceAutocompleteApiKey: U.string.isRequired
};

var ha = function ha(n) {
  var r,
      l,
      i,
      o = n.proId,
      s = n.apolloURL,
      c = n.gatsbyKey,
      d = n.service,
      u = n.services,
      m = n.placeId,
      p = n.changeService,
      f = n.currentWasteType,
      v = n.changeTemplate,
      g = n.imageStaticEnv,
      h = n.profileData,
      b = n.callBy,
      y = tt(t(!1), 2),
      x = y[0],
      C = y[1],
      E = tt(t([]), 2),
      w = E[0],
      k = E[1],
      S = tt(t(), 2),
      I = S[0],
      D = S[1],
      P = tt(t({
    first: !1,
    second: !1,
    third: !1,
    fourth: !1
  }), 2),
      L = P[0],
      _ = P[1];
  a(function () {
    Ge(Je().mark(function e() {
      var t;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, C(!0), e.next = 4, ua.getWasteTreatmentByPro(s, c, o);

            case 4:
              t = e.sent, D(null == t ? void 0 : t.data), d && O(), e.next = 12;
              break;

            case 9:
              e.prev = 9, e.t0 = e.catch(0), n.setShowFailureMessage(!0);

            case 12:
              return e.prev = 12, C(!1), e.finish(12);

            case 15:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 9, 12, 15]]);
    }))();
  }, []), a(function () {
    d && O();
  }, [d]);

  var O = function O() {
    var e,
        t = [];
    null == d || null === (e = d.images) || void 0 === e || e.forEach(function (e, a) {
      t.push({
        original: g + e,
        thumbnail: g + e,
        thumbnailWidth: "80px",
        thumbnailHeight: "80px",
        thumbnailAlt: d.title + a,
        thumbnailLoading: "lazy",
        loading: "lazy"
      });
    }), 0 === (null == t ? void 0 : t.length) && t.push({
      original: g + d.image,
      thumbnail: g + d.image,
      thumbnailWidth: "80px",
      thumbnailHeight: "80px",
      thumbnailAlt: d.title,
      thumbnailLoading: "lazy",
      loading: "lazy"
    }), k(t);
  },
      M = function M(e, t) {
    var a,
        n,
        r = "",
        l = null === (a = e.details[0]) || void 0 === a ? void 0 : a.text1.split(". <br>")[0],
        i = null === (n = e.details[1]) || void 0 === n ? void 0 : n.text1.split(". <br>")[0];
    return l && i && (r = "primary" === t ? "Includes ".concat(i.replace(" included", ""), " and ").concat(l.replace("included", ""), " of waste, by ").concat(null == h ? void 0 : h.n) : "".concat(i.replace("(s) included", ""), " / ").concat(l.replace("included", ""))), r;
  },
      B = function B() {
    v("book" === b ? "multiple-card-list" : "card-list");
  };

  return e.createElement(e.Fragment, null, e.createElement(N, {
    container: !0,
    direction: "column",
    justifyContent: "flex-start"
  }, x ? e.createElement(T, {
    size: 24
  }) : d && e.createElement("div", {
    className: "full-width"
  }, e.createElement("div", {
    className: "back-container",
    onClick: B
  }, e.createElement(A, null, e.createElement(Ee, {
    className: "back-button"
  })), e.createElement("span", {
    className: "back-label"
  }, "Back")), e.createElement("div", {
    className: "service-global-container"
  }, e.createElement("div", {
    className: "service-container"
  }, e.createElement("div", {
    className: "info"
  }, e.createElement("div", {
    className: "title"
  }, d.title), e.createElement("div", {
    className: "subtitle"
  }, M(d, "primary")), (null == h ? void 0 : h.r) > 0 && e.createElement("div", null, e.createElement(Gt, {
    reviews: h.r,
    calculated: h.rt && parseFloat(h.rt).toFixed(1).toString(),
    hideCallToAction: !0,
    hidePhrase: !0
  }))), (null == w ? void 0 : w.length) > 0 && e.createElement("div", {
    className: "service-images"
  }, e.createElement(we, {
    items: w,
    lazyLoad: !0,
    showNav: !1,
    showFullscreenButton: !1,
    showPlayButton: !1
  }))), e.createElement("div", {
    className: "services-container"
  }, e.createElement(Jt, {
    price: d.price,
    placeId: m,
    handleGoBack: B
  }), e.createElement("div", {
    className: "options-container"
  }, null == u ? void 0 : u.map(function (t) {
    var a, n;
    return e.createElement("div", {
      key: t.id,
      className: (null == t ? void 0 : t.id) === (null == d ? void 0 : d.id) ? "option-box selected" : "option-box"
    }, e.createElement("p", {
      className: (null == t ? void 0 : t.id) === (null == d ? void 0 : d.id) ? "option-text text-selected" : "option-text",
      onClick: function onClick() {
        return p(t.id);
      }
    }, null === (a = t.title) || void 0 === a ? void 0 : a.replace("Dumpster", ""), " - ", null === (n = M(t)) || void 0 === n ? void 0 : n.replace(" /", ",")));
  })), e.createElement("div", null, d.details.map(function (t) {
    return e.createElement(Yt, {
      key: t.id,
      detail: (a = t, Ke(Ke({}, a), {}, {
        text1: null == a ? void 0 : a.text1.replace("additional", "extra")
      }))
    });
    var a;
  })), e.createElement("div", null, !1 === d.allowBookingOnline ? e.createElement(F, {
    variant: "contained",
    className: "phoneButton"
  }, e.createElement("a", {
    className: "phone-text pro-phone-cont",
    "data-proid": d.proId,
    href: "tel://" + h.ph
  }, e.createElement("span", null, "Call ", Bt(h.ph)))) : d.price ? e.createElement(F, {
    id: "book-btn",
    disabled: !m,
    onClick: n.onClickBook,
    variant: "contained",
    className: "book-button"
  }, "Book now") : e.createElement(F, {
    id: "availability-btn",
    onClick: n.onClickBook,
    variant: "contained",
    className: "availability-button"
  }, "Get pricing & availability"))), e.createElement("div", {
    className: "overview-container"
  }, e.createElement("div", {
    className: "block-container"
  }, e.createElement("div", {
    className: "block-container"
  }, e.createElement("span", {
    className: "title"
  }, "Dumpster Service Made Simple"), e.createElement("p", {
    className: "detail-text"
  }, "Hometown Dumpster Rental has helped millions of homeowners and contractors find and book a dumpster service since 2008. Hometown provides transparent pricing and simplified booking for hundreds of locally-owned and operated dumpster services."), e.createElement("ol", {
    className: "block-container"
  }, e.createElement("li", {
    className: "list"
  }, e.createElement("span", {
    className: "second-title"
  }, "Book your dumpster online"), e.createElement("span", {
    className: "detail-text margin"
  }, "Your service provider will accept your order and confirm your delivery date.")), e.createElement("li", {
    className: "list"
  }, e.createElement("span", {
    className: "second-title"
  }, "Dumpster is delivered to you"), e.createElement("span", {
    className: "detail-text margin"
  }, "In your booking, you’ll describe where you want the dumpster placed.  Be sure there is free and clear access to that spot on delivery day.")), e.createElement("li", {
    className: "list"
  }, e.createElement("span", {
    className: "second-title"
  }, "Load the dumpster"), e.createElement("span", {
    className: "detail-text margin"
  }, "Open the door for easy loading.  Load bulky items first.  Be careful not to load above the rim of the dumpster.  Items sticking out the top of the dumpster can’t be transported safely.")), e.createElement("li", {
    className: "list"
  }, e.createElement("span", {
    className: "second-title"
  }, "Dumpster is hauled away"), e.createElement("span", {
    className: "detail-text margin"
  }, "If you need the dumpster picked up sooner or later than ordered, just call your service provider. On pickup day, be sure the driver has free and clear access to the dumpster.")))), e.createElement("div", {
    className: "block-container"
  }, e.createElement("div", {
    className: "block-container"
  }, e.createElement("span", {
    className: "second-title"
  }, "Book Local for Better Prices"), e.createElement("p", {
    className: "detail-text"
  }, "Hometown’s locally-owned dumpster services have better prices compared to big, nation-wide waste management companies. The larger companies typically have a high cost structure that gets passed on to the customer. Booking directly with local haulers on Hometown is usually $100 - $200 less expensive than the larger alternatives."), e.createElement("p", {
    className: "detail-text"
  }, "Hometown service pros also have better prices than large dumpster brokers. Customers are often unaware that brokers are middle-men and not the actual service provider. Some are not transparent and claim to offer discount or budget service. In reality, brokers often add on $100 or more to a local company's dumpster before selling it as their own.")), e.createElement("div", {
    className: "block-container"
  }, e.createElement("span", {
    className: "second-title"
  }, "Personal Service from Owner-Operators"), e.createElement("p", {
    className: "detail-text"
  }, "Hometown's owner-operators live in your community and have a strong interest in making sure customers are satisfied. They are empowered to solve your issue. That streamlined support minimizes your hassle compared to brokers or nationwide waste companies that send your support request to a help desk thousands of miles away."))))), e.createElement("div", {
    className: "waste-container"
  }, (null == I || null === (r = I.wasteInstructions) || void 0 === r ? void 0 : r.length) > 0 && (null == I ? void 0 : I.wasteInstructions.find(function (e) {
    return f && +e.id == +f;
  })) && e.createElement("div", null, e.createElement("span", {
    className: "title"
  }, "Waste Handling Instructions"), null == I ? void 0 : I.wasteInstructions.map(function (t) {
    return +t.id == +f && e.createElement("div", {
      key: t.id,
      className: "waste-content"
    }, e.createElement("span", {
      className: "subtitle-detail"
    }, t.name), e.createElement("span", {
      className: "instruction"
    }, t.instructions));
  })), e.createElement("div", {
    className: "block-container"
  }, e.createElement("span", {
    className: "title"
  }, "Frequently Asked Questions"), e.createElement("div", {
    className: "block-container"
  }, e.createElement("div", {
    className: "drop",
    onClick: function onClick() {
      return _(Ke(Ke({}, L), {}, {
        first: !L.first
      }));
    }
  }, e.createElement("span", null, "How long can I have the dumpster for?"), e.createElement(ke, null)), L.first && e.createElement("p", {
    className: "detail-text"
  }, "Each dumpster lists the number of days included with the price, plus the cost of additional time. Book the dumpster for the number of days you need.  If you need to extend the pickup date after the dumpster has been delivered, call your service provider directly to request the change.  Additional time above the included days will be charged at the rate quoted on the dumpster.")), e.createElement("div", {
    className: "block-container"
  }, e.createElement("div", {
    className: "drop",
    onClick: function onClick() {
      return _(Ke(Ke({}, L), {}, {
        second: !L.second
      }));
    }
  }, e.createElement("span", null, "How does included weight work?"), e.createElement(ke, null)), L.second && e.createElement("div", {
    className: "block-container"
  }, e.createElement("p", {
    className: "detail-text"
  }, "Each dumpster lists the amount of weight (in tons) included for the price. The waste inside your dumpster is weighed by the facility receiving the waste. If your waste weighs in at or under the included weight, there is no additional charge for weight. If your debris weighs more than the included weight, your service provider will pass on the cost of the overage weight to you at the quoted cost per ton."))), e.createElement("div", {
    className: "block-container"
  }, e.createElement("div", {
    className: "drop",
    onClick: function onClick() {
      return _(Ke(Ke({}, L), {}, {
        third: !L.third
      }));
    }
  }, e.createElement("span", null, "How much is one ton?"), e.createElement(ke, null)), L.third && e.createElement("div", {
    className: "block-container"
  }, e.createElement("p", {
    className: "detail-text"
  }, "1 ton is 2000lbs. Here are some examples of debris that weigh about 1 ton."), e.createElement("ul", {
    className: "detail-text block-container ton-list"
  }, e.createElement("li", null, "1000 square feet of asphalt shingles"), e.createElement("li", null, "20 cubic yards of cardboard, paper"), e.createElement("li", null, "20 cubic yards of loose trash"), e.createElement("li", null, "7 cubic yards of densely packed trash"), e.createElement("li", null, "1 cubic yard of concrete"), e.createElement("li", null, "1.5 cubic yards of asphalt"), e.createElement("li", null, ".5 cubic yards of gypsum, drywall"), e.createElement("li", null, "5 cubic yards of loose wood scrap")))), (null == I || null === (l = I.disallowedWaste) || void 0 === l ? void 0 : l.length) > 0 && e.createElement("div", {
    className: "block-container",
    style: {
      gap: "5px"
    }
  }, e.createElement("div", {
    className: "drop",
    onClick: function onClick() {
      return _(Ke(Ke({}, L), {}, {
        fourth: !L.fourth
      }));
    }
  }, e.createElement("span", null, "What items are not allowed in the dumpster?"), e.createElement(ke, null)), L.fourth && (null == I || null === (i = I.disallowedWaste) || void 0 === i ? void 0 : i.map(function (t) {
    return e.createElement("div", {
      key: t.id
    }, e.createElement("span", {
      className: "excluded-text"
    }, t.name));
  })))))))));
},
    ba = function ba(t) {
  var a = t.tabs,
      n = t.selectedTab,
      r = t.handleChangeCustomTab;
  return e.createElement("div", {
    className: "tab-container"
  }, a.map(function (t) {
    return e.createElement(e.Fragment, {
      key: "tab-".concat(t.label)
    }, e.createElement("div", {
      key: "tab-".concat(t.label),
      className: n === t.value ? "custom-tab active-custom-tab" : "custom-tab",
      onClick: function onClick() {
        r(t);
      }
    }, e.createElement("p", {
      className: n === t.value ? "custom-tab-label active-label" : "custom-tab-label"
    }, t.label)));
  }));
},
    ya = {
  select: "select",
  textfield: "textfield",
  date: "date",
  googleAddress: "googleAddress"
},
    xa = [{
  value: "small",
  label: "~ 10 yard"
}, {
  value: "medium",
  label: "~ 20 yard"
}, {
  value: "large",
  label: "~ 30 yard"
}];

function Ca(n) {
  var r,
      l = n.zipcode,
      i = n.proId,
      o = n.baseServiceId,
      s = n.initialValues,
      c = void 0 === s ? [] : s,
      d = n.googlePlaceAutocompleteApiKey,
      u = n.placesApiUrl,
      m = n.servicesApiUrl,
      p = n.imageStaticEnv,
      f = n.serviceCardCallback,
      v = n.defaultTemplateName,
      g = n.apolloURL,
      h = n.gatsbyKey,
      b = n.defaultService,
      y = n.profileData,
      x = n.callBy,
      C = n.defaultDumpsterSize,
      E = n.limitPerPage,
      w = n.setIsVisible,
      S = E || 21,
      I = tt(t(n.defaultServices ? at(n.defaultServices) : []), 2),
      D = I[0],
      P = I[1],
      L = tt(t(), 2),
      O = L[0],
      M = L[1],
      B = tt(t(), 2),
      z = B[0],
      W = B[1],
      R = tt(t(0), 2),
      V = R[0],
      j = R[1],
      H = tt(t({}), 2),
      U = H[0],
      q = H[1],
      K = tt(t(!n.defaultServices), 2),
      J = K[0],
      $ = K[1],
      Y = tt(t(!n.defaultFilters), 2),
      G = Y[0],
      Z = Y[1],
      X = tt(t(n.defaultFilters ? at(n.defaultFilters) : []), 2),
      Q = X[0],
      ee = X[1],
      te = tt(t(!1), 2),
      ae = te[0],
      ne = te[1],
      re = tt(t([]), 2),
      le = re[0],
      ie = re[1],
      oe = tt(t([]), 2),
      se = oe[0],
      ce = oe[1],
      de = tt(t(n.defaultFilters), 2),
      ue = de[0],
      me = de[1],
      pe = tt(t(n.defaultServices), 2),
      fe = pe[0],
      ve = pe[1],
      ge = tt(t(""), 2),
      he = ge[0],
      be = ge[1],
      ye = tt(t(), 2),
      xe = ye[0],
      Ce = ye[1],
      we = tt(t(b), 2),
      ke = we[0],
      Ne = we[1],
      Se = tt(t(v || "card-list"), 2),
      Ie = Se[0],
      De = Se[1],
      Fe = tt(t("undefined" != typeof window && localStorage.getItem("sessionId")), 2),
      Te = Fe[0],
      Pe = Fe[1],
      Le = tt(t(!0), 2),
      Ae = Le[0],
      _e = Le[1],
      Oe = tt(t(C || "small"), 2),
      Me = Oe[0],
      Be = Oe[1],
      ze = tt(t([]), 2),
      We = ze[0],
      Re = ze[1],
      Ve = tt(t(!1), 2),
      je = Ve[0],
      He = Ve[1],
      Ue = function Ue(e) {
    var t = e.find(function (e) {
      return "fullFormData" === e.key;
    }).value,
        a = Object.keys(t).map(function (e) {
      return [e, t[e]];
    }),
        n = [];
    return a.forEach(function (e) {
      if (e[0].includes("odf_")) {
        var t = e[0].replace("odf_", ""),
            a = e[1];
        n.push([t, a]);
      }
    }), e.find(function (e) {
      return "fullFormData" === e.key;
    }).value = JSON.stringify(n), e.push({
      key: "placeId",
      value: null
    }), e;
  },
      qe = tt(t(Ue(JSON.parse(JSON.stringify(c)))), 2),
      Ye = qe[0],
      Ze = qe[1];

  a(function () {
    if (!Te) {
      var e = Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2);
      localStorage.setItem("sessionId", e), Pe(e);
    }

    (null == ue ? void 0 : ue.length) > 0 && (null == fe ? void 0 : fe.length) > 0 ? (me([]), ve([])) : Qe();
  }, [i, l, o, c]), a(function () {
    D.length > 0 ? gt(ke) : (Ce(), Ne());
  }, [D]);

  var Xe = function () {
    var e = Ge(Je().mark(function e() {
      var t, a;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, !y) {
                e.next = 5;
                break;
              }

              Re([y]), e.next = 9;
              break;

            case 5:
              return e.next = 7, pa.getDumpsterPublishedPros(g, h);

            case 7:
              a = e.sent, (null === (t = a.data) || void 0 === t ? void 0 : t.length) > 0 && Re(a.data);

            case 9:
              e.next = 14;
              break;

            case 11:
              e.prev = 11, e.t0 = e.catch(0), console.log("error: ", e.t0);

            case 14:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 11]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      Qe = function () {
    var e = Ge(Je().mark(function e() {
      var t, a, n, r, s, d, u, m, p, f, v, g, h, y, C, E, w, k, N, I, D, F, T, L, A, _;

      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, $(!0), Z(!0), ne(!1), We && 0 !== (null == We ? void 0 : We.length) || Xe(), n = yt(), s = [], !n) {
                e.next = 20;
                break;
              }

              if (e.prev = 8, !n.a) {
                e.next = 14;
                break;
              }

              return e.next = 12, Ct(n.a);

            case 12:
              (r = e.sent) && (s = [{
                key: "wasteType",
                value: n.w ? [+n.w] : [1]
              }, {
                key: "deliveryAddress",
                value: r.odf_street && r.odf_street2 ? r.odf_street + ", " + r.odf_street2 : ""
              }, {
                key: "fullFormData",
                value: Ke(Ke({}, r), {}, {
                  wasteType: n.w ? [+n.w] : [1]
                })
              }]);

            case 14:
              e.next = 19;
              break;

            case 16:
              e.prev = 16, e.t0 = e.catch(8), console.error(e.t0);

            case 19:
              n.s && Be(n.s);

            case 20:
              if (d = (null === (t = s) || void 0 === t ? void 0 : t.length) > 0 ? at(s) : JSON.parse(JSON.stringify(c)), !(l && 0 === (null === (a = s) || void 0 === a ? void 0 : a.length) || r)) {
                e.next = 69;
                break;
              }

              if (f = null !== (u = r) && void 0 !== u && u.odf_postal_code ? r.odf_postal_code : l, !(v = null !== (m = r) && void 0 !== m && m.odf_locality ? r.odf_locality.replace(/ /g, "-") : null === (p = JSON.parse(JSON.stringify(c)).find(function (e) {
                return "fullFormData" === e.key;
              })) || void 0 === p || null === (p = p.value) || void 0 === p || null === (p = p.odf_locality) || void 0 === p ? void 0 : p.replace(/ /g, "-"))) {
                e.next = 67;
                break;
              }

              return e.next = 27, et(f, v);

            case 27:
              if (g = e.sent, M(+g.id), W(g.name), Ne(b), (h = Ue(d)).find(function (e) {
                return "placeId" === e.key;
              }).value = g.id, Ze(h), y = d.map(function (e) {
                return {
                  active: !0,
                  id: e.key,
                  currentValue: e.value
                };
              }), "book" !== x) {
                e.next = 51;
                break;
              }

              if (r || (null != (E = null === (C = JSON.parse(JSON.stringify(c))) || void 0 === C || null === (C = C.find(function (e) {
                return "fullFormData" === e.key;
              })) || void 0 === C ? void 0 : C.value) && E.odf_place_id && xt("a", E.odf_place_id), null != E && E.wasteType && E.wasteType.length > 0 && xt("w", E.wasteType[0]), Me && xt("s", Me)), ee(lt([{
                _id: "62aa3d7ad6e19c02d425eab8",
                name: "wasteType",
                supportedValues: [{
                  id: 1,
                  value: "Trash",
                  parentFilter: null,
                  parentValue: null,
                  code: null,
                  __typename: "keyValue"
                }, {
                  id: 2,
                  value: "Construction Debris",
                  parentFilter: null,
                  parentValue: null,
                  code: null,
                  __typename: "keyValue"
                }, {
                  id: 3,
                  value: "Concrete",
                  parentFilter: null,
                  parentValue: null,
                  code: null,
                  __typename: "keyValue"
                }, {
                  id: 4,
                  value: "Roofing",
                  parentFilter: null,
                  parentValue: null,
                  code: null,
                  __typename: "keyValue"
                }, {
                  id: 5,
                  value: "Yard Waste",
                  parentFilter: null,
                  parentValue: null,
                  code: null,
                  __typename: "keyValue"
                }, {
                  id: 6,
                  value: "Dirt",
                  parentFilter: null,
                  parentValue: null,
                  code: null,
                  __typename: "keyValue"
                }, {
                  id: 7,
                  value: "Rock or Brick",
                  parentFilter: null,
                  parentValue: null,
                  code: null,
                  __typename: "keyValue"
                }],
                type: "select",
                exposed: !0,
                defaultValue: ["1", "2", "3"],
                label: "Waste Type",
                weight: 2,
                active: !0,
                __typename: "serviceFilterDefinition"
              }, {
                _id: "62bc646c217b8b8382dcb72e",
                name: "deliveryAddress",
                supportedValues: [],
                type: "googleAddress",
                exposed: !0,
                defaultValue: [],
                label: "Delivery Address",
                weight: 1,
                active: !1,
                __typename: "serviceFilterDefinition"
              }], at(d))), Z(!1), !g || !g.id) {
                e.next = 48;
                break;
              }

              return e.next = 43, nt(+g.id, o, i, V * S, S, y, g.name, n.s ? n.s : null, h);

            case 43:
              w = e.sent, P(ct(w.data, +g.id)), q(w.pageInfo), e.next = 49;
              break;

            case 48:
              He(!0);

            case 49:
              e.next = 67;
              break;

            case 51:
              if (!g || !g.id) {
                e.next = 62;
                break;
              }

              return e.next = 54, Promise.allSettled([nt(+g.id, o, i, V * S, S, y, g.name), rt(o, i)]);

            case 54:
              k = e.sent, N = k[1].value, ee(lt(N.data, at(d))), I = k[0].value, P(ct(I.data, +g.id)), q(I.pageInfo), e.next = 67;
              break;

            case 62:
              return e.next = 64, rt(o, i);

            case 64:
              D = e.sent, ee(lt(D.data, at(d))), He(!0);

            case 67:
              e.next = 86;
              break;

            case 69:
              if ("book" !== x) {
                e.next = 75;
                break;
              }

              ee(lt([{
                _id: "62aa3d7ad6e19c02d425eab8",
                name: "wasteType",
                supportedValues: [{
                  id: 1,
                  value: "Trash",
                  parentFilter: null,
                  parentValue: null,
                  code: null,
                  __typename: "keyValue"
                }, {
                  id: 2,
                  value: "Construction Debris",
                  parentFilter: null,
                  parentValue: null,
                  code: null,
                  __typename: "keyValue"
                }, {
                  id: 3,
                  value: "Concrete",
                  parentFilter: null,
                  parentValue: null,
                  code: null,
                  __typename: "keyValue"
                }, {
                  id: 4,
                  value: "Roofing",
                  parentFilter: null,
                  parentValue: null,
                  code: null,
                  __typename: "keyValue"
                }, {
                  id: 5,
                  value: "Yard Waste",
                  parentFilter: null,
                  parentValue: null,
                  code: null,
                  __typename: "keyValue"
                }, {
                  id: 6,
                  value: "Dirt",
                  parentFilter: null,
                  parentValue: null,
                  code: null,
                  __typename: "keyValue"
                }, {
                  id: 7,
                  value: "Rock or Brick",
                  parentFilter: null,
                  parentValue: null,
                  code: null,
                  __typename: "keyValue"
                }],
                type: "select",
                exposed: !0,
                defaultValue: ["1", "2", "3"],
                label: "Waste Type",
                weight: 2,
                active: !0,
                __typename: "serviceFilterDefinition"
              }, {
                _id: "62bc646c217b8b8382dcb72e",
                name: "deliveryAddress",
                supportedValues: [],
                type: "googleAddress",
                exposed: !0,
                defaultValue: [],
                label: "Delivery Address",
                weight: 1,
                active: !1,
                __typename: "serviceFilterDefinition"
              }], at(d))), Z(!1), e.next = 86;
              break;

            case 75:
              return F = Ue(d), Ze(F), T = d.map(function (e) {
                return {
                  active: !0,
                  id: e.key,
                  currentValue: e.value
                };
              }), e.next = 80, Promise.allSettled([nt(null, o, i, V * S, S, T, null), rt(o, i)]);

            case 80:
              L = e.sent, A = L[1].value, ee(lt(A.data, at(d))), _ = L[0].value, P(ct(_.data, null)), q(_.pageInfo);

            case 86:
              e.next = 91;
              break;

            case 88:
              throw e.prev = 88, e.t1 = e.catch(0), e.t1;

            case 91:
              return e.prev = 91, Z(!1), $(!1), e.finish(91);

            case 95:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 88, 91, 95], [8, 16]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      et = function () {
    var e = Ge(Je().mark(function e(t, a) {
      var n;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, aa(u, t, a);

            case 3:
              return n = e.sent, e.abrupt("return", n.data);

            case 7:
              throw e.prev = 7, e.t0 = e.catch(0), e.t0;

            case 10:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 7]]);
    }));
    return function (t, a) {
      return e.apply(this, arguments);
    };
  }(),
      nt = function () {
    var e = Ge(Je().mark(function e(t, a, n, r, l, i, o, s, d, u) {
      var f, v, h, b, C, E, w, k, N, S, I, D, F, T;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, h = {}, b = [], 0 !== se.length) {
                e.next = 8;
                break;
              }

              return e.next = 6, ma.getWasteTypes(g);

            case 6:
              b = e.sent, ce(b.data);

            case 8:
              return (d || Ye || c).forEach(function (e) {
                var t, a, n, r, l;
                if ("fullFormData" === e.key) "object" === $e(e.value) ? (h.street1 = null === (t = e.value) || void 0 === t ? void 0 : t.odf_street, h.street2 = null === (a = e.value) || void 0 === a ? void 0 : a.odf_street2, h.city = null === (n = e.value) || void 0 === n ? void 0 : n.odf_locality, h.state = null === (r = e.value) || void 0 === r ? void 0 : r.odf_state, h.zipCode = null === (l = e.value) || void 0 === l ? void 0 : l.odf_postal_code) : JSON.parse(e.value).forEach(function (e) {
                  switch (e[0]) {
                    case "street":
                      h.street1 = e[1];
                      break;

                    case "street2":
                      h.street2 = e[1];
                      break;

                    case "locality":
                      h.city = e[1];
                      break;

                    case "state":
                      h.state = e[1];
                      break;

                    case "postal_code":
                      h.zipCode = e[1];
                  }
                });else if ("wasteType" === e.key) {
                  var i,
                      o,
                      s = se.length > 0 ? se : null === (i = b) || void 0 === i ? void 0 : i.data;
                  h.wasteTypeLabel = null === (o = s.find(function (t) {
                    return t.id === e.value;
                  })) || void 0 === o ? void 0 : o.value, h.wasteType = e.value;
                }
              }), t && o && (C = Te || localStorage.getItem("sessionId"), h.placeIdName = o, E = {
                eventType: "SC",
                eventDescription: u ? "No city selected" : "Address Selected",
                proId: n,
                eventData: Ke({
                  source: null == p ? void 0 : p.replace("/assets/", ""),
                  sessionId: C,
                  url: null != y && y.ur ? null == p ? void 0 : p.replace("/assets/", "/".concat(y.ur)) : null == p ? void 0 : p.replace("/assets/", "/book"),
                  placeId: [t]
                }, h)
              }, h.event = E, h.placesId = [t]), a && (h.idBaseService = a), n && (h.proId = n), "book" === x && (h.dumpsterSize = s || Me), ie([]), localStorage.setItem("onlineBookingData", JSON.stringify({
                placeId: t,
                baseServiceId: a,
                skip: r,
                limit: l,
                initialValues: c,
                finalDataForBooking: d || Ye
              })), e.next = 18, oa.get(m, r, l, i, h);

            case 18:
              if (w = e.sent, !((null === (f = w.data) || void 0 === f || null === (f = f.data) || void 0 === f ? void 0 : f.length) > 0 && null === (null === (v = w.data) || void 0 === v || null === (v = v.data[0]) || void 0 === v ? void 0 : v._id) && "book" !== x)) {
                e.next = 22;
                break;
              }

              return ie(null === (k = w.data.data.map(function (e) {
                return e.suggestedPros;
              })) || void 0 === k ? void 0 : k.slice(0, 5)), e.abrupt("return", {
                data: [],
                pageInfo: w.data.pageInfo
              });

            case 22:
              if (t || "book" === x) {
                e.next = 31;
                break;
              }

              if (N = he) {
                e.next = 29;
                break;
              }

              return e.next = 27, oa.getProAreaSegment(m.split("graphql")[0] + "api/v1", n);

            case 27:
              I = e.sent, null !== (S = I.data) && void 0 !== S && S.defaultArea && (be(null === (D = I.data) || void 0 === D ? void 0 : D.defaultArea), N = null === (F = I.data) || void 0 === F ? void 0 : F.defaultArea);

            case 29:
              return T = w.data.data.filter(function (e) {
                return e.areaId === N;
              }), e.abrupt("return", {
                data: T,
                pageInfo: w.data.pageInfo
              });

            case 31:
              return e.abrupt("return", w.data);

            case 34:
              throw e.prev = 34, e.t0 = e.catch(0), ne(!0), e.t0;

            case 38:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 34]]);
    }));
    return function (t, a, n, r, l, i, o, s, c, d) {
      return e.apply(this, arguments);
    };
  }(),
      rt = function () {
    var e = Ge(Je().mark(function e(t, a) {
      var n;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, sa(m, t, a);

            case 3:
              return n = e.sent, e.abrupt("return", n.data);

            case 7:
              throw e.prev = 7, e.t0 = e.catch(0), ne(!0), e.t0;

            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 7]]);
    }));
    return function (t, a) {
      return e.apply(this, arguments);
    };
  }(),
      lt = function lt(e, t) {
    return ot(it(function (e) {
      return e.sort(function (e, t) {
        return e.weight - t.weight;
      });
    }(e)), t);
  },
      it = function it(e) {
    return e.map(function (e) {
      return st(e);
    });
  },
      ot = function ot(e, t) {
    return t.forEach(function (t) {
      var a = e.find(function (e) {
        return e.id === t.key;
      });
      a && (a.currentValue = t.value);
    }), e;
  },
      st = function st(e) {
    return {
      id: e.name,
      label: e.label,
      type: (a = e.type, ya[a]),
      options: (t = e.supportedValues, t.map(function (e) {
        return {
          label: e.value,
          value: e.id,
          parentValue: e.parentValue
        };
      })),
      currentValue: "",
      exposed: e.exposed,
      active: e.active,
      weight: e.weight,
      dependency: e.supportedValues && e.supportedValues.length && e.supportedValues[0].parentFilter
    };
    var t, a;
  },
      ct = function ct(e, t) {
    return e.map(function (e) {
      return dt(e, t);
    });
  },
      dt = function dt(e, t) {
    var a,
        n = t && (null === (a = e.placesId) || void 0 === a || null === (a = a.find(function (e) {
      return +e.placeId == +t;
    })) || void 0 === a ? void 0 : a.distanceFee);
    return {
      id: e._id,
      title: e.description,
      subtitle: e.dimensions,
      imagePath: "",
      price: e.price ? n ? (e.price + +n).toFixed(2) : e.price.toFixed(2) : e.price,
      image: e.image,
      images: e.images,
      details: e.details.map(function (e, t) {
        return {
          id: t,
          text1: e.details
        };
      }),
      proId: e.proId
    };
  },
      ut = function () {
    var e = Ge(Je().mark(function e(t, a, n) {
      var r, l, s, d, u, m, p, f, v, g, h, b, y, C, E, w;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!n) {
                e.next = 47;
                break;
              }

              if (null === (r = JSON.parse(n)) || void 0 === r || r.forEach(function (e) {
                if (e.length > 0) switch (e[0]) {
                  case "postal_code":
                    l = e[1];
                    break;

                  case "locality":
                    e[1] && (s = e[1].replace(/ /g, "-"));
                    break;

                  case "street":
                    d = e[1];
                    break;

                  case "street2":
                    u = e[1];
                }
              }), e.prev = 2, $(!0), !l) {
                e.next = 34;
                break;
              }

              return e.next = 7, et(l, s);

            case 7:
              if (p = e.sent, M(+p.id), W(p.name), !s && p.name && (m = !0, f = JSON.parse(n), (null == (v = p.name.split(",")) ? void 0 : v.length) > 0 && (f.push(["locality", v[0]]), n = JSON.stringify(f))), j(0), _e(!0), (g = Ye).find(function (e) {
                return "fullFormData" === e.key;
              }).value = n, g.find(function (e) {
                return "placeId" === e.key;
              }).value = p.id, Ze(g), (h = Q).find(function (e) {
                return "deliveryAddress" === (null == e ? void 0 : e.id);
              }).currentValue = "".concat(d, " ").concat(u), ee(h), "book" === x && (null == (b = JSON.parse(n).filter(function (e) {
                return "place_id" == e[0];
              })) ? void 0 : b.length) > 0 && xt("a", b[0][1]), !p || !p.id) {
                e.next = 29;
                break;
              }

              return e.next = 24, nt(+p.id, o, i, 0, S, Q, p.name, null, g, m);

            case 24:
              y = e.sent, P(ct(y.data, +p.id)), q(y.pageInfo), e.next = 32;
              break;

            case 29:
              He(!0), _e(!0), mt();

            case 32:
              e.next = 37;
              break;

            case 34:
              _e(!1), He(!1), mt();

            case 37:
              e.next = 42;
              break;

            case 39:
              throw e.prev = 39, e.t0 = e.catch(2), e.t0;

            case 42:
              return e.prev = 42, $(!1), e.finish(42);

            case 45:
              e.next = 65;
              break;

            case 47:
              if (C = Ye, t.length > 2 ? C.find(function (e) {
                return "date" === e.key;
              }).value = t : (C.find(function (e) {
                return "wasteType" === e.key;
              }).value = [t], "book" === x && xt("w", t)), Ze(C), localStorage.setItem("onlineBookingData", JSON.stringify({
                placeId: O,
                baseServiceId: o,
                skip: 0,
                limit: S,
                initialValues: c,
                finalDataForBooking: C
              })), (E = Q)[a].currentValue = t, ee(at(E)), !E[a].active) {
                e.next = 65;
                break;
              }

              if ("book" !== x || O) {
                e.next = 57;
                break;
              }

              return e.abrupt("return");

            case 57:
              return $(!0), j(0), e.next = 61, nt(O, o, i, 0, S, E, z);

            case 61:
              w = e.sent, P(ct(w.data, O)), q(w.pageInfo), $(!1);

            case 65:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[2, 39, 42, 45]]);
    }));
    return function (t, a, n) {
      return e.apply(this, arguments);
    };
  }(),
      mt = function mt() {
    P([]), M(), W(), j(0), q({
      currentPage: 0,
      hasNextPage: !1,
      perPage: S,
      totalCount: 0,
      hasPreviousPage: !1,
      pageCount: 0,
      itemCount: 0,
      __typename: "pageInfo"
    });
  },
      pt = function () {
    var e = Ge(Je().mark(function e() {
      var t, a, n, r;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!Ye) {
                e.next = 23;
                break;
              }

              if ((t = Ye).find(function (e) {
                return "placeId" === e.key;
              }).value = null, t.find(function (e) {
                return "fullFormData" === e.key;
              }).value = "[]", Ze(t), a = JSON.parse(JSON.stringify(t)).map(function (e) {
                return {
                  active: !0,
                  id: e.key,
                  currentValue: e.value
                };
              }), (n = Q).find(function (e) {
                return "deliveryAddress" === (null == e ? void 0 : e.id);
              }).currentValue = "", ee(n), "book" === x) {
                e.next = 17;
                break;
              }

              return e.next = 12, nt(null, o, i, V * S, S, a, null);

            case 12:
              r = e.sent, P(ct(r.data, null)), q(r.pageInfo), e.next = 19;
              break;

            case 17:
              xt("a"), mt();

            case 19:
              M(null), W(null), _e(!0), He(!1);

            case 23:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      ft = function () {
    var e = Ge(Je().mark(function e() {
      var t, a, n;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, t = {
                idBaseService: o,
                placesId: [O],
                placeIdName: z
              }, "book" === x && (t.dumpsterSize = Me), (Ye || c).forEach(function (e) {
                var a;
                "wasteType" === e.key && se.length > 0 && (t.wasteTypeLabel = null === (a = se.find(function (t) {
                  return t.id === e.value;
                })) || void 0 === a ? void 0 : a.value, t.wasteType = e.value);
              }), e.next = 7, oa.get(m, (V + 1) * S, S, Q, t);

            case 7:
              a = e.sent, q(a.data.pageInfo), j(V + 1), n = ct(a.data.data, O), P([].concat(at(D), at(n))), e.next = 17;
              break;

            case 14:
              throw e.prev = 14, e.t0 = e.catch(0), e.t0;

            case 17:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 14]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      vt = function vt(e) {
    ne(!1), De(e), "card-details" !== e && (w && w(!0), sessionStorage.removeItem("service-detail"));
  },
      gt = function gt(e) {
    var t = null == D ? void 0 : D.find(function (t) {
      return t.id === e;
    });

    if (t) {
      Ce(t), Ne(e);
      var a = sessionStorage.getItem("service-detail");
      a = a ? JSON.parse(a) : {}, sessionStorage.setItem("service-detail", JSON.stringify(Ke(Ke({}, a), {}, {
        serviceId: e
      })));
    } else {
      if ((null == D ? void 0 : D.length) > 0) if ("book" !== x) Ce(D[0]), Ne(D[0].id);else if (xe) if (!D.find(function (e) {
        return e.id === xe.id;
      })) {
        var n = xe.proId,
            r = D.find(function (e) {
          return +e.proId == +n;
        });
        r ? (Ce(r), Ne(r.id)) : (Ce(), Ne());
      }
    }
  },
      ht = function () {
    var e = Ge(Je().mark(function e(t) {
      var a;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (Me === t.value) {
                e.next = 11;
                break;
              }

              return Be(t.value), xt("s", t.value), $(!0), j(0), e.next = 7, nt(O, o, i, 0, S, Q, z, t.value);

            case 7:
              a = e.sent, P(ct(a.data, O)), q(a.pageInfo), $(!1);

            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }(),
      bt = function bt(e) {
    return We.find(function (t) {
      return +t._attributes_id == +e;
    });
  },
      yt = function yt() {
    var e = new URLSearchParams(window.location.search),
        t = {};
    return e.forEach(function (e, a) {
      t[a] = e;
    }), t;
  },
      xt = function xt(e, t) {
    var a = new URL(window.location);
    t ? a.searchParams.set(e, t) : a.searchParams.delete(e), window.history.replaceState({}, "", a);
  },
      Ct = function () {
    var e = Ge(Je().mark(function e(t) {
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", new Promise(function (e, a) {
                wt(d).load().then(function (n) {
                  new n.maps.places.PlacesService(document.createElement("div")).getDetails({
                    placeId: t,
                    fields: ["address_components"]
                  }, function (r, l) {
                    if (l === n.maps.places.PlacesServiceStatus.OK && r) {
                      var i,
                          o,
                          s,
                          c,
                          d,
                          u,
                          m,
                          p = r.address_components,
                          f = (null === (i = p.find(function (e) {
                        return e.types.includes("street_number");
                      })) || void 0 === i ? void 0 : i.long_name) || "",
                          v = (null === (o = p.find(function (e) {
                        return e.types.includes("route");
                      })) || void 0 === o ? void 0 : o.long_name) || "",
                          g = (null === (s = p.find(function (e) {
                        return e.types.includes("locality");
                      })) || void 0 === s ? void 0 : s.long_name) || "",
                          h = (null === (c = p.find(function (e) {
                        return e.types.includes("administrative_area_level_1");
                      })) || void 0 === c ? void 0 : c.long_name) || "",
                          b = (null === (d = p.find(function (e) {
                        return e.types.includes("administrative_area_level_1");
                      })) || void 0 === d ? void 0 : d.short_name) || "",
                          y = (null === (u = p.find(function (e) {
                        return e.types.includes("postal_code");
                      })) || void 0 === u ? void 0 : u.long_name) || "",
                          x = (null === (m = p.find(function (e) {
                        return e.types.includes("country");
                      })) || void 0 === m ? void 0 : m.long_name) || "",
                          C = "".concat(f, " ").concat(v).trim(),
                          E = "".concat(g, ", ").concat(b, " ").concat(y, ", ").concat(x);
                      e({
                        odf_country: x,
                        odf_locality: g,
                        odf_place_id: t,
                        odf_postal_code: y,
                        odf_state: h,
                        odf_street: C,
                        odf_street2: E
                      });
                    } else a(new Error("Failed to retrieve place details: ".concat(l)));
                  });
                }).catch(function (e) {
                  a(e);
                });
              }));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }();

  return e.createElement(e.Fragment, null, e.createElement(N, {
    container: !0,
    direction: "column",
    justifyContent: "flex-start",
    alignItems: G || ae ? "center" : "flex-start"
  }, G ? e.createElement(T, {
    size: 24
  }) : ae ? e.createElement(e.Fragment, null, e.createElement(k, {
    className: "notFound"
  }, "An error ocurred while loading services"), e.createElement("br", null), e.createElement(F, {
    variant: "contained",
    className: "tryAgainButton",
    onClick: Qe
  }, "Try Again")) : e.createElement(e.Fragment, null, e.createElement("div", {
    className: "card-details" === Ie || "multiple-card-list" === Ie ? "filtersContainer2" : "filtersContainer"
  }, "card-list" === Ie && e.createElement(k, {
    variant: "h2",
    className: "filterTitle"
  }, "Add your address & waste type for pricing"), "card-details" !== Ie && e.createElement(ga, {
    filters: Q,
    onChange: ut,
    onResetServices: pt,
    googlePlaceAutocompleteApiKey: d
  })), "book" === x && "card-details" !== Ie && e.createElement(e.Fragment, null, "multiple-card-list" === Ie && z && e.createElement(k, {
    variant: "h2",
    className: "filterTitle"
  }, "Dumpsters in ", z), O && e.createElement(ba, {
    tabs: xa,
    selectedTab: Me,
    handleChangeCustomTab: ht
  })), J && e.createElement(_, {
    style: {
      zIndex: 11
    },
    className: "backdrop",
    open: !0
  }, e.createElement(T, {
    className: "white-loader"
  })), D.length > 0 ? e.createElement(e.Fragment, null, "card-details" === Ie ? xe ? e.createElement(ha, {
    proId: i || xe.proId,
    apolloURL: g,
    gatsbyKey: h,
    imageStaticEnv: p,
    service: xe,
    services: i ? D : D.filter(function (e) {
      return e.proId === xe.proId;
    }),
    placeId: O,
    changeService: gt,
    currentWasteType: null === (r = Q.find(function (e) {
      return "wasteType" === e.id;
    })) || void 0 === r ? void 0 : r.currentValue,
    onClickBook: function onClickBook() {
      var e = [].concat(at(Ye), [{
        key: "service",
        value: xe
      }, {
        key: "template",
        value: "card-details"
      }, {
        key: "profileData",
        value: y || bt(xe.proId)
      }, {
        key: "dumpsterSize",
        value: Me
      }]);
      f(e);
    },
    changeTemplate: vt,
    setShowFailureMessage: ne,
    profileData: y || bt(xe.proId),
    callBy: x
  }) : e.createElement(e.Fragment, null, e.createElement("div", {
    className: "back-container",
    onClick: function onClick() {
      return vt("book" === x ? "multiple-card-list" : "card-list");
    }
  }, e.createElement(A, null, e.createElement(Ee, {
    className: "back-button"
  })), e.createElement("span", {
    className: "back-label"
  }, "Back")), e.createElement(k, {
    className: "suggestedTitle suggestedAlign"
  }, "No matching services were found for this pro, please go back.")) : e.createElement(Xt, {
    cards: D,
    placeId: O,
    showSeeMoreButton: "multiple-card-list" === Ie && U.hasNextPage,
    onCardActionClick: f,
    onSeeMoreClick: ft,
    imageStaticEnv: p,
    isLoadingServices: J,
    finalData: Ye,
    handleServiceClick: function handleServiceClick(e) {
      gt(e.id), De("card-details"), w && w(!1), sessionStorage.setItem("service-detail", JSON.stringify({
        templateName: "card-details",
        serviceId: e.id
      })), window.scrollTo(0, 0);
    },
    profileData: y,
    listOfPublishedPros: We,
    selectedDumpsterSize: Me
  })) : !J && e.createElement(e.Fragment, null, "book" !== x || O || z || !Ae || je ? e.createElement(k, {
    className: "suggestedTitle suggestedAlign"
  }, je ? "Sorry, we can't find results for this place." : Ae ? "No matching services were found".concat("book" !== x ? " for this pro." : ".") : "Please enter a valid street address.") : e.createElement(k, {
    className: "suggestedTitle suggestedAlign"
  }, "Enter a service address to see available dumpsters for rent."), (null == le ? void 0 : le.length) > 0 && e.createElement("div", {
    className: "suggestedContainer"
  }, e.createElement(k, {
    className: "suggestedTitle"
  }, "Here is a list of pros that match with your search:"), e.createElement("div", {
    className: "prosContainer"
  }, le.map(function (t, a) {
    return e.createElement("a", {
      key: a,
      className: "prosClas",
      href: "/".concat(t.ur)
    }, t.n);
  })))))));
}

function Ea(e, t) {
  var a = [];

  function n(e, t) {
    return "notRequired" === e.validationType ? t = t.notRequired() : "defined" === e.validationType ? t = t.defined() : "required" === e.validationType ? t = t.required(e.message) : "typeError" === e.validationType ? t = t.typeError(e.message) : "nullable" === e.validationType ? t = t.nullable(1 === e.value) : "oneOf" === e.validationType && (t = t.nullable(e.value, e.message)), t;
  }

  return e.map(function (e) {
    if (e.name && e.validations) {
      var r = ne.string();

      switch (e.yupType) {
        case "string":
          (!e.preConditions || e.preConditions && t[e.preConditions.name] === e.preConditions.value) && e.validations.map(function (e) {
            r = n(e, r), "min" === e.validationType ? r = r.min(e.value, e.message) : "max" === e.validationType ? r = r.max(e.value, e.message) : "email" === e.validationType ? r = r.email(e.message) : "url" === e.validationType ? r = r.url(e.value, e.message) : "matches" === e.validationType && (r = r.matches(new RegExp(e.regex), {
              message: e.message,
              excludeEmptyString: !0
            }));
          });
          break;

        case "number":
          (!e.preConditions || e.preConditions && t[e.preConditions.name] === e.preConditions.value) && (r = ne.number(), e.validations.map(function (e) {
            r = n(e, r), "positive" === e.validationType ? r = r.positive(e.message) : "negative" === e.validationType ? r = r.negative(e.message) : "integer" === e.validationType ? r = r.integer(e.message) : "min" === e.validationType ? r = r.min(e.value, e.message) : "max" === e.validationType && (r = r.max(e.value, e.message));
          }));
          break;

        case "boolean":
          (!e.preConditions || e.preConditions && t[e.preConditions.name] === e.preConditions.value) && (r = ne.boolean(), e.validations.map(function (e) {
            r = n(e, r);
          }));
          break;

        case "date":
          (!e.preConditions || e.preConditions && t[e.preConditions.name] === e.preConditions.value) && (r = ne.date(), e.validations.map(function (e) {
            r = n(e, r), "min" === e.validationType ? r = r.min(Date.parse(e.value), e.message) : "max" === e.validationType && (r = r.max(Date.parse(e.value), e.message));
          }));
          break;

        case "array":
          (!e.preConditions || e.preConditions && t[e.preConditions.name] === e.preConditions.value) && (r = ne.array(), e.validations.map(function (e) {
            r = n(e, r), "min" === e.validationType ? r = r.min(e.value, e.message) : "max" === e.validationType && (r = r.max(e.value, e.message));
          }));
      }

      a[e.name] = r;
    }
  }), ne.object().shape(a);
}

Ca.propTypes = {
  zipcode: U.oneOfType([U.number, U.string]).isRequired,
  proId: U.oneOfType([U.number, U.string]),
  baseServiceId: U.string.isRequired,
  initialValues: U.array,
  googlePlaceAutocompleteApiKey: U.string.isRequired,
  placesApiUrl: U.string.isRequired,
  servicesApiUrl: U.string.isRequired,
  imageStaticEnv: U.string.isRequired
};
var wa = ie(function (e) {
  return {
    stepper: {
      padding: e.spacing(3, 0, 5)
    },
    buttons: {
      display: "flex",
      justifyContent: "flex-end"
    },
    button: {
      marginTop: e.spacing(3),
      marginLeft: e.spacing(1)
    },
    wrapper: {
      margin: e.spacing(1),
      position: "relative"
    },
    buttonProgress: {
      position: "absolute",
      top: "50%",
      left: "50%"
    },
    flexcontainer: {
      display: "flex"
    },
    flexcontainer2: {
      display: "flex",
      flexDirection: "column"
    },
    justifyspacebetween: {
      justifyContent: "space-between",
      alignItems: "center"
    },
    justifyspacebetween2: {
      justifyContent: "space-between",
      "@media (min-width: 600px)": {
        alignItems: "center"
      }
    },
    topContainer: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: "15px"
    },
    topContainer2: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: "15px",
      justifyContent: "space-around"
    },
    image: {
      maxWidth: "200px"
    },
    imageConfirmation: {
      maxWidth: "300px",
      maxHeight: "160px",
      marginTop: "20px",
      marginBottom: "20px"
    },
    price: {
      width: "15%",
      fontSize: "1.4rem",
      lineHeight: "2rem"
    },
    boldFont: {
      fontWeight: "600",
      fontSize: "1.7rem",
      lineHeight: "2rem"
    },
    boldFontConfirmation: {
      fontWeight: "600",
      fontSize: "2.8rem",
      lineHeight: "2rem",
      marginBottom: "5px",
      padding: "5px 0 5px 0"
    },
    linkColor: {
      color: "#f58220",
      "&:hover": {
        color: "#f58220",
        textDecoration: "none"
      }
    },
    proLink: {
      color: "#212529",
      textDecoration: "none",
      "&:hover": {
        color: "#212529",
        textDecoration: "underline"
      }
    },
    cursorPointer: {
      cursor: "pointer"
    },
    marginY: {
      margin: "10px 0px"
    },
    divider: {
      margin: "10px 0px 10px 0px"
    },
    dividerConfirmation: {
      margin: "20px 0px 20px 0px",
      backgroundColor: "#aeaeae !important",
      height: "2px !important",
      width: "100%"
    },
    marginYBig: {
      margin: "30px 0px",
      "& div": {
        "& div": {
          minWidth: "75%",
          "@media (max-width: 768px)": {
            minWidth: "100%"
          }
        }
      }
    },
    itemContainer: {
      padding: "8px",
      "@media (max-width: 550px)": {
        maxWidth: "100%",
        flexBasis: "100%",
        padding: "2px"
      }
    },
    dateContainer: {
      marginTop: "10px",
      "@media (max-width: 768px)": {
        flexDirection: "column",
        gap: "10px"
      }
    },
    marginRight: {
      marginRight: "20px"
    },
    mobileHelperText: {
      color: "#e76b6b",
      fontSize: "1.2rem",
      margin: "0px"
    },
    marginRightSmall: {
      marginRight: "10px"
    },
    marginTopBig: {
      marginTop: "10px"
    },
    marginTopDescription: {
      marginTop: "50px"
    },
    paddingContainer: {
      padding: "8px",
      "@media (max-width: 500px)": {
        padding: "2px !important"
      }
    },
    paddingWaste: {
      "@media (max-width: 500px)": {
        padding: "2px !important"
      }
    },
    styledAccordion: {
      boxShadow: "none",
      position: "initial",
      minHeight: "fit-content",
      "& .MuiAccordionSummary-root": {
        flexDirection: "row-reverse",
        minHeight: "fit-content",
        padding: "0px",
        "& .MuiAccordionSummary-content": {
          margin: "5px 20px"
        },
        "& .MuiIconButton-root": {
          padding: "0px"
        }
      }
    },
    fullWidth: {
      width: "100%"
    },
    itemsList: {
      minWidth: "250px"
    },
    detailContainer: {
      width: "100%",
      "@media (min-width: 992px)": {
        maxWidth: "66.666667%",
        padding: "8px"
      },
      "@media (max-width: 500px)": {
        padding: "0 !important"
      },
      "@media (min-width: 501px and max-width: 991px)": {
        marginBottom: "20px"
      }
    },
    pricingContainer: {
      width: "100%",
      "@media (min-width: 992px)": {
        maxWidth: "33.333333%",
        padding: "8px"
      },
      "@media (max-width: 500px)": {
        padding: "0 !important",
        paddingTop: "16px !important",
        marginTop: "10px"
      }
    },
    detailsCard: {
      "@media (min-width: 1200px)": {
        minWidth: "700px"
      },
      "@media (max-width: 500px)": {
        boxShadow: "none"
      },
      "& .MuiCardContent-root": {
        "@media (max-width: 500px)": {
          paddingLeft: "0 !important",
          paddingRight: "0 !important",
          paddingBottom: "0"
        }
      }
    },
    contactDetailsCard: {
      "@media (min-width: 1200px)": {
        minWidth: "700px"
      },
      width: "100%",
      "@media (max-width: 500px)": {
        boxShadow: "none"
      }
    },
    cardContentBooking: {
      "@media (max-width: 500px)": {
        padding: "5px !important"
      }
    },
    paddingCard: {
      "@media (max-width: 500px)": {
        padding: "5px !important"
      }
    },
    accordionContainer: {
      width: "100%",
      "@media (max-width: 500px)": {
        "& .MuiAccordionDetails-root": {
          padding: "0 !important"
        }
      }
    },
    helperText: {
      paddingLeft: "8px",
      marginLeft: "14px",
      marginRight: "14px",
      fontSize: "1.4rem !important",
      lineHeight: "2rem",
      fontStyle: "italic"
    },
    paymentTitle: {
      fontSize: "1.8rem"
    },
    checkLabel: {
      "@media (max-width: 500px)": {
        marginLeft: "-5px",
        paddingLeft: "2px !important"
      },
      "& span": {
        fontSize: "1.6rem",
        "@media (max-width: 500px)": {
          padding: "0 !important",
          paddingRight: "9px !important"
        }
      }
    },
    emailHelper: {
      "& p": {
        fontSize: "1.2rem"
      }
    },
    inputFont: {
      fontSize: "1.3rem",
      color: "rgba(0, 0, 0, 0.54) !important"
    },
    descriptionFont: {
      fontSize: "1.7rem",
      lineHeight: "2rem"
    },
    titleModal: {
      fontSize: "2.2rem",
      lineHeight: "2rem",
      fontWeight: "600",
      marginBottom: "0px",
      marginTop: "4px"
    },
    descriptionHelperFont: {
      fontSize: "1.4rem",
      lineHeight: "2rem"
    },
    inputMinWidth: {
      width: "200px"
    },
    element: {
      borderColor: "#c4c4c4",
      borderRadius: "5px",
      width: "400px",
      padding: "15px 15px",
      "&::-webkit-scrollbar": {
        display: "none"
      },
      "@media (max-width: 500px)": {
        width: "325px"
      },
      "@media (max-width: 420px)": {
        width: "270px"
      }
    },
    fakeLabelContainer: {
      position: "relative"
    },
    fakeLabel: {
      position: "absolute",
      backgroundColor: "white",
      color: "#000",
      left: "15px",
      top: "-10px",
      padding: "0px 5px",
      fontSize: "1.6rem",
      fontWeight: "400",
      lineHeight: "1.4rem"
    },
    billingAddress: {
      width: "100%"
    },
    successIcon: {
      color: "#7dd773"
    },
    dotted: {
      minWidth: "70px"
    },
    paymentFormContainer: {
      padding: "20px",
      width: "100%",
      "@media (max-width: 500px)": {
        padding: "5px !important"
      }
    },
    paymentWidth: {
      width: "100%"
    },
    drawerHeader: {
      padding: "15px"
    },
    backgroundPrimary: {
      backgroundColor: "#f18605",
      color: "#FFF"
    },
    accentBookableColor: {
      backgroundColor: "#f18605",
      color: "#FFF",
      fontWeight: "600",
      textTransform: "none",
      "& span": {
        fontSize: "1.6rem",
        lineHeight: "2rem",
        textTransform: "none"
      },
      "&:hover": {
        backgroundColor: "#db6c0a"
      }
    },
    pointer: {
      cursor: "pointer"
    },
    cardNumberElement: {
      border: "1px solid #c4c4c4",
      borderRadius: "3px",
      padding: "10.5px"
    },
    stripeLabel: {
      position: "relative",
      top: "29px",
      left: "11px",
      fontSize: "16px",
      color: "#757575",
      lineHeight: "0px"
    },
    chargedToday: {
      padding: "25px",
      backgroundColor: "#fafafa",
      fontSize: "2rem !important"
    },
    headerContainer: {
      width: "calc(100% - 32px)",
      minHeight: "80px",
      display: "flex",
      flexDirection: "column",
      background: "#FFFFFF",
      borderRadius: "4px",
      "@media (min-width: 500px)": {
        marginLeft: "12px",
        marginRight: "16px"
      }
    },
    headerContainerColor: {
      width: "100%",
      height: "50px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      background: "rgba(0, 0, 0, 0.12)",
      borderRadius: "4px",
      marginBottom: "16px"
    },
    backButton: {
      width: "5%"
    },
    backButtonColor: {
      width: "5%",
      color: "#000 !important"
    },
    backHrefColor: {
      width: "5%",
      color: "#FFFFFF !important",
      textDecoration: "none",
      textAlign: "center",
      "&:hover": {
        color: "#FFFFFF !important",
        textDecoration: "none"
      }
    },
    fontHeader: {
      width: "95%",
      fontWeight: "700",
      fontSize: "20px",
      lineHeight: "1.5",
      letterSpacing: "0.00938em",
      color: "#263238",
      margin: "0px",
      marginLeft: "20px"
    },
    fontHeaderConfirmation: {
      width: "95%",
      fontWeight: "700",
      fontSize: "4rem",
      lineHeight: "1.5",
      letterSpacing: "0.00938em",
      color: "#263238",
      padding: "10px 0 10px 0"
    },
    fontSubTitleConfirmation: {
      fontSize: "2.3rem",
      padding: "10px 0 10px 0"
    },
    marginPhone: {
      marginBottom: "10px"
    },
    fontDatesConfirmation: {
      gap: "15px"
    },
    fontHeaderColor: {
      width: "95%",
      textAlign: "center",
      fontWeight: "700",
      fontSize: "18px",
      lineHeight: "1.5",
      letterSpacing: "0.00938em",
      color: "#000",
      margin: "0px"
    },
    loader: {
      margin: "auto",
      color: "#F18400"
    },
    draweVisibility: {
      zIndex: "999 !important"
    },
    accordionSummary: {
      "& div:nth-child(2)": {
        transform: "rotate(0deg)"
      },
      "& .MuiAccordionSummary-content": {
        flexDirection: "column",
        cursor: "default"
      },
      "@media (max-width: 500px)": {
        padding: "0px 5px !important"
      }
    },
    orderConfirmationContainer: {
      display: "flex",
      flexDirection: "column",
      width: "960px",
      alignItems: "center",
      margin: "auto !important",
      "@media (max-width: 1200px)": {
        width: "900px"
      },
      "@media (max-width: 992px)": {
        width: "100%"
      }
    },
    displayFlex: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start"
    },
    firstOrderColumn: {
      width: "100%"
    },
    secondOrderColumn: {
      width: "100%"
    },
    thirdOrderColumn: {
      width: "100%"
    },
    dividerVisibility: {
      "@media (min-width: 992px)": {
        display: "none"
      }
    },
    titleFont: {
      fontSize: "1.8rem"
    },
    titleCheckoutFont: {
      fontSize: "2rem"
    },
    titleAlign: {
      marginTop: "10px",
      "@media (min-width: 600px)": {
        textAlign: "center"
      }
    },
    dateTitle: {
      fontSize: "1.7rem",
      fontWeight: "600",
      lineHeight: "2rem"
    },
    pricePadding: {
      padding: "10px"
    },
    taxesContainer: {
      "& div": {
        justifyContent: "space-between"
      }
    },
    priceSpace: {
      marginRight: "10px"
    },
    amountMargin: {
      marginRight: "12px",
      fontSize: "2rem !important"
    },
    dumpsterForContainer: {
      padding: "8px",
      marginTop: "5px",
      "@media (max-width: 550px)": {
        padding: "2px"
      }
    },
    dumpsterForSelect: {
      "& label": {
        backgroundColor: "#FFFFFF",
        paddingRight: "5px",
        color: "#000",
        fontSize: "20px",
        marginTop: "-2px",
        "@media (max-width: 340px)": {
          fontSize: "clamp(14px, 6vw, 20px) !important"
        }
      },
      "& div": {
        fontSize: "20px !important",
        color: "#000",
        "& div": {
          padding: "14px !important"
        },
        "& fieldset": {
          top: "0 !important"
        }
      }
    },
    datePicker: {
      "& label": {
        marginTop: "6px",
        marginLeft: "10px",
        backgroundColor: "#FFFFFF",
        padding: "5px",
        cursor: "pointer",
        zIndex: 1,
        color: "#000",
        fontSize: "20px",
        "@media (max-width: 340px)": {
          fontSize: "clamp(14px, 6vw, 20px) !important"
        }
      },
      "& div": {
        border: "solid 1px rgba(0, 0, 0, 0.23)",
        borderRadius: "4px",
        padding: "10px",
        cursor: "pointer",
        fontSize: "20px !important",
        color: "#000",
        "& input": {
          padding: "0px",
          paddingTop: "3px !important",
          paddingLeft: "5px",
          cursor: "pointer"
        }
      },
      "& p": {
        fontSize: "1.2rem"
      },
      "& .MuiInput-underline:before": {
        borderBottom: "none !important"
      },
      "& .MuiInput-underline:after": {
        borderBottom: "none !important"
      },
      "& .MuiInputLabel-shrink": {
        marginTop: "6px !important"
      }
    },
    containerWidth: {
      "@media (max-width: 768px)": {
        width: "100%"
      },
      "@media (min-width: 768px)": {
        width: "50%"
      }
    },
    inputWidth: {
      width: "100%"
    },
    textInputStyle: {
      "& label": {
        marginTop: "6px"
      },
      "& > div": {
        padding: "14px",
        fontSize: "18px !important",
        "& input": {
          cursor: "pointer",
          padding: "0px",
          paddingTop: "3px !important",
          paddingLeft: "5px"
        },
        "& fieldset": {
          top: "0 !important"
        }
      },
      "& .MuiInputLabel-shrink": {
        marginTop: "0px !important"
      }
    },
    marginLabelTop: {
      marginTop: "20px"
    },
    textAreaHeight: {
      height: "75px !important",
      fontSize: "18px"
    },
    paymentLabel: {
      "& label": {
        backgroundColor: "#FFFFFF"
      },
      "& div": {
        "& div": {
          border: "none !important",
          padding: "0 !important"
        }
      }
    },
    paymentLabelModal: {
      "& label": Ze({
        backgroundColor: "#FFFFFF",
        fontSize: "18px",
        fontWeight: "400",
        lineHeight: "1.4rem",
        paddingLeft: "10px",
        paddingRight: "8px",
        marginTop: "-2px",
        color: "#000"
      }, "marginTop", "6px"),
      "& .MuiInputLabel-shrink": {
        marginTop: "-2px !important"
      },
      "& div": {
        padding: "14px",
        fontSize: "18px !important",
        "& div": {
          border: "none !important",
          padding: "0 !important"
        },
        "& fieldset": {
          top: "0 !important"
        }
      }
    },
    inputError: {
      "& div": {
        "& input": {
          color: "#e76b6b"
        },
        "& fieldset": {
          borderColor: "#e76b6b"
        }
      }
    },
    textareaError: {
      borderColor: "#e76b6b"
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "flex-end"
    },
    buttonWidth: {
      width: "150px"
    },
    checkedIcon: {
      color: "#4CAF50"
    },
    contactSummaryContainer: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      justifyContent: "space-around"
    },
    contactSummary: {
      display: "flex",
      flexDirection: "column",
      width: "400px",
      "@media (max-width: 768px)": {
        width: "200px"
      }
    },
    contactSummaryCard: {
      display: "flex",
      flexDirection: "column",
      width: "400px",
      "@media (max-width: 768px)": {
        width: "fit-content"
      }
    },
    contactText: {
      fontSize: "1.6rem",
      lineHeight: "2rem",
      margin: "0px"
    },
    editButton: {
      border: "none",
      textDecoration: "underline",
      color: "#F18400",
      background: "none",
      fontSize: "1.7rem",
      lineHeight: "2rem",
      cursor: "pointer",
      "&:hover": {
        textDecoration: "none"
      }
    },
    cardInfo: {
      display: "flex",
      flexDirection: "row",
      gap: "10px",
      alignItems: "center",
      cursor: "pointer"
    },
    cardIcon: {
      maxWidth: "78px",
      maxHeight: "78px"
    },
    addCardContainer: {
      display: "flex",
      width: "100%",
      justifyContent: "center"
    },
    addCard: {
      border: "none",
      textDecoration: "underline",
      color: "#279AD5",
      background: "none",
      fontSize: "1.5rem",
      lineHeight: "2rem",
      cursor: "pointer",
      width: "fit-content !important",
      "&:hover": {
        textDecoration: "none",
        background: "none"
      }
    },
    removeCard: {
      cursor: "pointer",
      color: "#279AD5 !important"
    },
    alignCard: {
      alignItems: "center"
    },
    checkedButton: {
      color: "#279AD5",
      "&:hover": {
        background: "none"
      }
    },
    cancelButton: {
      backgroundColor: "#FFFFFF",
      color: "rgba(0, 0, 0, 0.26)",
      fontSize: "1.6rem",
      lineHeight: "2rem",
      "& span": {
        textTransform: "none"
      },
      "&:hover": {
        backgroundColor: "#FFFFFF"
      }
    },
    buttonsContainer: {
      display: "flex",
      flexDirection: "row",
      gap: "10px"
    },
    checkboxContainer: {
      "&:hover": {
        background: "none !important"
      }
    },
    popUp: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      minHeight: "150px"
    },
    cancelButtonModal: {
      background: "none",
      fontSize: "1.6rem",
      color: "#263238",
      boxShadow: "none",
      "&:hover": {
        backgroundImage: "linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1))"
      },
      "& span": {
        textTransform: "none"
      }
    },
    confirmButtonModal: {
      backgroundColor: "#f18605",
      color: "#FFF",
      fontWeight: "600",
      textTransform: "none",
      "& span": {
        fontSize: "1.6rem",
        textTransform: "none"
      },
      "&:hover": {
        backgroundColor: "#db6c0a"
      }
    },
    backdrop: {
      background: "#FFFFFF",
      zIndex: "3000"
    },
    buttonsContainerModal: {
      gap: "10px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      marginTop: "20px"
    },
    extaDataCard: {
      "@media (max-width: 768px)": {
        flexDirection: "column"
      }
    },
    cardExtraWidth: {
      paddingRight: "10px",
      "@media (max-width: 768px)": {
        maxWidth: "100%",
        flexBasis: "100%",
        paddingRight: 0,
        marginBottom: "10px"
      }
    },
    cardExtraWidth2: {
      "@media (max-width: 768px)": {
        maxWidth: "100%",
        flexBasis: "100%"
      }
    },
    errorIconContainer: {
      textAlign: "center"
    },
    errorIcon: {
      color: "#f27474",
      fontSize: "6rem !important"
    },
    verifyContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "15px"
    },
    verifyFont: {
      fontSize: "1.7rem",
      lineHeight: "2rem",
      margin: 0
    },
    verifyAgain: {
      fontSize: "1.7rem",
      lineHeight: "2rem",
      border: "none",
      background: "none",
      textTransform: "none",
      color: "#279AD5",
      "& span": {
        fontSize: "1.7rem",
        lineHeight: "2rem",
        textTransform: "none"
      },
      "&:hover": {
        textDecoration: "underline",
        background: "none"
      }
    },
    verifyButtons: {
      gap: "10px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginTop: "20px"
    },
    failedContainer: {
      display: "flex",
      fontSize: "2.7rem",
      fontWeight: 700,
      lineHeight: "1.5",
      padding: "15px 15px",
      textAlign: "left",
      borderRadius: "5px",
      width: "100%",
      color: "rgb(191, 38, 0)",
      backgroundColor: "rgb(255, 235, 230)"
    }
  };
});

function ka(n) {
  var r = wa(),
      l = n.isLoadingServices,
      i = n.additionalPeriodsAmount,
      o = n.extraPeriodCost,
      s = n.startDate,
      c = n.endDate,
      d = n.placeId,
      u = n.serviceId,
      m = n.apolloURL,
      p = n.serviceDescription,
      f = n.proId,
      v = n.event,
      g = tt(t(0), 2),
      h = g[0],
      b = g[1],
      y = tt(t(0), 2),
      x = y[0],
      C = y[1],
      E = tt(t(0), 2),
      w = E[0],
      S = E[1];
  a(function () {
    Ge(Je().mark(function e() {
      var t, a, r;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!(s && c && d && u)) {
                e.next = 13;
                break;
              }

              return e.prev = 1, e.next = 4, oa.getServicePrice(m, {
                startDate: s,
                endDate: c,
                placeId: d,
                serviceId: u,
                proId: f,
                event: v
              });

            case 4:
              t = e.sent, b(t.data.basePrice + t.data.distanceFee), C(t.data.extraDaysFee), S(t.data.serviceFee), e.next = 13;
              break;

            case 10:
              e.prev = 10, e.t0 = e.catch(1), 422 === (null === (a = e.t0.response) || void 0 === a ? void 0 : a.status) && 1018 === (null === (r = e.t0.response) || void 0 === r || null === (r = r.data) || void 0 === r ? void 0 : r.code) ? (n.setModalCode("pageOutOfDate"), n.setShowModal(!0)) : (n.setModalCode("pageOutOfOrder"), n.setShowModal(!0));

            case 13:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[1, 10]]);
    }))();
  }, [s, c, d, u]);
  var I;
  return e.createElement(e.Fragment, null, e.createElement(N, {
    container: !0,
    direction: "row"
  }, l ? e.createElement(_, {
    className: r.backdrop,
    open: !0
  }, e.createElement(T, {
    className: r.white
  })) : e.createElement(L, {
    className: r.fullWidth
  }, e.createElement(O, {
    className: r.noPadding
  }, e.createElement("div", {
    className: "".concat(r.flexcontainer, " ").concat(r.justifyspacebetween, " ").concat(r.pricePadding)
  }, e.createElement(k, {
    variant: "body2",
    className: r.descriptionFont
  }, p), e.createElement(k, {
    variant: "body2",
    className: "".concat(r.descriptionFont, " ").concat(r.priceSpace)
  }, "$", 0 === h ? h : h.toFixed(2))), e.createElement("div", {
    className: "".concat(r.flexcontainer, " ").concat(r.justifyspacebetween, " ").concat(r.pricePadding)
  }, i > 0 && o ? e.createElement(e.Fragment, null, e.createElement(k, {
    variant: "body2",
    className: r.descriptionFont
  }, "Extra time (", i, " @ $", o, ")"), e.createElement(k, {
    variant: "body2",
    className: "".concat(r.descriptionFont, " ").concat(r.priceSpace)
  }, "$", 0 === x ? x : x.toFixed(2))) : e.createElement(e.Fragment, null)), e.createElement(M, {
    className: "".concat(r.styledAccordion)
  }, e.createElement(B, {
    expandIcon: e.createElement(Ne, null),
    "aria-controls": "panel1a-content",
    id: "panel1a-header",
    className: r.taxesContainer
  }, e.createElement(k, {
    className: r.descriptionFont
  }, "Taxes & fees"), e.createElement(k, {
    variant: "body2",
    className: r.descriptionFont
  }, "$", 0 === w ? w : w.toFixed(2))), e.createElement(z, null, e.createElement(W, {
    className: r.itemsList,
    dense: !0
  }, e.createElement(R, null, e.createElement("div", {
    className: "".concat(r.flexcontainer, " ").concat(r.fullWidth, " ").concat(r.justifyspacebetween)
  }, e.createElement(k, {
    variant: "body2",
    className: r.descriptionFont
  }, "Taxes"), e.createElement(k, {
    variant: "body2",
    className: r.descriptionFont
  }, "$0"))), e.createElement(R, null, e.createElement("div", {
    className: "".concat(r.flexcontainer, " ").concat(r.fullWidth, " ").concat(r.justifyspacebetween)
  }, e.createElement(k, {
    variant: "body2",
    className: r.descriptionFont
  }, "Service Fee"), e.createElement(k, {
    variant: "body2",
    className: r.descriptionFont
  }, "$", 0 === w ? w : w.toFixed(2)))))))), e.createElement("div", {
    className: "".concat(r.flexcontainer, " ").concat(r.justifyspacebetween, " ").concat(r.chargedToday)
  }, e.createElement("strong", null, e.createElement(k, {
    className: r.boldFont
  }, "Total")), e.createElement("strong", null, e.createElement(k, {
    className: "".concat(r.boldFont, " ").concat(r.amountMargin)
  }, "$", 0 === (I = h + x + w) ? I : I.toFixed(2)))))));
}

function Na(n) {
  var r,
      l,
      i,
      o = wa();
  n.servicesApiUrl;
  var s = n.placeId;
  n.baseServiceId;
  var c = n.proId,
      d = n.apolloURL,
      u = n.service;
  n.connectedAcountId;
  var m = n.handleCheckoutClick,
      p = n.staticUrl,
      f = n.proName,
      v = n.maxDatePicker,
      g = n.dumpsterFor,
      h = tt(t(!1), 2),
      b = h[0],
      y = h[1],
      x = tt(t(n.deliveryDates ? n.deliveryDates : [null, null]), 2),
      C = x[0],
      E = x[1],
      w = tt(t([]), 2);
  w[0];

  var S = w[1],
      I = tt(t([]), 2),
      D = I[0],
      P = I[1],
      _ = tt(t([]), 2),
      M = _[0],
      B = _[1],
      z = tt(t(n.googlePlace ? n.googlePlace : ""), 2),
      W = z[0];

  z[1];
  var R = tt(t(!1), 2),
      V = R[0],
      j = R[1],
      H = tt(t(se()), 2),
      U = H[0],
      q = H[1],
      Y = tt(t({
    delivery: !1,
    removal: !1,
    message: "Please select a valid date"
  }), 2),
      G = Y[0],
      Z = Y[1],
      X = tt(t(""), 2),
      Q = X[0],
      ee = X[1],
      te = tt(t(!1), 2),
      ae = te[0],
      ne = te[1],
      re = tt(t(g && g), 2),
      le = re[0],
      ie = re[1],
      oe = n.selectedWasteType && (Array.isArray(n.selectedWasteType) ? n.selectedWasteType[0] : n.selectedWasteType);

  function se() {
    return window.innerWidth;
  }

  a(function () {
    var e = function e() {
      q(se());
    };

    return window.addEventListener("resize", e), function () {
      window.removeEventListener("resize", e);
    };
  }, [U]), a(function () {
    Ge(Je().mark(function e() {
      var t, a, r, l, i, o, s;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, window.scrollTo(0, 0), y(!0), e.next = 5, Promise.all([ma.getSizes(d), ma.getTypes(d), ma.getWasteTypes(d)]);

            case 5:
              a = e.sent, r = tt(a, 3), l = r[0], i = r[1], o = r[2], s = o.data.filter(function (e) {
                return u.wasteType.includes(e.id);
              }), S(s), ee(null == s || null === (t = s.find(function (e) {
                return e.id === oe;
              })) || void 0 === t ? void 0 : t.value), P(l.data), B(i.data), e.next = 22;
              break;

            case 17:
              e.prev = 17, e.t0 = e.catch(0), console.log(e.t0), n.setModalCode("pageOutOfOrder"), n.setShowModal(!0);

            case 22:
              return e.prev = 22, y(!1), e.finish(22);

            case 25:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 17, 22, 25]]);
    }))();
  }, []);

  var ce = function ce(e, t) {
    var a = t.getTime() - e.getTime();
    return Math.ceil(a / 864e5);
  },
      de = function de(e, t) {
    var a = e.find(function (e) {
      return e.id === t;
    });
    return a ? a.value : "";
  },
      ue = function ue(e, t) {
    var a = e.find(function (e) {
      return e.id === t;
    });
    return a ? a.value : "";
  },
      me = function me() {
    if (C[0] && C[1]) {
      var e = (ce(new Date(C[0]), new Date(C[1])) - u.details[1].period) / u.details[1].extraDayPeriod;
      if (e > 0) return Math.ceil(e);
    }

    return 0;
  },
      pe = function () {
    var e = Ge(Je().mark(function e() {
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              try {
                j(!0), m({
                  googlePlace: W,
                  deliveryDates: C,
                  selectedWasteType: oe,
                  selectedWasteTypeLabel: Q,
                  getAditionalPeriodsAmount: me,
                  selectedDumpsterFor: le,
                  serviceDescription: "".concat(de(D, u.dumpsterSize[0]), " ").concat(ue(M, u.dumpsterType[0]))
                });
              } catch (e) {
                console.log(e);
              } finally {
                j(!1);
              }

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      fe = function fe(e) {
    return 0 === e.getDay() || 6 === e.getDay();
  },
      ve = function ve(e) {
    var t = new Date(e),
        a = new Date();
    return a.setHours(0, 0, 0, 0), t.setHours(0, 0, 0, 0), a >= t;
  },
      ge = null === (r = u.placesId) || void 0 === r || null === (r = r.find(function (e) {
    return +e.placeId == +s;
  })) || void 0 === r ? void 0 : r.distanceFee;

  return e.createElement(e.Fragment, null, e.createElement(N, {
    container: !0,
    direction: "row"
  }, b ? e.createElement(T, {
    size: 35,
    className: o.loader
  }) : e.createElement(e.Fragment, null, e.createElement("div", {
    className: o.headerContainer
  }, e.createElement(A, {
    className: o.backButton,
    onClick: function onClick() {
      return n.handleBack([{
        key: "wasteType",
        value: oe
      }, {
        key: "fullFormData",
        value: W
      }]);
    }
  }, e.createElement(Ee, null)), e.createElement("p", {
    className: o.fontHeader
  }, e.createElement("strong", null, "Set dates and confirm order"))), e.createElement(N, {
    item: !0,
    className: o.detailContainer
  }, e.createElement(L, {
    className: "".concat(o.detailsCard)
  }, e.createElement(O, null, e.createElement(N, {
    xs: 6,
    item: !0,
    className: "".concat(o.itemContainer, " ").concat(o.dumpsterForContainer)
  }, e.createElement(It, {
    className: "".concat(o.dumpsterForSelect, " outlined-select"),
    name: "dumpsterFor",
    label: "Dumpster is for *",
    data: [{
      value: "1",
      label: "Personal use"
    }, {
      value: "2",
      label: "Contractor / business use"
    }],
    onChange: function onChange(e) {
      e ? (ne(!1), ie(e)) : ne(!0);
    },
    defaultValue: le,
    error: "Please select an option",
    isError: ae,
    fullWidth: !0
  })), e.createElement(N, {
    container: !0
  }, e.createElement(N, {
    xs: 6,
    item: !0,
    className: o.itemContainer
  }, e.createElement(K, {
    utils: $
  }, e.createElement(J, {
    className: "".concat(o.marginRight, " ").concat(o.datePicker),
    value: C[0],
    onChange: function onChange(e) {
      var t = ce(new Date(), e);
      if (t > 0 || -0 === t) {
        if (C[1]) {
          var a = ce(e, new Date(C[1]));
          a > 0 || -0 === a ? (C[0] = e, E(at(C)), Z(Ke(Ke({}, G), {}, {
            delivery: !1
          }))) : (C[0] = null, E(at(C)), Z(Ke(Ke({}, G), {}, {
            delivery: !0
          })));
        } else C[0] = e, E(at(C)), Z(Ke(Ke({}, G), {}, {
          delivery: !1
        }));
      } else C[0] = null, E(at(C)), Z(Ke(Ke({}, G), {}, {
        delivery: !0
      }));
    },
    label: "Delivery date",
    fullWidth: !0,
    size: "small",
    variant: "outlined",
    required: !0,
    shouldDisableDate: fe,
    minDate: new Date(Date.now() + 864e5),
    maxDate: C[1] ? new Date(C[1].getTime() - 864e5) : new Date(Date.now() + v),
    error: G.delivery,
    invalidDateMessage: G.delivery && G.message,
    helperText: G.delivery && G.message,
    autoOk: !0,
    format: "MM/dd/yyyy",
    DialogProps: {
      PaperProps: {
        className: C[0] ? "" : ve(new Date(Date.now() + 864e5)) ? "today-custom-date-picker" : "custom-date-picker"
      }
    },
    inputProps: {
      "data-testid": "filter-input",
      placeholder: ""
    },
    InputProps: {
      endAdornment: e.createElement(Ie, null)
    }
  }))), e.createElement(N, {
    xs: 6,
    item: !0,
    className: o.itemContainer
  }, e.createElement(K, {
    utils: $
  }, e.createElement(J, {
    className: "".concat(o.marginRight, " ").concat(o.datePicker),
    value: C[1],
    onChange: function onChange(e) {
      var t = ce(C[0] ? new Date(C[0]) : new Date(), new Date(e));
      t > 0 || -0 === t ? (C[1] = e, E(at(C)), Z(Ke(Ke({}, G), {}, {
        removal: !1
      }))) : (C[1] = null, E(at(C)), Z(Ke(Ke({}, G), {}, {
        removal: !0
      })));
    },
    label: "Removal date",
    fullWidth: !0,
    size: "small",
    variant: "outlined",
    required: !0,
    shouldDisableDate: fe,
    minDate: C[0] ? new Date(C[0].getTime() + 864e5) : new Date(Date.now() + 864e5),
    maxDate: new Date(Date.now() + v),
    error: G.removal,
    invalidDateMessage: G.removal && G.message,
    helperText: G.removal && G.message,
    autoOk: !0,
    format: "MM/dd/yyyy",
    DialogProps: {
      PaperProps: {
        className: C[1] ? "" : ve(C[0] ? new Date(C[0].getTime() + 864e5) : new Date(Date.now() + 864e5)) ? "today-custom-date-picker" : "custom-date-picker"
      }
    },
    inputProps: {
      "data-testid": "filter-input",
      placeholder: ""
    },
    InputProps: {
      endAdornment: e.createElement(Ie, null)
    }
  }))), e.createElement("p", {
    className: o.dateTitle,
    style: {
      fontWeight: "400",
      fontSize: "1.6rem",
      marginLeft: "20px"
    }
  }, u.details[1].details.replace("<br> ", "").replace(".", ","), ".")), !U || U > 600 ? e.createElement("div", {
    className: "".concat(o.flexcontainer, " ").concat(o.justifyspacebetween, " ").concat(o.marginTopDescription, " ").concat(o.paddingContainer)
  }, e.createElement("div", {
    className: o.topContainer
  }, e.createElement("img", {
    src: "".concat(p).concat((null === (l = u.images) || void 0 === l ? void 0 : l.length) > 0 ? u.images[0] : u.image),
    className: o.image
  }), e.createElement("div", null, e.createElement(k, {
    className: "".concat(o.boldFont, " ").concat(o.price)
  }, "$", ge ? (u.price + +ge).toFixed(2) : u.price.toFixed(2)), e.createElement(k, {
    className: "".concat(o.descriptionFont, " ").concat(o.titleFont)
  }, de(D, u.dumpsterSize[0]), " ", ue(M, u.dumpsterType[0]), ", ", f)))) : e.createElement("div", {
    className: "".concat(o.flexcontainer2, " ").concat(o.justifyspacebetween2, " ").concat(o.marginTopDescription, " ").concat(o.paddingContainer)
  }, e.createElement("div", {
    className: o.topContainer2
  }, e.createElement("img", {
    src: "".concat(p).concat((null === (i = u.images) || void 0 === i ? void 0 : i.length) > 0 ? u.images[0] : u.image),
    className: o.image
  })), e.createElement(k, {
    className: "".concat(o.boldFont, " ").concat(o.price, " ").concat(o.titleAlign)
  }, "$", u.price), e.createElement(k, {
    className: "".concat(o.descriptionFont, " ").concat(o.titleFont, " ").concat(o.titleAlign)
  }, de(D, u.dumpsterSize[0]), " ", ue(M, u.dumpsterType[0]), ", ", f, ".")), e.createElement("div", {
    className: "".concat(o.marginTopBig, " ").concat(o.paddingContainer)
  }, e.createElement("div", {
    className: o.marginTopBig
  }, e.createElement("p", {
    className: o.dateTitle
  }, "Deliver to:"), e.createElement("p", {
    className: o.dateTitle,
    style: {
      fontWeight: "400",
      fontSize: "1.6rem"
    }
  }, W ? Object.fromEntries(JSON.parse(W)).street + ", " + Object.fromEntries(JSON.parse(W)).street2 : "")), e.createElement("div", {
    className: "".concat(o.marginTopBig, " ").concat(o.paddingWaste)
  }, e.createElement("p", {
    className: o.dateTitle
  }, "Waste:"), e.createElement("p", {
    className: o.dateTitle,
    style: {
      fontWeight: "400",
      fontSize: "1.6rem"
    }
  }, Q, " - ", u.details[0].details.replace("<br> ", ""))))))), e.createElement(N, {
    item: !0,
    className: o.pricingContainer
  }, e.createElement(N, {
    container: !0,
    className: o.paddingContainer,
    style: {
      paddingTop: "8px",
      gap: "10px",
      marginBottom: "20px"
    }
  }, e.createElement(N, {
    xs: 12,
    item: !0
  }, e.createElement(F, {
    onClick: pe,
    className: o.accentBookableColor,
    size: "large",
    variant: "contained",
    fullWidth: !0,
    disabled: !(oe && C[0] && C[1] && W && le)
  }, V ? e.createElement(T, {
    size: 24,
    color: "inherit"
  }) : e.createElement("b", null, "Continue to Checkout"))), e.createElement(N, {
    xs: 12,
    item: !0
  }, e.createElement(N, {
    container: !0,
    alignItems: "center"
  }, e.createElement(Se, {
    className: o.marginRightSmall
  }), e.createElement(k, {
    variant: "subtitle1",
    className: o.descriptionFont
  }, "Secure checkout"))), e.createElement(N, {
    xs: 12,
    item: !0
  }, e.createElement(ka, {
    startDate: C[0],
    endDate: C[1],
    placeId: s,
    proId: c,
    additionalPeriodsAmount: me(),
    extraPeriodCost: u.details[1].extraPeriodCost,
    serviceId: u._id,
    apolloURL: d,
    serviceDescription: "".concat(de(D, u.dumpsterSize[0]), " ").concat(ue(M, u.dumpsterType[0])),
    setModalCode: n.setModalCode,
    setShowModal: n.setShowModal
  })))))));
}

function Sa(a) {
  var n = wa(),
      r = a.isLoadingServices,
      l = a.handleFirstNameChange,
      i = a.handleLastnameChange,
      o = a.handleMobilePhoneChange,
      s = a.handleEmailChange,
      c = a.name,
      d = a.lastname,
      u = a.mobilePhone,
      p = a.email,
      f = a.error,
      v = a.dumpsterPlacement,
      g = a.emailError,
      h = a.handleContinue;
  a.getCustomerList;

  var b = a.getCustomer,
      y = a.changeShowModal,
      x = a.setCustomerList,
      C = a.setSelectedCard,
      E = tt(t(!1), 2),
      w = E[0],
      S = E[1],
      I = tt(t(!1), 2),
      D = I[0],
      P = I[1],
      A = tt(t(!1), 2),
      M = A[0],
      B = A[1],
      z = tt(t(!1), 2),
      W = z[0],
      R = z[1],
      V = tt(t(!1), 2),
      j = V[0],
      H = V[1],
      U = function () {
    var e = Ge(Je().mark(function e() {
      var t;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, H(!0), !(t = JSON.parse(localStorage.getItem("Customer"))) || t.phone !== u || !Qt.defaults.headers.common.hashcode) {
                e.next = 7;
                break;
              }

              h(v ? "panel1" : "panel2"), e.next = 12;
              break;

            case 7:
              return (t || Qt.defaults.headers.common.hashcode) && (localStorage.removeItem("Customer"), delete Qt.defaults.headers.common.hashcode, x([]), C("")), e.next = 10, b();

            case 10:
              e.sent ? y("verificationCode") : h(v ? "panel1" : "panel2");

            case 12:
              e.next = 17;
              break;

            case 14:
              e.prev = 14, e.t0 = e.catch(0), console.log("error: ", e.t0);

            case 17:
              return e.prev = 17, H(!1), e.finish(17);

            case 20:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 14, 17, 20]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }();

  return e.createElement(e.Fragment, null, e.createElement(N, {
    container: !0,
    direction: "row"
  }, r ? e.createElement(_, {
    className: n.backdrop,
    open: !0
  }, e.createElement(T, {
    className: n.white
  })) : e.createElement(L, {
    className: "".concat(n.contactDetailsCard)
  }, e.createElement(O, {
    className: n.cardContentBooking
  }, e.createElement(k, {
    variant: "caption",
    style: {
      fontSize: "1.1rem",
      color: "rgba(0, 0, 0, 0.54)"
    }
  }, "* Required fields"), e.createElement("br", null), e.createElement("br", null), e.createElement("div", null, e.createElement(N, {
    container: !0,
    spacing: 2
  }, e.createElement(N, {
    item: !0,
    className: n.containerWidth
  }, e.createElement(m, {
    className: "".concat(n.marginRight, " ").concat(n.inputWidth, " ").concat(n.textInputStyle, " ").concat(w && !c && n.inputError),
    onChange: l,
    value: c,
    label: "First name *",
    variant: "outlined",
    type: "text",
    size: "small",
    onFocus: function onFocus() {
      return S(!1);
    },
    onBlur: function onBlur() {
      S(!c);
    },
    helperText: w && !c && e.createElement("p", {
      className: n.mobileHelperText
    }, "Enter first name"),
    inputProps: {
      "data-testid": "filter-input",
      placeholder: ""
    }
  })), e.createElement(N, {
    item: !0,
    className: n.containerWidth
  }, e.createElement(m, {
    className: "".concat(n.marginRight, " ").concat(n.inputWidth, " ").concat(n.textInputStyle, " ").concat(D && !d && n.inputError),
    onChange: i,
    label: "Last name *",
    value: d,
    variant: "outlined",
    type: "text",
    size: "small",
    onFocus: function onFocus() {
      return P(!1);
    },
    onBlur: function onBlur() {
      P(!d);
    },
    helperText: D && !d && e.createElement("p", {
      className: n.mobileHelperText
    }, "Enter last name"),
    inputProps: {
      "data-testid": "filter-input",
      placeholder: ""
    }
  }))), e.createElement("br", null), e.createElement(N, {
    container: !0,
    spacing: 2
  }, e.createElement(N, {
    item: !0,
    className: n.containerWidth
  }, e.createElement(m, {
    className: "".concat(n.marginRight, " ").concat(n.inputWidth, " ").concat(n.textInputStyle, " ").concat(W && f && n.inputError),
    onChange: o,
    label: "Mobile phone (10 digits) *",
    value: u,
    variant: "outlined",
    type: "tel",
    size: "small",
    onFocus: function onFocus() {
      return R(!1);
    },
    onBlur: function onBlur() {
      R(!!f);
    },
    helperText: W && f ? e.createElement("p", {
      className: n.mobileHelperText
    }, f) : e.createElement("p", {
      className: n.descriptionHelperFont
    }, "Service info texted here"),
    inputProps: {
      "data-testid": "filter-input",
      placeholder: "",
      maxLength: null != u && u.includes(" ") || null != u && u.includes("(") || null != u && u.includes(")") || null != u && u.includes("-") ? 14 : 10
    }
  })), e.createElement(N, {
    item: !0,
    className: n.containerWidth
  }, e.createElement(m, {
    className: "".concat(n.marginRight, " ").concat(n.inputWidth, " ").concat(n.textInputStyle, " ").concat(M && g && n.inputError),
    onChange: s,
    label: "Email *",
    value: p,
    variant: "outlined",
    type: "email",
    size: "small",
    onFocus: function onFocus() {
      return B(!1);
    },
    onBlur: function onBlur() {
      B(!!g);
    },
    helperText: M && g ? e.createElement("p", {
      className: n.mobileHelperText
    }, g) : e.createElement("p", {
      className: n.descriptionHelperFont
    }, "Your receipt will be emailed here"),
    inputProps: {
      "data-testid": "filter-input",
      placeholder: ""
    }
  })))), e.createElement("br", null), e.createElement("div", {
    className: n.buttonContainer
  }, e.createElement(F, {
    onClick: U,
    className: "".concat(n.accentBookableColor, " ").concat(n.buttonWidth),
    size: "large",
    variant: "contained",
    fullWidth: !0,
    disabled: !c || !d || 14 !== (null == u ? void 0 : u.length) || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(p) || j
  }, j ? e.createElement(T, {
    size: 24,
    color: "inherit"
  }) : e.createElement("b", null, "Continue")))))));
}

function Ia(a) {
  var n = wa(),
      r = a.isLoadingServices,
      l = a.handleDumpsterPlacementChange,
      i = a.dumpsterPlacement,
      o = a.handleContinue,
      s = a.setIsShowingCards,
      c = a.customerList,
      d = a.setIsContinuePress,
      u = tt(t(!1), 2),
      m = u[0],
      p = u[1];
  return e.createElement(e.Fragment, null, e.createElement(N, {
    container: !0,
    direction: "row"
  }, r ? e.createElement(_, {
    className: n.backdrop,
    open: !0
  }, e.createElement(T, {
    className: n.white
  })) : e.createElement("div", {
    className: "".concat(n.fullWidth, " ").concat(n.paddingCard)
  }, e.createElement(k, {
    variant: "body2",
    className: "".concat(n.descriptionFont, " ").concat(n.marginLabelTop)
  }, "Describe where the dumpster should be placed. Include any access issues (gates, lock codes, hours of operation, etc)."), e.createElement("div", {
    className: "".concat(n.marginYBig, " ").concat(n.fakeLabelContainer)
  }, e.createElement(k, {
    variant: "caption",
    className: n.fakeLabel
  }, "Dumpster Placement *"), e.createElement(x, {
    className: "".concat(n.element, " ").concat(n.textAreaHeight, " ").concat(m && !i && n.textareaError),
    value: i,
    onChange: l,
    minRows: 10,
    maxRows: 10,
    onFocus: function onFocus() {
      return p(!1);
    },
    onBlur: function onBlur() {
      p(!i);
    },
    "aria-label": "maximum height"
  }), e.createElement(g, {
    className: m && !i ? n.mobileHelperText : n.helperText
  }, m && !i ? "Enter instructions" : "On the left side of the driveway near the garage")), e.createElement("br", null), e.createElement("div", {
    className: n.buttonContainer
  }, e.createElement(F, {
    onClick: function onClick() {
      (null == c ? void 0 : c.length) > 0 ? (s(!0), o("panel2")) : (s(!1), o("panel3")), d(!0);
    },
    className: "".concat(n.accentBookableColor, " ").concat(n.buttonWidth),
    size: "large",
    variant: "contained",
    fullWidth: !0,
    disabled: !i
  }, e.createElement("b", null, "Continue"))))));
}

function Da(t) {
  var a = wa(),
      n = _e(),
      r = Oe(),
      l = t.isLoadingServices,
      i = t.customerEmail;

  t.customerName, t.customerPhone, t.customerLastname, t.pi, t.apolloURL;
  var o = t.defaultAddress,
      s = t.stripeApiKey,
      c = t.handleContinue,
      d = t.setIsShowingCards,
      u = t.addCustomerList,
      p = tt(e.useState(!1), 2),
      g = p[0],
      h = p[1],
      b = tt(e.useState(""), 2),
      y = b[0],
      x = b[1],
      C = tt(e.useState(!1), 2),
      E = C[0],
      w = C[1],
      S = tt(e.useState("Enter a valid card"), 2),
      I = S[0],
      D = S[1],
      P = tt(e.useState("Enter expiration date"), 2),
      L = P[0],
      A = P[1],
      O = tt(e.useState("Enter security code"), 2),
      M = O[0],
      B = O[1],
      z = tt(e.useState(""), 2),
      W = z[0],
      R = z[1],
      j = tt(e.useState(""), 2),
      H = j[0],
      U = j[1],
      q = tt(e.useState(""), 2),
      K = q[0],
      J = q[1],
      $ = tt(e.useState(!1), 2),
      Y = $[0],
      G = $[1],
      Z = tt(e.useState(!1), 2),
      X = Z[0],
      Q = Z[1],
      ee = tt(e.useState(!1), 2),
      te = ee[0],
      ae = ee[1];
  Re(s);

  var ne = function () {
    var e = Ge(Je().mark(function e() {
      var t, a, l, s;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (event.preventDefault(), n && r) {
                e.next = 3;
                break;
              }

              return e.abrupt("return");

            case 3:
              return h(!0), t = {}, E ? (a = Object.fromEntries(JSON.parse(y)), t = {
                city: a.locality,
                country: "US",
                postal_code: a.postal_code,
                state: a.state,
                line1: a.street
              }) : t = {
                city: o.locality,
                country: "US",
                postal_code: o.postal_code,
                state: o.state,
                line1: o.street
              }, l = {
                email: i,
                address: t
              }, e.prev = 7, e.next = 10, n.createPaymentMethod({
                type: "card",
                card: r.getElement(Me),
                billing_details: l
              });

            case 10:
              (s = e.sent).paymentMethod && (u({
                id: s.paymentMethod.id,
                brand: s.paymentMethod.card.brand,
                last4: s.paymentMethod.card.last4,
                expiration: "".concat(s.paymentMethod.card.exp_month / 10 > 1 ? s.paymentMethod.card.exp_month : "0" + s.paymentMethod.card.exp_month, "/").concat(s.paymentMethod.card.exp_year),
                attachedMethod: !1
              }), d(!0), c("panel3")), e.next = 18;
              break;

            case 14:
              e.prev = 14, e.t0 = e.catch(7), console.log(e.t0), h(!1);

            case 18:
              return e.prev = 18, h(!1), e.finish(18);

            case 21:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[7, 14, 18, 21]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      re = function re(e) {
    "cardNumber" === e.elementType && (e.complete ? D("") : (e.error, D("Enter a valid card"))), "cardExpiry" === e.elementType && (e.complete ? A("") : (e.error, A("Enter expiration date"))), "cardCvc" === e.elementType && (e.complete ? B("") : (e.error, B("Enter security code")));
  };

  return e.createElement(e.Fragment, null, e.createElement(N, {
    container: !0,
    direction: "row"
  }, l ? e.createElement(_, {
    className: a.backdrop,
    open: !0
  }, e.createElement(T, {
    className: a.white
  })) : e.createElement(e.Fragment, null, e.createElement("div", {
    className: a.paymentWidth
  }, e.createElement(k, {
    variant: "subtitle2",
    className: a.inputFont
  }, "*Required fields"), e.createElement(N, {
    container: !0,
    className: "".concat(a.flex, " ").concat(a.marginY)
  }, e.createElement(N, {
    className: a.inputContainer,
    item: !0,
    xs: 12
  }, e.createElement(m, {
    fullWidth: !0,
    value: H,
    className: "".concat(a.paymentLabel, " ").concat(a.textInputStyle, " ").concat(I && Y && a.inputError),
    onChange: function onChange(e) {
      U(e.empty ? "" : " ");
    },
    label: "Card number *",
    size: "small",
    variant: "outlined",
    onFocus: function onFocus() {
      return G(!1);
    },
    onBlur: function onBlur() {
      G(!!I);
    },
    helperText: Y && I && e.createElement("p", {
      className: a.mobileHelperText
    }, I),
    InputProps: {
      inputComponent: Me
    },
    inputProps: {
      className: a.cardNumberElement,
      onChange: re,
      options: {
        placeholder: "",
        showIcon: !!H
      }
    }
  }))), e.createElement(N, {
    container: !0,
    className: "".concat(a.flex, " ").concat(a.marginY, " ").concat(a.extaDataCard)
  }, e.createElement(N, {
    item: !0,
    xs: 6,
    className: a.cardExtraWidth
  }, e.createElement(m, {
    fullWidth: !0,
    value: W,
    className: "".concat(a.paymentLabel, " ").concat(a.textInputStyle, " ").concat(L && X && a.inputError),
    onChange: function onChange(e) {
      R(e.empty ? "" : " ");
    },
    label: "MM/YY *",
    size: "small",
    variant: "outlined",
    onFocus: function onFocus() {
      return Q(!1);
    },
    onBlur: function onBlur() {
      Q(!!L);
    },
    helperText: X && L && e.createElement("p", {
      className: a.mobileHelperText
    }, L),
    InputProps: {
      inputComponent: Be
    },
    inputProps: {
      className: a.cardNumberElement,
      onChange: re,
      options: {
        placeholder: ""
      }
    }
  })), e.createElement(N, {
    item: !0,
    xs: 6,
    className: a.cardExtraWidth2
  }, e.createElement(m, {
    fullWidth: !0,
    value: K,
    className: "".concat(a.paymentLabel, " ").concat(a.textInputStyle, " ").concat(M && te && a.inputError),
    onChange: function onChange(e) {
      J(e.empty ? "" : " ");
    },
    label: "Security code *",
    size: "small",
    variant: "outlined",
    onFocus: function onFocus() {
      return ae(!1);
    },
    onBlur: function onBlur() {
      ae(!!M);
    },
    helperText: te && M && e.createElement("p", {
      className: a.mobileHelperText
    }, M),
    InputProps: {
      inputComponent: ze
    },
    inputProps: {
      className: a.cardNumberElement,
      onChange: re,
      options: {
        placeholder: ""
      }
    }
  })))))), e.createElement("br", null), e.createElement(V, null), e.createElement("br", null), e.createElement("div", null, e.createElement(k, null, e.createElement("b", {
    className: a.paymentTitle
  }, "Billing Address")), e.createElement("br", null), e.createElement(f, {
    className: a.checkLabel,
    control: e.createElement(v, {
      onChange: function onChange() {
        var e = window.scrollY;
        w(function (e) {
          return !e;
        }), setTimeout(function () {
          return window.scrollTo(0, e);
        }, 0);
      },
      name: "checkedB",
      color: "primary",
      checked: !E
    }),
    label: "Same as service address"
  }), e.createElement("br", null), e.createElement("br", null), E ? e.createElement(e.Fragment, null, e.createElement(N, {
    spacing: 2,
    container: !0,
    className: "".concat(a.flex, " ").concat(a.marginY)
  }, e.createElement(N, {
    item: !0,
    xs: 12
  }, e.createElement(Nt, {
    apiKey: t.googlePlaceAutocompleteApiKey,
    className: a.billingAddress,
    defaultValue: y ? Object.fromEntries(JSON.parse(y)).street + ", " + Object.fromEntries(JSON.parse(y)).street2 : "",
    name: "",
    label: "Street address *",
    fieldName: "c",
    placeholder: "Street address",
    resetError: function resetError() {},
    onResetField: function onResetField() {
      x("");
    },
    onChange: function onChange(e) {
      x(JSON.stringify(e));
    },
    onChangeValue: y,
    formValues: [],
    size: "small",
    fullWidth: !0,
    showSearchIcon: !0
  })))) : e.createElement("p", {
    className: a.dateTitle,
    style: {
      fontWeight: "400",
      fontSize: "1.6rem"
    }
  }, o ? o.street + ", " + o.street2 : "")), e.createElement("br", null), e.createElement("br", null), e.createElement(N, {
    xs: 12,
    item: !0,
    className: a.buttonsContainer
  }, e.createElement(F, {
    className: a.cancelButton,
    variant: "contained",
    size: "large",
    fullWidth: !0,
    onClick: function onClick() {
      d(!0), c("panel3");
    }
  }, "Cancel"), e.createElement(F, {
    disabled: (E ? !y : !o) || g || I || L || M,
    className: a.accentBookableColor,
    variant: "contained",
    size: "large",
    fullWidth: !0,
    onClick: ne
  }, g ? e.createElement(T, {
    size: 24,
    color: "inherit"
  }) : "Continue")));
}

function Fa(t) {
  var a = t.customerName,
      n = t.customerLastname,
      r = t.customerPhone,
      l = t.customerEmail,
      i = t.pi,
      o = t.apolloURL,
      s = t.defaultAddress,
      c = t.stripeApiKey,
      d = t.handleContinue,
      u = t.setIsShowingCards,
      m = t.addCustomerList,
      p = Re(c);
  return e.createElement(We, {
    stripe: p,
    options: {}
  }, e.createElement(Da, {
    googlePlaceAutocompleteApiKey: t.googlePlaceAutocompleteApiKey,
    pi: i,
    customerName: a,
    customerLastname: n,
    customerPhone: r,
    customerEmail: l,
    apolloURL: o,
    defaultAddress: s,
    stripeApiKey: c,
    handleContinue: d,
    setIsShowingCards: u,
    addCustomerList: m
  }));
}

function Ta(t) {
  var n = t.cardId,
      r = t.handleCheckoutFinishWithPayment,
      l = t.setShowModal,
      i = t.apolloURL,
      o = t.service,
      s = t.proId,
      c = t.fromDate,
      d = t.toDate,
      u = t.placeId,
      p = t.customerEmail,
      f = t.customerName,
      v = t.customerPhone,
      g = t.customerSurname,
      h = t.count,
      b = t.setCount,
      y = t.removeCard,
      x = t.changeShowModal,
      C = _e(),
      E = Oe(),
      w = wa(),
      k = tt(e.useState(""), 2),
      S = k[0],
      I = k[1],
      D = tt(e.useState(!1), 2),
      P = D[0],
      L = D[1],
      A = tt(e.useState(!1), 2),
      O = A[0],
      M = A[1],
      B = tt(e.useState(!1), 2),
      z = B[0],
      W = B[1],
      R = tt(e.useState("Enter security code"), 2),
      V = R[0],
      j = R[1],
      H = tt(e.useState(), 2),
      U = H[0],
      q = H[1],
      K = tt(e.useState(), 2),
      J = K[0],
      $ = K[1],
      Y = tt(e.useState(), 2),
      G = Y[0],
      Z = Y[1],
      X = tt(e.useState(!1), 2),
      Q = X[0],
      ee = X[1];

  a(function () {
    Ge(Je().mark(function e() {
      var t, a, n, r;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, M(!0), e.next = 4, ca.createPaymentIntent(i, o._id, s, c, d, u);

            case 4:
              if (t = e.sent, q(t.data.clientSecret), $(t.data.mongoPayment), !t.data.mongoPayment) {
                e.next = 12;
                break;
              }

              return e.next = 10, da.addCustomer(i, t.data.mongoPayment.intentId, {
                customerEmail: p,
                customerName: f,
                customerPhone: v,
                customerSurname: g
              });

            case 10:
              a = e.sent, Z(a.data.customerId);

            case 12:
              e.next = 18;
              break;

            case 14:
              e.prev = 14, e.t0 = e.catch(0), console.log(e.t0), 422 === (null === (n = e.t0.response) || void 0 === n ? void 0 : n.status) && 1018 === (null === (r = e.t0.response) || void 0 === r || null === (r = r.data) || void 0 === r ? void 0 : r.code) ? (x("pageOutOfDate"), l(!0)) : (x("pageOutOfOrder"), l(!0));

            case 18:
              return e.prev = 18, M(!1), e.finish(18);

            case 21:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 14, 18, 21]]);
    }))();
  }, []);

  var te = function () {
    var e = Ge(Je().mark(function e() {
      var t;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (C && E) {
                e.next = 2;
                break;
              }

              return e.abrupt("return");

            case 2:
              return e.prev = 2, W(!0), e.next = 6, C.confirmCardPayment(U, {
                payment_method: n,
                payment_method_options: {
                  card: {
                    cvc: E.getElement(ze)
                  }
                }
              });

            case 6:
              (t = e.sent).error ? "card_declined" === t.error.code || h - 1 == 0 ? (y(n, !0), ee(!0)) : (L(!0), j("Enter a valid security code"), b(--h)) : t.paymentIntent && r({
                customerId: G,
                paymentId: J._id,
                pi: J.intentId
              }), e.next = 13;
              break;

            case 10:
              e.prev = 10, e.t0 = e.catch(2), console.log(e.t0);

            case 13:
              return e.prev = 13, W(!1), e.finish(13);

            case 16:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[2, 10, 13, 16]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }();

  return e.createElement(N, {
    container: !0,
    className: w.popUp,
    style: {
      marginTop: "15px"
    }
  }, O ? e.createElement(_, {
    className: w.backdrop,
    open: !0
  }, e.createElement(T, {
    className: w.white
  })) : Q ? e.createElement(e.Fragment, null, e.createElement("div", {
    className: w.errorIconContainer
  }, e.createElement(je, {
    className: w.errorIcon
  })), e.createElement(N, {
    item: !0,
    xs: 12
  }, e.createElement("p", {
    className: w.descriptionFont
  }, "Your card was declined. You can try a different card or contact the card issuer for more information.")), e.createElement(N, {
    xs: 12,
    item: !0,
    className: w.buttonsContainerModal
  }, e.createElement(F, {
    className: w.confirmButtonModal,
    variant: "contained",
    size: "medium",
    onClick: function onClick() {
      return l(!1);
    }
  }, "Ok"))) : e.createElement(e.Fragment, null, e.createElement(N, {
    item: !0,
    xs: 12
  }, e.createElement(m, {
    fullWidth: !0,
    value: S,
    className: "".concat(w.paymentLabelModal, " ").concat(V && P && w.inputError),
    onChange: function onChange(e) {
      I(e.empty ? "" : " ");
    },
    label: "Security code *",
    size: "small",
    variant: "outlined",
    onFocus: function onFocus() {
      return L(!1);
    },
    onBlur: function onBlur() {
      L(!!V);
    },
    helperText: P && V && e.createElement("p", {
      className: w.mobileHelperText
    }, V),
    InputProps: {
      inputComponent: ze
    },
    inputProps: {
      className: w.cardNumberElement,
      onChange: function onChange(e) {
        "cardCvc" === e.elementType && (e.complete ? j("") : (e.error, j("Enter security code")));
      },
      options: {
        placeholder: ""
      }
    }
  })), e.createElement(N, {
    xs: 12,
    item: !0,
    className: w.buttonsContainerModal
  }, e.createElement(F, {
    className: w.cancelButtonModal,
    variant: "contained",
    size: "medium",
    onClick: function onClick() {
      return l(!1);
    }
  }, "Cancel"), e.createElement(F, {
    disabled: V,
    className: w.confirmButtonModal,
    variant: "contained",
    size: "medium",
    onClick: function onClick() {
      return te();
    }
  }, z ? e.createElement(T, {
    size: 24,
    color: "inherit"
  }) : "Continue"))));
}

function Pa(a) {
  var n = a.phone,
      r = a.setShowModal,
      l = a.handleContinue,
      i = a.getCustomerList,
      o = a.dumpsterPlacement,
      s = a.apolloURL,
      c = a.customerId,
      d = a.popUpClass,
      u = a.setPopUpClass,
      m = wa(),
      p = tt(t(!1), 2),
      f = p[0],
      v = p[1],
      g = tt(t(""), 2),
      h = g[0],
      b = g[1],
      y = tt(t(!1), 2),
      x = y[0],
      C = y[1],
      E = tt(t(!1), 2),
      w = E[0],
      k = E[1],
      S = function () {
    var e = Ge(Je().mark(function e() {
      var t;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, k(!0), t = null == n ? void 0 : n.replace(/ /g, "").replace(/-/g, "").replace("(", "").replace(")", ""), e.next = 5, da.generateCode(s, {
                customerId: c,
                phone: t
              });

            case 5:
              e.sent, u("verify"), C(!1), e.next = 14;
              break;

            case 10:
              e.prev = 10, e.t0 = e.catch(0), 1039 !== e.t0.response.data.code && 1044 !== e.t0.response.data.code || (C(!1), u("verifyFail")), 429 === e.t0.response.status && (C(!0), u("verifyFail"));

            case 14:
              return e.prev = 14, k(!1), e.finish(14);

            case 17:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 10, 14, 17]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      I = function () {
    var e = Ge(Je().mark(function e() {
      var t, a;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, da.validateCode(s, {
                customerId: c,
                code: h
              });

            case 3:
              a = e.sent, null !== (t = a.data) && void 0 !== t && t.hash ? (v(!1), localStorage.setItem("Customer", JSON.stringify({
                phone: n
              })), Qt.defaults.headers.common.hashcode = a.data.hash, i() && (r(!1), u("welcome"), l(o ? "panel1" : "panel2"))) : v(!0), e.next = 11;
              break;

            case 7:
              e.prev = 7, e.t0 = e.catch(0), console.log(e.t0), 1041 === e.t0.response.data.code && v(!0);

            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 7]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      D = function D() {
    r(!1), u("welcome"), l(o ? "panel1" : "panel2");
  };

  return e.createElement(N, {
    container: !0,
    className: m.popUp
  }, function () {
    switch (d) {
      case "welcome":
        return e.createElement(e.Fragment, null, e.createElement(N, {
          item: !0,
          xs: 12
        }, e.createElement("p", {
          className: m.descriptionFont
        }, "It looks like you've booked before. Continue as ", n, " to speed up your checkout.")), e.createElement(N, {
          xs: 12,
          item: !0,
          className: m.verifyButtons
        }, e.createElement(F, {
          disabled: w,
          className: m.confirmButtonModal,
          variant: "contained",
          size: "medium",
          onClick: S
        }, w ? e.createElement(T, {
          size: 24,
          color: "inherit"
        }) : e.createElement("b", null, "Continue as ", n)), e.createElement(F, {
          className: m.cancelButtonModal,
          variant: "contained",
          size: "medium",
          onClick: D
        }, "Continue as a guest")));

      case "verify":
        return e.createElement(N, {
          item: !0,
          xs: 12
        }, e.createElement("div", {
          className: m.verifyContainer
        }, e.createElement("p", {
          className: m.verifyFont
        }, "Enter the 6-digit verification code we just sent by text message."), e.createElement(He, {
          length: 6,
          placeholder: "-",
          value: h,
          onChange: function onChange(e) {
            return b(e);
          }
        }), f && e.createElement("p", {
          className: m.mobileHelperText
        }, "This code is incorrect or it has expired. Please try again."), e.createElement(F, {
          disabled: (null == h ? void 0 : h.includes("-")) || (null == h ? void 0 : h.length) < 6,
          className: m.confirmButtonModal,
          style: {
            minWidth: "200px"
          },
          variant: "contained",
          size: "medium",
          onClick: I
        }, "Continue"), e.createElement("br", null), e.createElement("div", {
          className: m.verifyContainer
        }, e.createElement("p", {
          className: m.verifyFont
        }, "Didn't receive the code?"), e.createElement(F, {
          onClick: S,
          className: m.verifyAgain
        }, "Send code again"))));

      case "verifyFail":
        return e.createElement(e.Fragment, null, e.createElement(N, {
          item: !0,
          xs: 12
        }, e.createElement("div", {
          className: m.errorIconContainer
        }, e.createElement(je, {
          className: m.errorIcon
        }), e.createElement("p", {
          className: m.descriptionFont
        }, x ? "You've reached the limit on verification attempts." : "Our verification text message to your number was not delivered for some reason."))), e.createElement(N, {
          xs: 12,
          item: !0,
          className: m.verifyButtons
        }, e.createElement(F, {
          className: m.confirmButtonModal,
          variant: "contained",
          size: "medium",
          onClick: D
        }, "Continue as a guest")));

      case "expired":
        return e.createElement(e.Fragment, null, e.createElement(N, {
          item: !0,
          xs: 12
        }, e.createElement("p", {
          className: m.descriptionFont
        }, "The code you entered has expired.")), e.createElement(N, {
          xs: 12,
          item: !0,
          className: m.verifyButtons
        }, e.createElement(F, {
          className: m.confirmButtonModal,
          variant: "contained",
          size: "medium",
          onClick: S
        }, "Send a new code"), e.createElement(F, {
          className: m.cancelButtonModal,
          variant: "contained",
          size: "medium",
          onClick: D
        }, "Continue as a guest")));
    }
  }());
}

function La(a) {
  var n = wa(),
      r = a.modalCode,
      l = a.changeShowModal,
      i = a.showModal,
      o = a.setShowModal,
      s = {},
      c = a.stripeApiKey && Re(a.stripeApiKey),
      d = tt(t({
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      borderRadius: "10px",
      border: "none",
      backgroundColor: "#FFFFFF",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "0px 20px",
      minHeight: "fit-content !important",
      width: "500px"
    }
  }), 2),
      u = d[0];
  d[1];

  var m = function m() {
    o(!1), window.location.reload();
  },
      p = function p() {
    l(), a.setPopUpClass("welcome");
  };

  return e.createElement(Ve, {
    id: "online-booking-checkout",
    isOpen: i,
    style: u,
    contentLabel: "",
    shouldCloseOnOverlayClick: !1,
    preventScroll: !0,
    ariaHideApp: !1
  }, function () {
    switch (r) {
      case "security":
        var t,
            i,
            d,
            u,
            f = null === (t = a.customerList) || void 0 === t ? void 0 : t.find(function (e) {
          return e.id === a.selectedCard;
        });
        return e.createElement(e.Fragment, null, e.createElement("div", {
          className: "modal-header"
        }, e.createElement("p", {
          className: n.titleModal
        }, (null == f || null === (i = f.brand) || void 0 === i ? void 0 : i.charAt(0).toUpperCase()) + (null == f || null === (d = f.brand) || void 0 === d ? void 0 : d.slice(1)), " ...", null == f ? void 0 : f.last4), e.createElement("button", {
          type: "button",
          className: "close closermodal",
          onClick: l,
          "aria-label": "Close"
        }, e.createElement("span", {
          "aria-hidden": "true"
        }, "×"))), e.createElement("div", {
          className: "modal-container"
        }, e.createElement(N, {
          item: !0,
          xs: 12
        }, e.createElement("p", {
          className: n.descriptionFont
        }, "Please enter the 3- or 4-digit security code for this card.")), e.createElement(We, {
          stripe: c,
          options: s
        }, e.createElement(Ta, {
          cardId: a.selectedCard,
          handleCheckoutFinishWithPayment: a.handleCheckoutFinishWithPayment,
          setShowModal: o,
          service: a.service,
          apolloURL: a.apolloURL,
          proId: a.proId,
          fromDate: a.fromDate,
          toDate: a.toDate,
          placeId: a.placeId,
          customerEmail: a.email,
          customerName: a.name,
          customerPhone: null === (u = a.mobilePhone) || void 0 === u ? void 0 : u.replace(/ /g, "").replace(/-/g, "").replace("(", "").replace(")", ""),
          customerSurname: a.lastname,
          count: a.count,
          setCount: a.setCount,
          removeCard: a.removeCard,
          changeShowModal: l
        }))));

      case "goBack":
        return e.createElement(e.Fragment, null, e.createElement("div", {
          className: "modal-header"
        }, e.createElement("p", {
          className: n.titleModal
        }, "You're almost there!"), e.createElement("button", {
          type: "button",
          className: "close closermodal",
          onClick: l,
          "aria-label": "Close"
        }, e.createElement("span", {
          "aria-hidden": "true"
        }, "×"))), e.createElement("div", {
          className: "modal-container"
        }, e.createElement(N, {
          container: !0,
          className: n.popUp
        }, e.createElement(N, {
          item: !0,
          xs: 12
        }, e.createElement("p", {
          className: n.descriptionFont
        }, "You'll have to start over if you leave")), e.createElement(N, {
          xs: 12,
          item: !0,
          className: n.buttonsContainerModal
        }, e.createElement(F, {
          className: n.cancelButtonModal,
          variant: "contained",
          size: "medium",
          onClick: function onClick() {
            return a.handleBack({
              name: a.name,
              lastname: a.lastname,
              mobilePhone: a.mobilePhone,
              email: a.email,
              dumpsterPlacement: a.dumpsterPlacement,
              customerList: a.customerList,
              customerId: a.customerId
            });
          }
        }, "Leave anyway"), e.createElement(F, {
          className: n.confirmButtonModal,
          variant: "contained",
          size: "medium",
          onClick: function onClick() {
            return o(!1);
          }
        }, "Keep checking out")))));

      case "removeCard":
        return e.createElement(e.Fragment, null, e.createElement("div", {
          className: "modal-header"
        }, e.createElement("p", {
          className: n.titleModal
        }, "Delete this card?"), e.createElement("button", {
          type: "button",
          className: "close closermodal",
          onClick: l,
          "aria-label": "Close"
        }, e.createElement("span", {
          "aria-hidden": "true"
        }, "×"))), e.createElement("div", {
          className: "modal-container"
        }, e.createElement(N, {
          container: !0
        }, e.createElement(N, {
          xs: 12,
          item: !0,
          className: n.buttonsContainerModal
        }, e.createElement(F, {
          className: n.cancelButtonModal,
          variant: "contained",
          size: "medium",
          onClick: function onClick() {
            return o(!1);
          }
        }, "Cancel"), e.createElement(F, {
          className: n.confirmButtonModal,
          variant: "contained",
          size: "medium",
          onClick: function onClick() {
            return a.removeCard(a.cardToRemove);
          }
        }, "Continue")))));

      case "declinedCard":
        return e.createElement(e.Fragment, null, e.createElement("div", {
          className: "modal-header"
        }, e.createElement("p", {
          className: n.titleModal
        }, "Your card was declined."), e.createElement("button", {
          type: "button",
          className: "close closermodal",
          onClick: l,
          "aria-label": "Close"
        }, e.createElement("span", {
          "aria-hidden": "true"
        }, "×"))), e.createElement("div", {
          className: "modal-container"
        }, e.createElement(N, {
          container: !0,
          className: n.popUp
        }, e.createElement(N, {
          item: !0,
          xs: 12
        }, e.createElement("p", {
          className: n.descriptionFont
        }, "You can try a different card or contact the card issuer for more information.")), e.createElement(N, {
          xs: 12,
          item: !0,
          className: n.buttonsContainerModal
        }, e.createElement(F, {
          className: n.confirmButtonModal,
          variant: "contained",
          size: "medium",
          onClick: function onClick() {
            return o(!1);
          }
        }, "Ok")))));

      case "declinedPayment":
        return e.createElement(e.Fragment, null, e.createElement("div", {
          className: "modal-header"
        }, e.createElement("p", {
          className: n.titleModal
        }, "Something went wrong"), e.createElement("button", {
          type: "button",
          className: "close closermodal",
          onClick: l,
          "aria-label": "Close"
        }, e.createElement("span", {
          "aria-hidden": "true"
        }, "×"))), e.createElement("div", {
          className: "modal-container"
        }, e.createElement(N, {
          container: !0,
          className: n.popUp
        }, e.createElement("div", {
          className: n.errorIconContainer
        }, e.createElement(je, {
          className: n.errorIcon
        })), e.createElement(N, {
          item: !0,
          xs: 12
        }, e.createElement("p", {
          className: n.descriptionFont,
          style: {
            textAlign: "center"
          }
        }, "Please try again.")), e.createElement(N, {
          xs: 12,
          item: !0,
          className: n.buttonsContainerModal
        }, e.createElement(F, {
          className: n.confirmButtonModal,
          variant: "contained",
          size: "medium",
          onClick: function onClick() {
            return o(!1);
          }
        }, "Ok")))));

      case "verificationCode":
        return e.createElement(e.Fragment, null, e.createElement("div", {
          className: "modal-header"
        }, e.createElement("p", {
          className: n.titleModal
        }, function () {
          switch (a.popUpClass) {
            case "welcome":
              return "Welcome back!";

            case "verify":
              return "Verify its you";

            case "verifyFail":
              return "Verification failed";

            case "expired":
              return "Expired verification code";
          }
        }()), e.createElement("button", {
          type: "button",
          className: "close closermodal",
          onClick: p,
          "aria-label": "Close"
        }, e.createElement("span", {
          "aria-hidden": "true"
        }, "×"))), e.createElement("div", {
          className: "modal-container"
        }, e.createElement(Pa, {
          phone: a.mobilePhone,
          setShowModal: o,
          handleContinue: a.handleChange,
          dumpsterPlacement: a.dumpsterPlacement,
          getCustomerList: a.getCustomerList,
          apolloURL: a.apolloURL,
          customerId: a.customerId,
          setPopUpClass: a.setPopUpClass,
          popUpClass: a.popUpClass
        })));

      case "pageOutOfDate":
        return e.createElement(e.Fragment, null, e.createElement("div", {
          className: "modal-header"
        }, e.createElement("p", {
          className: n.titleModal
        }, "This page is out of date"), e.createElement("button", {
          type: "button",
          className: "close closermodal",
          onClick: a.handleClose,
          "aria-label": "Close"
        }, e.createElement("span", {
          "aria-hidden": "true"
        }, "×"))), e.createElement("div", {
          className: "modal-container"
        }, e.createElement("div", {
          className: n.errorIconContainer
        }, e.createElement(je, {
          className: n.errorIcon
        })), e.createElement(N, {
          item: !0,
          xs: 12
        }, e.createElement("p", {
          className: n.descriptionFont
        }, "Please refresh this page to get the latest."), e.createElement("br", null), e.createElement("div", {
          className: n.verifyContainer
        }, e.createElement(F, {
          className: n.confirmButtonModal,
          variant: "contained",
          size: "medium",
          onClick: a.handleClose ? a.handleClose : m()
        }, "Refresh")))));

      case "pageOutOfOrder":
        return e.createElement(e.Fragment, null, e.createElement("div", {
          className: "modal-header"
        }, e.createElement("p", {
          className: n.titleModal
        }, "Something went wrong"), e.createElement("button", {
          type: "button",
          className: "close closermodal",
          onClick: m,
          "aria-label": "Close"
        }, e.createElement("span", {
          "aria-hidden": "true"
        }, "×"))), e.createElement("div", {
          className: "modal-container"
        }, e.createElement("div", {
          className: n.errorIconContainer
        }, e.createElement(je, {
          className: n.errorIcon
        })), e.createElement(N, {
          item: !0,
          xs: 12
        }, e.createElement("p", {
          className: n.descriptionFont
        }, "Please reload the page."), e.createElement("br", null), e.createElement("div", {
          className: n.verifyContainer
        }, e.createElement(F, {
          className: n.confirmButtonModal,
          variant: "contained",
          size: "medium",
          onClick: m
        }, "Refresh")))));
    }
  }());
}

function Aa(n) {
  var r,
      l,
      i = wa(),
      o = n.isLoadingServices,
      s = n.proId,
      c = n.pi,
      d = n.placeId,
      u = n.stripeApiKey,
      m = n.staticUrl,
      p = n.proName,
      f = n.dumpsterFor,
      g = tt(e.useState(!(n.defaultDumpsterPlacement && n.defaultName && n.defaultLastname && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(n.defaultEmail) && 14 === (null === (r = n.defaultMobilePhone) || void 0 === r ? void 0 : r.length)) && (n.defaultName && n.defaultLastname && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(n.defaultEmail) && 14 === (null === (l = n.defaultMobilePhone) || void 0 === l ? void 0 : l.length) && !n.defaultStep ? "panel2" : "panel1")), 2),
      h = g[0],
      b = g[1],
      y = tt(e.useState(n.defaultName), 2),
      x = y[0],
      C = y[1],
      E = tt(e.useState(n.defaultLastname), 2),
      w = E[0],
      S = E[1],
      I = tt(e.useState(n.defaultMobilePhone), 2),
      D = I[0],
      P = I[1],
      L = tt(e.useState(n.defaultEmail), 2),
      O = L[0],
      W = L[1],
      R = tt(e.useState(n.defaultDumpsterPlacement), 2),
      V = R[0],
      j = R[1],
      H = tt(e.useState(""), 2),
      U = H[0],
      q = H[1],
      K = tt(e.useState(""), 2),
      J = K[0],
      $ = K[1],
      Y = tt(e.useState(!1), 2),
      G = Y[0],
      Z = Y[1],
      X = tt(e.useState(n.defaultCustomerList ? n.defaultCustomerList : []), 2),
      Q = X[0],
      ee = X[1],
      te = tt(e.useState(!(!n.defaultCustomerList || !n.defaultDumpsterPlacement)), 2),
      ae = te[0],
      ne = te[1],
      re = tt(e.useState(""), 2),
      le = re[0],
      ie = re[1],
      oe = tt(e.useState(!1), 2),
      se = oe[0],
      ce = oe[1],
      de = tt(e.useState(""), 2),
      ue = de[0],
      me = de[1],
      pe = tt(e.useState(""), 2),
      fe = pe[0],
      ve = pe[1],
      ge = tt(e.useState(3), 2),
      he = ge[0],
      be = ge[1],
      ye = tt(e.useState(!!n.defaultDumpsterPlacement), 2),
      xe = ye[0],
      Ce = ye[1],
      we = tt(e.useState(n.defaultCustomerId ? n.defaultCustomerId : ""), 2),
      ke = we[0],
      Ne = we[1],
      Ie = tt(t("welcome"), 2),
      _e = Ie[0],
      Oe = Ie[1],
      Me = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
      Be = n.event;
  Be.eventDescription = "Checkout viewed";

  var ze = function ze(e) {
    e && me(e), ce(!se);
  };

  a(function () {
    window.scrollTo(0, 0);
  }, []);

  var We = function We(e) {
    var t = h !== e;
    "panel1" === e ? b(!!t && e) : "panel2" === e ? x && w && Me.test(O) && 14 === (null == D ? void 0 : D.length) ? (x || w || Me.test(O) || null == D || D.length, b(!!t && e)) : b("panel1") : "panel3" === e && (x && w && Me.test(O) && 14 === (null == D ? void 0 : D.length) ? b(V ? !!t && e : "panel2") : b("panel1"));
  },
      Re = function () {
    var e = Ge(Je().mark(function e() {
      var t, a, r, l, i;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, r = null == D ? void 0 : D.replace(/ /g, "").replace(/-/g, "").replace("(", "").replace(")", ""), e.next = 4, da.checkCustomer(n.apolloURL, r);

            case 4:
              return l = e.sent, null !== (t = l.data) && void 0 !== t && t.customerFound ? Ne(null === (i = l.data) || void 0 === i ? void 0 : i.customerId) : (Ne(""), ee([])), e.abrupt("return", null === (a = l.data) || void 0 === a ? void 0 : a.customerFound);

            case 9:
              e.prev = 9, e.t0 = e.catch(0), console.log(e.t0);

            case 12:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 9]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      Ve = function () {
    var e = Ge(Je().mark(function e() {
      var t, a, r;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, da.getCustomerList(n.apolloURL, ke);

            case 3:
              if (a = e.sent, null === (t = a.data) || void 0 === t || !t.customerFound) {
                e.next = 11;
                break;
              }

              return r = a.data.paymentMethods.map(function (e) {
                return {
                  id: e.paymentMethodId,
                  brand: e.brand,
                  last4: e.last4,
                  expiration: "".concat(e.expirationMonth / 10 > 1 ? e.expirationMonth : "0" + e.expirationMonth, "/").concat(e.expirationYear),
                  attachedMethod: !0
                };
              }), ee(r), (null == r ? void 0 : r.length) > 0 ? ie(r[0].id) : ie(""), e.abrupt("return", !0);

            case 11:
              ee([]), ie("");

            case 13:
              e.next = 18;
              break;

            case 15:
              e.prev = 15, e.t0 = e.catch(0), 1042 === e.t0.response.data.code && (ee([]), ie(""), delete Qt.defaults.headers.common.hashcode, Oe("expired"), ze("verificationCode"), ce(!0));

            case 18:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 15]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      je = function je(e) {
    var t = "".concat(m.split("assets")[0], "images/icons/payment-cards/generic.png");

    switch (e) {
      case "visa":
        t = "".concat(m.split("assets")[0], "images/icons/payment-cards/visa.png");
        break;

      case "mastercard":
        t = "".concat(m.split("assets")[0], "images/icons/payment-cards/master.png");
        break;

      case "amex":
        t = "".concat(m.split("assets")[0], "images/icons/payment-cards/american.png");
        break;

      case "discover":
        t = "".concat(m.split("assets")[0], "images/icons/payment-cards/discover.png");
    }

    return t;
  },
      He = function () {
    var e = Ge(Je().mark(function e(t, a) {
      var r, l, i, o;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, !(l = null == Q || null === (r = Q.find(function (e) {
                return e.id === t;
              })) || void 0 === r ? void 0 : r.attachedMethod)) {
                e.next = 9;
                break;
              }

              return e.next = 5, ca.deleteCard(n.apolloURL, {
                methodId: t,
                customerId: ke
              });

            case 5:
              e.sent.data && (i = Q.filter(function (e) {
                return e.id !== t;
              }), ee(i), le === t && ie("")), e.next = 10;
              break;

            case 9:
              !1 === l && (o = Q.filter(function (e) {
                return e.id !== t;
              }), ee(o), le === t && ie(""));

            case 10:
              a || ce(!1), e.next = 17;
              break;

            case 13:
              e.prev = 13, e.t0 = e.catch(0), console.log(e.t0), 1042 === e.t0.response.data.code && (ee([]), ie(""), delete Qt.defaults.headers.common.hashcode, Oe("expired"), ze("verificationCode"), ce(!0));

            case 17:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 13]]);
    }));
    return function (t, a) {
      return e.apply(this, arguments);
    };
  }(),
      Ue = function Ue(e) {
    var t = new Date(e);
    return new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate())).toISOString();
  },
      qe = function () {
    var e = Ge(Je().mark(function e(t) {
      var a;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, Z(!0), ce(!1), e.next = 5, ca.completeCheckout(n.apolloURL, {
                jobData: {
                  customerId: t.customerId,
                  customerEmail: O,
                  addressData: {
                    address: n.addressData.street,
                    address2: n.addressData.street2,
                    address_id: n.addressData.place_id,
                    city: n.addressData.locality,
                    instructions: V,
                    state: n.addressData.state,
                    zip: n.addressData.postal_code,
                    place: d
                  },
                  placeId: d,
                  proId: s,
                  proName: p,
                  phone: null == D ? void 0 : D.replace(/ /g, "").replace(/-/g, "").replace("(", "").replace(")", ""),
                  startDate: Ue(n.fromDate),
                  endDate: Ue(n.toDate),
                  serviceId: n.service._id,
                  debrisValue: Array.isArray(n.selectedWasteType) ? n.selectedWasteType[0] : n.selectedWasteType,
                  debrisLabel: n.selectedWasteTypeLabel,
                  pageSource: "undefined" != typeof window ? window.location.pathname + window.location.search : "-",
                  dumpsterFor: f
                },
                paymentId: t.paymentId,
                intentId: t.pi,
                availabilityRequestId: n.availabilityRequestId,
                event: Ke(Ke({}, Be), {}, {
                  eventDescription: "Booking Requested"
                })
              });

            case 5:
              (a = e.sent).data && n.handleContinue(a.data.jobRequestId), e.next = 15;
              break;

            case 9:
              e.prev = 9, e.t0 = e.catch(0), console.log(e.t0), Z(!1), ze("declinedPayment"), ce(!0);

            case 15:
              return e.prev = 15, Z(!1), e.finish(15);

            case 18:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 9, 15, 18]]);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }(),
      $e = function () {
    var e = Ge(Je().mark(function e() {
      var t, a, r, l, i, o;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, Z(!0), e.next = 4, ca.addFullCheckout(n.apolloURL, {
                jobData: {
                  addressData: {
                    address: n.addressData.street,
                    address2: n.addressData.street2,
                    address_id: n.addressData.place_id,
                    city: n.addressData.locality,
                    instructions: V,
                    state: n.addressData.state,
                    zip: n.addressData.postal_code,
                    place: d
                  },
                  placeId: d,
                  proId: s,
                  proName: p,
                  phone: null == D ? void 0 : D.replace(/ /g, "").replace(/-/g, "").replace("(", "").replace(")", ""),
                  startDate: Ue(n.fromDate),
                  endDate: Ue(n.toDate),
                  serviceId: n.service._id,
                  debrisValue: Array.isArray(n.selectedWasteType) ? n.selectedWasteType[0] : n.selectedWasteType,
                  debrisLabel: n.selectedWasteTypeLabel,
                  pageSource: "undefined" != typeof window ? window.location.pathname + window.location.search : "-",
                  dumpsterFor: f
                },
                customerData: {
                  customerEmail: O,
                  customerName: x,
                  customerSurname: w,
                  customerPhone: null == D ? void 0 : D.replace(/ /g, "").replace(/-/g, "").replace("(", "").replace(")", "")
                },
                methodData: {
                  methodId: le,
                  attachedMethod: null === (t = Q.find(function (e) {
                    return e.id === le;
                  })) || void 0 === t ? void 0 : t.attachedMethod
                },
                event: Ke(Ke({}, Be), {}, {
                  eventDescription: "Booking Requested"
                }),
                availabilityRequestId: n.availabilityRequestId
              });

            case 4:
              (a = e.sent).data && n.handleContinue(a.data.jobRequestId), e.next = 12;
              break;

            case 8:
              e.prev = 8, e.t0 = e.catch(0), Z(!1), 422 === (null === (r = e.t0.response) || void 0 === r ? void 0 : r.status) && 2005 === (null === (l = e.t0.response.data) || void 0 === l ? void 0 : l.code) ? (ze("declinedCard"), ce(!0)) : 422 === (null === (i = e.t0.response) || void 0 === i ? void 0 : i.status) && 1018 === (null === (o = e.t0.response.data) || void 0 === o ? void 0 : o.code) ? (ze("pageOutOfDate"), ce(!0)) : (ze("declinedPayment"), ce(!0));

            case 12:
              return e.prev = 12, Z(!1), e.finish(12);

            case 15:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 8, 12, 15]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }();

  return e.createElement(e.Fragment, null, e.createElement(N, {
    container: !0,
    direction: "row"
  }, o ? e.createElement(_, {
    className: i.backdrop,
    open: !0
  }, e.createElement(T, {
    className: i.white
  })) : e.createElement(e.Fragment, null, e.createElement("div", {
    className: i.headerContainerColor
  }, e.createElement(A, {
    className: i.backButtonColor,
    onClick: function onClick() {
      return ze("goBack");
    }
  }, e.createElement(Ee, null)), e.createElement("p", {
    className: i.fontHeaderColor
  }, "Checkout")), e.createElement(La, {
    modalCode: ue,
    changeShowModal: ze,
    showModal: se,
    stripeApiKey: u,
    selectedCard: le,
    handleCheckoutFinishWithPayment: qe,
    setShowModal: ce,
    service: n.service,
    apolloURL: n.apolloURL,
    proId: s,
    fromDate: n.fromDate,
    toDate: n.toDate,
    placeId: d,
    email: O,
    name: x,
    mobilePhone: D,
    lastname: w,
    count: he,
    setCount: be,
    removeCard: He,
    handleBack: n.handleBack,
    dumpsterPlacement: V,
    customerList: Q,
    cardToRemove: fe,
    handleChange: We,
    getCustomerList: Ve,
    customerId: ke,
    setPopUpClass: Oe,
    popUpClass: _e
  }), e.createElement(N, {
    item: !0,
    className: i.detailContainer
  }, e.createElement(M, {
    expanded: "panel1" === h,
    className: i.accordionContainer
  }, e.createElement(B, {
    "aria-controls": "panel1bh-content",
    id: "panel1bh-header",
    className: i.accordionSummary
  }, e.createElement(N, {
    container: !0,
    justifyContent: "space-between"
  }, e.createElement(k, {
    className: "".concat(i.descriptionFont, " ").concat(i.titleCheckoutFont)
  }, "1. Contact"), x && w && Me.test(O) && 14 === (null == D ? void 0 : D.length) && "panel1" !== h ? e.createElement(Fe, {
    className: i.checkedIcon
  }) : e.createElement(De, null)), x && w && Me.test(O) && 14 === (null == D ? void 0 : D.length) && "panel1" !== h && e.createElement(e.Fragment, null, e.createElement("br", null), e.createElement("div", {
    className: i.contactSummaryContainer
  }, e.createElement("div", {
    className: i.contactSummary
  }, e.createElement("p", {
    className: i.contactText
  }, x, " ", w), e.createElement("p", {
    className: i.contactText
  }, D), e.createElement("p", {
    className: i.contactText
  }, O)), e.createElement("div", null, e.createElement("button", {
    onClick: function onClick() {
      return We("panel1");
    },
    className: i.editButton
  }, "Edit"))))), e.createElement(z, null, e.createElement(Sa, {
    handleFirstNameChange: function handleFirstNameChange(e) {
      C(e.target.value);
    },
    handleLastnameChange: function handleLastnameChange(e) {
      S(e.target.value);
    },
    handleMobilePhoneChange: function handleMobilePhoneChange(e) {
      var t = "",
          a = e.target.value.replace(/[^0-9]/g, "");
      "1" === a[0] && (a = "");
      var n = a.substr(0, 3),
          r = a.substr(3, 3),
          l = a.substr(6, 4);
      0 === n.length ? t = "" : n.length < 3 ? t = "(" + n : 3 == n.length && r.length < 3 ? t = "(" + n + ") " + r : 3 == n.length && 3 == r.length && (t = "(" + n + ") " + r + "-" + l), P(t), 0 === t.length ? q("Please enter your mobile phone number") : 14 !== t.length ? q("Enter a 10 digit number starting with the area code") : q("");
    },
    handleEmailChange: function handleEmailChange(e) {
      W(e.target.value), Me.test(e.target.value) ? $("") : $("Enter a valid email");
    },
    name: x,
    lastname: w,
    mobilePhone: D,
    email: O,
    error: U,
    dumpsterPlacement: V,
    emailError: J,
    handleContinue: We,
    getCustomerList: Ve,
    getCustomer: Re,
    changeShowModal: ze,
    setCustomerList: ee,
    setSelectedCard: ie
  }))), e.createElement(M, {
    expanded: "panel2" === h,
    className: i.accordionContainer
  }, e.createElement(B, {
    "aria-controls": "panel2bh-content",
    id: "panel2bh-header",
    className: i.accordionSummary
  }, e.createElement(N, {
    container: !0,
    justifyContent: "space-between"
  }, e.createElement(k, {
    className: "".concat(i.descriptionFont, " ").concat(i.titleCheckoutFont)
  }, "2. Delivery instructions"), V && "panel2" !== h ? e.createElement(Fe, {
    className: i.checkedIcon
  }) : e.createElement(De, null)), V && "panel2" !== h && e.createElement(e.Fragment, null, e.createElement("br", null), e.createElement("div", {
    className: i.contactSummaryContainer
  }, e.createElement("div", {
    className: i.contactSummary
  }, e.createElement("p", {
    className: i.contactText
  }, (null == V ? void 0 : V.length) > 100 ? (null == V ? void 0 : V.substring(0, 100)) + "..." : V)), e.createElement("div", null, e.createElement("button", {
    onClick: function onClick() {
      return We("panel2");
    },
    className: i.editButton
  }, "Edit"))))), e.createElement(z, null, e.createElement(Ia, {
    deliveryDate: n.fromDate,
    handleDumpsterPlacementChange: function handleDumpsterPlacementChange(e) {
      j(e.target.value);
    },
    dumpsterPlacement: V,
    handleContinue: We,
    setIsShowingCards: ne,
    customerList: Q,
    setIsContinuePress: Ce
  }))), e.createElement(M, {
    expanded: "panel3" === h,
    className: i.accordionContainer
  }, e.createElement(B, {
    "aria-controls": "panel3bh-content",
    id: "panel3bh-header",
    className: i.accordionSummary
  }, e.createElement(N, {
    container: !0,
    justifyContent: "space-between"
  }, e.createElement(k, {
    className: "".concat(i.descriptionFont, " ").concat(i.titleCheckoutFont)
  }, "3. Debit or credit card"), x && w && V && Me.test(O) && 14 === (null == D ? void 0 : D.length) && le && ae && "panel3" !== h ? e.createElement(Fe, {
    className: i.checkedIcon
  }) : e.createElement(De, null)), x && w && V && Me.test(O) && 14 === (null == D ? void 0 : D.length) && ae && e.createElement(e.Fragment, null, e.createElement("br", null), Q.length > 0 && Q.map(function (t, a) {
    return e.createElement("div", {
      key: t.id,
      className: "".concat(i.contactSummaryContainer, " ").concat(i.alignCard)
    }, e.createElement("div", {
      className: i.cardInfo,
      onClick: function onClick() {
        return ie(t.id);
      }
    }, e.createElement(v, {
      className: i.checkboxContainer,
      icon: e.createElement(Pe, null),
      checkedIcon: e.createElement(Le, {
        className: i.checkedButton
      }),
      defaultChecked: !1,
      checked: le === t.id
    }), e.createElement("img", {
      src: je(t.brand),
      className: i.cardIcon,
      alt: "card".concat(a)
    }), " ", e.createElement("div", {
      className: i.contactSummaryCard
    }, e.createElement("p", {
      className: i.contactText
    }, "Card ...", t.last4), e.createElement("p", {
      className: i.contactText
    }, "Expires ", t.expiration))), e.createElement("div", null, e.createElement(Ae, {
      className: i.removeCard,
      color: "secondary",
      onClick: function onClick() {
        ve(t.id), ze("removeCard");
      }
    })));
  }), e.createElement("br", null), e.createElement("div", {
    className: i.addCardContainer
  }, e.createElement(F, {
    startIcon: e.createElement(Te, null),
    onClick: function onClick() {
      ne(!1), We("panel3");
    },
    className: i.addCard
  }, "Add a new card")))), e.createElement(z, null, e.createElement("div", {
    className: i.paymentFormContainer
  }, "panel3" === h && e.createElement(Fa, {
    googlePlaceAutocompleteApiKey: n.googlePlaceAutocompleteApiKey,
    pi: c,
    customerName: x,
    customerLastname: w,
    customerEmail: O,
    customerPhone: null == D ? void 0 : D.replace(/ /g, "").replace(/-/g, "").replace("(", "").replace(")", ""),
    apolloURL: n.apolloURL,
    defaultAddress: n.addressData,
    stripeApiKey: u,
    handleContinue: We,
    setIsShowingCards: ne,
    addCustomerList: function addCustomerList(e) {
      if (e) {
        var t = Q;
        t.unshift(e), ee(t), ie(e.id);
      }
    }
  }))))), e.createElement(N, {
    item: !0,
    className: i.pricingContainer,
    style: {
      marginBottom: "20px"
    }
  }, e.createElement(N, {
    container: !0,
    style: {
      gap: "10px"
    }
  }, e.createElement(N, {
    xs: 12,
    item: !0
  }, e.createElement(N, {
    container: !0,
    alignItems: "center"
  }, e.createElement(Se, {
    className: i.marginRightSmall
  }), e.createElement(k, {
    variant: "subtitle1",
    className: i.descriptionFont
  }, "Secure checkout"))), e.createElement(N, {
    xs: 12,
    item: !0,
    style: {
      paddingTop: "8px"
    }
  }, e.createElement(ka, {
    startDate: n.fromDate,
    endDate: n.toDate,
    placeId: d,
    proId: s,
    additionalPeriodsAmount: n.getAditionalPeriodsAmount(),
    extraPeriodCost: n.service.details[1].extraPeriodCost,
    serviceId: n.service._id,
    apolloURL: n.apolloURL,
    serviceDescription: n.serviceDescription,
    setModalCode: me,
    setShowModal: ce,
    event: Be
  })), e.createElement(N, {
    xs: 12,
    item: !0,
    style: {
      paddingTop: "8px"
    }
  }, e.createElement(F, {
    onClick: function onClick() {
      var e;
      return null != Q && null !== (e = Q.find(function (e) {
        return e.id === le;
      })) && void 0 !== e && e.attachedMethod ? ze("security") : $e();
    },
    className: i.accentBookableColor,
    size: "large",
    variant: "contained",
    fullWidth: !0,
    disabled: !x || !w || !Me.test(O) || 14 !== (null == D ? void 0 : D.length) || !V || !le || !xe || G
  }, G ? e.createElement(T, {
    size: 24,
    color: "inherit"
  }) : e.createElement("b", null, "Place your order"))))))));
}

function _a(n) {
  var r,
      l,
      i,
      o = wa(),
      s = n.bookingId,
      c = n.proId,
      d = n.proName,
      u = n.proPhone,
      m = n.apolloURL,
      p = n.imageStaticEnv,
      f = n.backUrl,
      v = n.isError,
      g = n.gatsbyKey,
      h = tt(t(null), 2),
      b = h[0],
      y = h[1],
      x = tt(t(null), 2),
      C = x[0],
      E = x[1],
      w = tt(t(!0), 2),
      S = w[0],
      I = w[1],
      D = tt(t(null), 2),
      F = D[0],
      P = D[1],
      L = tt(t(null), 2),
      A = L[0],
      _ = L[1],
      O = tt(t(v || !1), 2),
      M = O[0],
      B = O[1],
      z = tt(t(u), 2),
      W = z[0],
      R = z[1],
      j = tt(t(d), 2),
      H = j[0],
      U = j[1],
      q = tt(t(f), 2),
      K = q[0],
      J = q[1],
      $ = tt(t(), 2);
  $[0];
  var Y = $[1];
  a(function () {
    Ge(Je().mark(function e() {
      var t, a, n, r;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, window.scrollTo(0, 0), I(!0), e.next = 5, G();

            case 5:
              if (!((t = e.sent) && t.length > 0)) {
                e.next = 20;
                break;
              }

              if (y(t[0]), a = c || t[0].jobRequestInvitations[0].pro, d && f && u) {
                e.next = 12;
                break;
              }

              return e.next = 12, Z(a);

            case 12:
              return n = new Date(new Date(t[0].startDate).toISOString().slice(0, -1)), P(n), n = new Date(new Date(t[0].endDate).toISOString().slice(0, -1)), _(n), e.next = 18, ua.getWasteTreatmentByPro(m, g, a);

            case 18:
              r = e.sent, E(r.data);

            case 20:
              e.next = 25;
              break;

            case 22:
              e.prev = 22, e.t0 = e.catch(0), console.log(e.t0);

            case 25:
              return e.prev = 25, I(!1), e.finish(25);

            case 28:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 22, 25, 28]]);
    }))();
  }, []);

  var G = function () {
    var e = Ge(Je().mark(function e() {
      var t;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, ua.getBookingById(m, s);

            case 3:
              return t = e.sent, e.abrupt("return", t.data);

            case 7:
              throw e.prev = 7, e.t0 = e.catch(0), B(!0), e.t0;

            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 7]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      Z = function () {
    var e = Ge(Je().mark(function e(t) {
      var a, n;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, pa.getDumpsterPublishedPros(m, g, t);

            case 3:
              n = e.sent, (null === (a = n.data) || void 0 === a ? void 0 : a.length) > 0 && (U(n.data[0].n), n.data[0].ph && R(Bt(n.data[0].ph)), J(n.data[0].ur), Y(n.data[0].em)), e.next = 11;
              break;

            case 7:
              throw e.prev = 7, e.t0 = e.catch(0), B(!0), e.t0;

            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 7]]);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }(),
      X = function X() {
    var e;
    return C && (null === (e = C.disallowedWaste) || void 0 === e ? void 0 : e.length) > 0;
  },
      Q = function Q() {
    var e,
        t = (null == C || null === (e = C.wasteInstructions) || void 0 === e ? void 0 : e.filter(function (e) {
      return e.id == b.debrisValue;
    })) || [];
    return t.length > 0 ? "Instructions: ".concat(t[0].instructions) : null;
  };

  return e.createElement(e.Fragment, null, S ? e.createElement(T, {
    size: 35,
    className: o.loader
  }) : e.createElement(e.Fragment, null, e.createElement(La, {
    modalCode: "pageOutOfOrder",
    showModal: M,
    setShowModal: B
  }), b && e.createElement(N, {
    container: !0,
    className: o.orderConfirmationContainer
  }, (null === (r = b.payment) || void 0 === r ? void 0 : r.length) > 0 && (null === (l = b.payment[0].total) || void 0 === l ? void 0 : l.totalRefunds) && e.createElement("div", {
    className: "".concat(o.fullWidth, " ").concat(o.displayFlex)
  }, e.createElement("span", {
    className: o.failedContainer
  }, "A refund of $", b.payment[0].total.totalRefunds.toFixed(2), " has been applied to this booking.")), e.createElement(N, {
    item: !0,
    className: "".concat(o.firstOrderColumn, " ").concat(o.displayFlex)
  }, e.createElement(k, {
    className: o.fontHeaderConfirmation
  }, function () {
    var e,
        t = "";

    switch (b.jobRequestInvitations[0].status) {
      case "Delivered":
        t = "Your request was sent.";
        break;

      case "Accepted":
        t = (null === (e = b.payment) || void 0 === e ? void 0 : e.length) > 0 && "refunded" === b.payment[0].status ? "Your dumpster was canceled." : "Your dumpster is confirmed!";
        break;

      case "Declined":
      case "Expired":
        t = "Your booking was declined by ".concat(H);
    }

    return t;
  }()), e.createElement(k, {
    className: o.fontSubTitleConfirmation
  }, function () {
    var e,
        t = "";

    switch (b.jobRequestInvitations[0].status) {
      case "Delivered":
        t = "Please allow the service pro up to 3 business hours to confirm the booking. You wont be charged until your booking is confirmed.";
        break;

      case "Accepted":
        t = (null === (e = b.payment) || void 0 === e ? void 0 : e.length) > 0 && "refunded" === b.payment[0].status ? "Your card was fully refunded." : "".concat(H, " is your service provider and will deliver your dumpster. Call your service provider directly for support/questions.");
        break;

      case "Declined":
      case "Expired":
        t = "Unfortunately, your selected service provider is not available to deliver your dumpster. We're sorry for the inconvenience. You have not been charged.";
    }

    return t;
  }()), "Accepted" === b.jobRequestInvitations[0].status && e.createElement(k, {
    className: "".concat(o.fontSubTitleConfirmation)
  }, H, " ", e.createElement("br", null), W && e.createElement("a", {
    inline: !0,
    style: {
      fontSize: "2.3rem"
    },
    className: "".concat(o.boldFontConfirmation, " ").concat(o.proLink),
    align: "right",
    href: "tel://" + W
  }, W)), e.createElement("img", {
    src: p + ((null === (i = b.service[0].images) || void 0 === i ? void 0 : i.length) > 0 ? b.service[0].images[0] : b.service[0].image),
    className: o.imageConfirmation
  }), e.createElement(k, {
    className: o.boldFontConfirmation
  }, b.service[0].description), "Accepted" !== b.jobRequestInvitations[0].status && e.createElement(k, {
    className: "".concat(o.fontSubTitleConfirmation, " ").concat(o.marginPhone)
  }, e.createElement("a", {
    href: K,
    target: "_blank",
    inline: !0,
    className: o.proLink
  }, H)), e.createElement(V, {
    className: o.dividerConfirmation,
    variant: "middle"
  }), e.createElement(N, {
    container: !0,
    direction: "column",
    className: o.fontDatesConfirmation
  }, e.createElement(N, {
    item: !0
  }, e.createElement(k, {
    className: o.boldFontConfirmation
  }, "Delivery"), e.createElement(k, {
    className: o.fontSubTitleConfirmation
  }, F.toLocaleDateString("en-EN", {
    weekday: "long"
  }), ", ", F.toLocaleString("en-EN", {
    month: "long"
  }), " ", F.getDate(), ", ", F.getFullYear())), e.createElement(N, {
    item: !0
  }, e.createElement(k, {
    className: o.boldFontConfirmation
  }, "Removal"), e.createElement(k, {
    className: o.fontSubTitleConfirmation
  }, A.toLocaleDateString("en-EN", {
    weekday: "long"
  }), ", ", A.toLocaleString("en-EN", {
    month: "long"
  }), " ", A.getDate(), ", ", A.getFullYear())), e.createElement(N, {
    item: !0
  }, e.createElement(k, {
    className: "".concat(o.boldFontConfirmation)
  }, "Address"), e.createElement(k, {
    className: o.fontSubTitleConfirmation
  }, b.address.address, " ", b.address.address2), b.address.instructions && e.createElement(k, {
    className: o.fontSubTitleConfirmation
  }, "Instructions: ", b.address.instructions))), e.createElement(V, {
    className: o.dividerConfirmation,
    variant: "middle"
  })), e.createElement(N, {
    item: !0,
    className: "".concat(o.thirdOrderColumn, " ").concat(o.displayFlex)
  }, e.createElement(N, {
    container: !0
  }, e.createElement(k, {
    inline: !0,
    className: o.boldFontConfirmation,
    align: "left"
  }, "Amount")), e.createElement(k, {
    className: o.fontSubTitleConfirmation
  }, "$", b.payment[0].total.gross.toFixed(2)), e.createElement(k, {
    className: o.fontSubTitleConfirmation
  }, b.service[0].details[0].details.replace(". <br>", ",")), e.createElement(k, {
    className: o.fontSubTitleConfirmation
  }, b.service[0].details[1].details.replace(". <br>", ",")), e.createElement(V, {
    className: o.dividerConfirmation,
    variant: "middle"
  }), e.createElement(k, {
    className: "".concat(o.boldFontConfirmation)
  }, "Waste Type"), e.createElement(k, {
    className: o.fontSubTitleConfirmation
  }, b.debrisLabel), Q() && e.createElement(k, {
    className: o.fontSubTitleConfirmation
  }, Q()), X() && e.createElement(e.Fragment, null, e.createElement(V, {
    className: o.dividerConfirmation,
    variant: "middle"
  }), e.createElement(k, {
    className: "".concat(o.boldFontConfirmation)
  }, "Disallowed Waste"), e.createElement(k, {
    className: "".concat(o.fontSubTitleConfirmation)
  }, "The following items are not allowed in the dumpster."), e.createElement("br", null), e.createElement(k, {
    className: o.fontSubTitleConfirmation
  }, X() ? C.disallowedWaste.map(function (t) {
    return e.createElement("span", {
      key: t.id
    }, t.name, e.createElement("br", null));
  }) : void 0), " ")))));
}

function Oa(n) {
  var r,
      l = tt(e.useState(!1), 2),
      i = l[0],
      o = l[1],
      s = tt(e.useState(null), 2),
      c = s[0],
      d = s[1],
      u = wa(),
      m = n.initialData.find(function (e) {
    return "wasteType" === e.key;
  }).value,
      p = n.initialData.find(function (e) {
    return "service" === e.key;
  }).value,
      f = n.initialData.find(function (e) {
    return "fullFormData" === e.key;
  }).value,
      v = n.initialData.find(function (e) {
    return "placeId" === e.key;
  }).value,
      g = null === (r = n.initialData.find(function (e) {
    return "customerData" === e.key;
  })) || void 0 === r ? void 0 : r.value,
      h = tt(e.useState(g), 2),
      b = h[0],
      y = h[1],
      x = tt(t(), 2),
      C = x[0],
      E = x[1],
      w = tt(t(!0), 2),
      k = w[0],
      N = w[1],
      S = tt(t(!0), 2),
      I = S[0],
      D = S[1],
      F = tt(t(null), 2),
      P = F[0],
      L = F[1],
      A = tt(t(!1), 2),
      _ = A[0],
      O = A[1],
      M = tt(t(""), 2),
      B = M[0],
      z = M[1],
      W = tt(t({}), 2),
      R = W[0],
      V = W[1];
  a(function () {
    Ge(Je().mark(function e() {
      var t, a, r;
      return Je().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, N(!0), t = j(), e.next = 5, oa.getServiceByIdWithEvent(n.apolloURL, n.proId, p.id, {
                event: t
              });

            case 5:
              a = e.sent, E(a.data), localStorage.removeItem("Customer"), delete Qt.defaults.headers.common.hashcode, e.next = 14;
              break;

            case 11:
              e.prev = 11, e.t0 = e.catch(0), 404 === (null === (r = e.t0.response) || void 0 === r ? void 0 : r.status) ? (z("pageOutOfDate"), O(!0)) : (z("pageOutOfOrder"), O(!0));

            case 14:
              return e.prev = 14, N(!1), e.finish(14);

            case 17:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 11, 14, 17]]);
    }))();
  }, []);

  var j = function j() {
    try {
      var e,
          t = null === (e = n.staticUrl) || void 0 === e ? void 0 : e.replace("/assets/", ""),
          a = {
        wasteType: m,
        placeId: v
      };
      JSON.parse(f).forEach(function (e) {
        switch (e[0]) {
          case "street":
            a.street1 = e[1];
            break;

          case "street2":
            a.street2 = e[1];
            break;

          case "locality":
            a.city = e[1];
            break;

          case "state":
            a.state = e[1];
            break;

          case "postal_code":
            a.zipCode = e[1];
        }
      });
      var r = {
        eventType: "BR",
        eventDescription: "Confirm order viewed",
        proId: n.proId,
        eventData: Ke({
          source: t,
          sessionId: localStorage.getItem("sessionId"),
          url: t + n.backUrl
        }, a)
      };
      return V(r), r;
    } catch (e) {
      console.log("Could no generate new event: ", e);
    }
  };

  return k ? e.createElement(T, {
    size: 35,
    className: u.loader
  }) : e.createElement(e.Fragment, null, e.createElement(La, {
    handleClose: function handleClose() {
      if (O(!1), n.handleBack) {
        var e = null != c && c.selectedWasteType ? null == c ? void 0 : c.selectedWasteType : m;
        n.handleBack([{
          key: "wasteType",
          value: e && (Array.isArray(e) ? e[0] : e)
        }, {
          key: "fullFormData",
          value: null != c && c.googlePlace ? null == c ? void 0 : c.googlePlace : f
        }]);
      }
    },
    modalCode: B,
    showModal: _,
    setShowModal: O
  }), I ? i ? e.createElement(Aa, {
    selectedWasteType: null == c ? void 0 : c.selectedWasteType,
    selectedWasteTypeLabel: null == c ? void 0 : c.selectedWasteTypeLabel,
    addressData: null == c ? void 0 : c.addressData,
    service: C,
    fromDate: null == c ? void 0 : c.deliveryDates[0],
    toDate: null == c ? void 0 : c.deliveryDates[1],
    dumpsterFor: null == c ? void 0 : c.selectedDumpsterFor,
    googlePlaceAutocompleteApiKey: n.googlePlaceAutocompleteApiKey,
    apolloURL: n.apolloURL,
    proId: n.proId,
    proName: n.proName,
    handleBack: function handleBack(e) {
      y(e), o(!1);
    },
    placeId: v,
    defaultName: null == b ? void 0 : b.name,
    defaultLastname: null == b ? void 0 : b.lastname,
    defaultMobilePhone: null == b ? void 0 : b.mobilePhone,
    defaultEmail: null == b ? void 0 : b.email,
    defaultDumpsterPlacement: null == b ? void 0 : b.dumpsterPlacement,
    defaultCustomerList: null == b ? void 0 : b.customerList,
    defaultCustomerId: null == b ? void 0 : b.customerId,
    defaultStep: g && "panel1",
    handleContinue: function handleContinue(e) {
      window.history.replaceState(null, "", "/order?j=".concat(e)), L(e), D(!1);
    },
    stripeApiKey: n.stripeApiKey,
    getAditionalPeriodsAmount: null == c ? void 0 : c.getAditionalPeriodsAmount,
    serviceDescription: null == c ? void 0 : c.serviceDescription,
    staticUrl: n.staticUrl,
    event: R,
    availabilityRequestId: n.availabilityRequestId
  }) : C && e.createElement(Na, {
    proName: n.proName,
    deliveryDates: null == c ? void 0 : c.deliveryDates,
    dumpsterFor: null == c ? void 0 : c.selectedDumpsterFor,
    selectedWasteType: null != c && c.selectedWasteType ? null == c ? void 0 : c.selectedWasteType : m,
    googlePlace: null != c && c.googlePlace ? null == c ? void 0 : c.googlePlace : f,
    staticUrl: n.staticUrl,
    googlePlaceAutocompleteApiKey: n.googlePlaceAutocompleteApiKey,
    apolloURL: n.apolloURL,
    service: C,
    placeId: v,
    handleCheckoutClick: function handleCheckoutClick(e) {
      e.addressData = Object.fromEntries(JSON.parse(e.googlePlace)), d(e), o(!0);
    },
    connectedAcountId: n.connectedAcountId,
    proId: n.proId,
    handleBack: n.handleBack,
    setModalCode: z,
    setShowModal: O,
    maxDatePicker: n.maxDatePicker ? n.maxDatePicker : 7776e6
  }) : e.createElement(_a, {
    proId: n.proId,
    apolloURL: n.apolloURL,
    proName: n.proName,
    proPhone: n.proPhone,
    proEmail: n.email,
    bookingId: P,
    imageStaticEnv: n.staticUrl,
    backUrl: n.backUrl,
    gatsbyKey: n.gatsbyKey
  }));
}

var Ma = Ue(function () {
  return {
    root: {
      padding: "24px",
      display: "flex",
      flexDirection: "column",
      alignContent: "center"
    },
    title: {
      fontSize: "4rem !important",
      fontFamily: "inherit !important",
      fontWeight: "600 !important"
    },
    subtitle: {
      fontSize: "2rem !important",
      fontWeight: "400 !important",
      fontFamily: "inherit !important"
    },
    buttonContainer: {
      marginTop: "48px",
      display: "flex",
      justifyContent: "center"
    }
  };
});

function Ba() {
  var t = Ma(),
      a = j(),
      n = H(a.breakpoints.down("sm"));
  return e.createElement("div", {
    className: t.root
  }, e.createElement(k, {
    align: "center",
    className: t.title,
    variant: n ? "h4" : "h1"
  }, "404: The page you are looking for isn’t here"), e.createElement(k, {
    align: "center",
    variant: "subtitle2",
    className: t.subtitle
  }, "There's nothing happening here.  Try again or use the link below."), e.createElement("div", {
    className: t.buttonContainer
  }, e.createElement(F, {
    variant: "contained",
    className: "availabilityButton",
    style: {
      maxWidth: "200px"
    },
    onClick: function onClick() {
      return window.location.href = "/";
    }
  }, "Go to home")));
}

var za = Ue(function () {
  return {
    root: {
      padding: "24px",
      display: "flex",
      flexDirection: "column",
      alignContent: "center"
    },
    title: {
      fontSize: "4rem !important",
      fontFamily: "inherit !important",
      fontWeight: "600 !important"
    },
    subtitle: {
      fontSize: "2rem !important",
      fontWeight: "400 !important",
      fontFamily: "inherit !important"
    },
    buttonContainer: {
      marginTop: "48px",
      display: "flex",
      justifyContent: "center"
    }
  };
});

function Wa() {
  var t = za(),
      a = j(),
      n = H(a.breakpoints.down("sm"));
  return e.createElement("div", {
    className: t.root
  }, e.createElement(k, {
    align: "center",
    className: t.title,
    variant: n ? "h4" : "h1"
  }, "500 Error"), e.createElement(k, {
    align: "center",
    variant: "subtitle2",
    className: t.subtitle
  }, "The server is not responding right now.  Please wait a few moments and try again."), e.createElement("div", {
    className: t.buttonContainer
  }, e.createElement(F, {
    variant: "contained",
    className: "availabilityButton",
    style: {
      maxWidth: "200px"
    },
    onClick: function onClick() {
      return window.location.reload();
    }
  }, "Refresh")));
}

var Ra = {
  Small: 10,
  Medium: 17,
  Large: 30,
  "Not Sure": 14
};

function Va(n) {
  var r,
      l = n.apolloURL,
      i = n.availabilityReqId,
      o = n.imageStaticEnv,
      s = n.gatsbyKey,
      c = n.serviceCardCallback,
      d = n.defaultTemplateName,
      u = n.defaultService,
      m = n.baseServiceId,
      p = tt(t(!0), 2),
      f = p[0],
      v = p[1],
      g = tt(t(), 2),
      h = g[0],
      b = g[1],
      y = tt(t([]), 2),
      x = y[0],
      C = y[1],
      E = tt(t(), 2),
      w = E[0],
      k = E[1],
      S = tt(t(), 2),
      I = S[0],
      D = S[1],
      F = tt(t(d || "card-list"), 2),
      P = F[0],
      L = F[1],
      A = tt(t([]), 2),
      _ = A[0],
      O = A[1],
      M = tt(t(), 2),
      B = M[0],
      z = M[1],
      W = tt(t(), 2);
  W[0], W[1];
  var R = tt(t(""), 2),
      V = R[0],
      j = R[1],
      H = tt(t([]), 2),
      U = H[0],
      q = H[1],
      K = tt(t([]), 2),
      J = K[0],
      $ = K[1],
      Y = tt(t(1), 2),
      G = Y[0],
      Z = Y[1],
      X = tt(t(6), 2),
      Q = X[0],
      ee = X[1],
      te = tt(t(!1), 2),
      ae = te[0],
      ne = te[1];
  a(function () {
    var e;
    return Ge(Je().mark(function t() {
      var a, n, r, o, c, d, p, f, g, h, y, x, E, w, N, S, I, D;
      return Je().wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.prev = 0, v(!0), t.next = 4, Promise.all([fa(l, i), pa.getDumpsterPublishedPros(l, s)]);

            case 4:
              a = t.sent, n = tt(a, 2), r = n[0], o = n[1], r.data && (c = r.data.addressData, b(r.data), z({
                key: "customerData",
                value: {
                  name: r.data.fullCustomer[0].firstName,
                  lastname: r.data.fullCustomer[0].lastName,
                  mobilePhone: Bt(r.data.fullCustomer[0].phone),
                  email: r.data.fullCustomer[0].email
                }
              }), d = [{
                key: "wasteType",
                value: +r.data.wasteType
              }, {
                key: "deliveryAddress",
                value: c.address && c.address2 ? c.address + ", " + c.address2 : ""
              }, ie(c), {
                key: "placeId",
                value: c.place
              }], O(d), "undefined" == typeof window || localStorage.getItem("sessionId") || (p = Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2), localStorage.setItem("sessionId", p)), "Expired" === r.data.status || "Canceled" === r.data.status ? (g = [{
                key: "wasteType",
                value: [+r.data.wasteType]
              }, {
                key: "deliveryAddress",
                value: c.address && c.address2 ? c.address + ", " + c.address2 : ""
              }, {
                key: "fullFormData",
                value: {
                  odf_country: "United States",
                  odf_locality: c.city,
                  odf_place_id: c.address_id,
                  odf_postal_code: null === (f = c.zip) || void 0 === f ? void 0 : f.toString(),
                  odf_state: c.state,
                  odf_street: c.address,
                  odf_street2: "".concat(c.city, ", ").concat(c.state, " ").concat(c.zip, ", USA"),
                  wasteType: [+r.data.wasteType]
                }
              }], localStorage.setItem("onlineBookingData", JSON.stringify({
                placeId: c.place,
                baseServiceId: m,
                skip: 0,
                limit: 21,
                initialValues: g,
                finalDataForBooking: d
              }))) : (k(c.place), x = {}, null === (h = r.data.notifications) || void 0 === h || h.forEach(function (e) {
                e.acceptedData.forEach(function (t) {
                  t.acceptedServices.forEach(function (a) {
                    var n = e.fullAcceptedServices.find(function (e) {
                      return e._id === a;
                    });
                    if (n) if (x[a]) x[a].availableDates.push(t.date);else {
                      var l,
                          i = null === (l = n.placesId) || void 0 === l ? void 0 : l.find(function (e) {
                        return +e.placeId == +r.data.addressData.place;
                      }),
                          o = n.price;
                      (null == i ? void 0 : i.distanceFee) > 0 && (o += i.distanceFee), x[a] = Ke(Ke({}, n), {}, {
                        id: n._id,
                        title: n.description,
                        subtitle: n.dimensions,
                        price: o.toFixed(2),
                        details: n.details.map(function (e, t) {
                          return {
                            id: t,
                            text1: e.details
                          };
                        }),
                        allowBookingOnline: e.allowBookingOnline,
                        availableDates: [t.date]
                      });
                    }
                  });
                });
              }), E = Object.values(x), (null === (y = o.data) || void 0 === y ? void 0 : y.length) > 0 && C(o.data), (null == E ? void 0 : E.length) > 0 && ((w = new Date()).setUTCHours(0, 0, 0, 0), N = [].concat(at(r.data.alternativeDates), [r.data.startDate]).map(function (e) {
                var t = new Date(e);
                return t.setUTCHours(0, 0, 0, 0), t;
              }).reduce(function (e, t) {
                return t > e ? t : e;
              }), S = !0, w > N && (S = !1), I = E.map(function (e) {
                return Ke(Ke({}, e), {}, {
                  includesPreferredDate: e.availableDates.includes(r.data.startDate),
                  showBanner: S
                });
              }), D = de(I, "top", r.data, o.data), q(D), $(de(I, "all", r.data, o.data)), D.length < 3 && (ne(!0), ee(6 - D.length))), "card-details" === P && se(u, E), "Sent" === r.data.status && (e = function () {
                var e = Ge(Je().mark(function e() {
                  var t;
                  return Je().wrap(function (e) {
                    for (;;) {
                      switch (e.prev = e.next) {
                        case 0:
                          if ("visible" !== document.visibilityState) {
                            e.next = 11;
                            break;
                          }

                          return e.prev = 1, e.next = 4, va(l, i, s);

                        case 4:
                          null != (t = e.sent) && t.data && (r.data.acceptedNotificationsCount == t.data.acceptedNotificationsCount && r.data.status === t.data.status || window.location.reload()), e.next = 11;
                          break;

                        case 8:
                          e.prev = 8, e.t0 = e.catch(1), console.log("error: ", e.t0);

                        case 11:
                        case "end":
                          return e.stop();
                      }
                    }
                  }, e, null, [[1, 8]]);
                }));
                return function () {
                  return e.apply(this, arguments);
                };
              }(), document.addEventListener("visibilitychange", e)))), t.next = 15;
              break;

            case 11:
              t.prev = 11, t.t0 = t.catch(0), console.log("error: ", t.t0), j(t.t0.response.status);

            case 15:
              return t.prev = 15, v(!1), t.finish(15);

            case 18:
            case "end":
              return t.stop();
          }
        }
      }, t, null, [[0, 11, 15, 18]]);
    }))(), function () {
      e && (console.log("Removing visibilitychange listener"), document.removeEventListener("visibilitychange", e));
    };
  }, []);

  var re,
      le,
      ie = function ie(e) {
    var t = [["country", "United States"], ["locality", e.city], ["place_id", e.address_id], ["postal_code", e.zip.toString()], ["state", e.state], ["street", e.address], ["street2", "".concat(e.city, ", ").concat(e.state, " ").concat(e.zip, ", USA")]];
    return {
      key: "fullFormData",
      value: JSON.stringify(t)
    };
  },
      oe = function oe(e) {
    se(e.id), L("card-details"), sessionStorage.setItem("service-detail", JSON.stringify({
      templateName: "card-details",
      serviceId: e.id
    })), window.scrollTo(0, 0);
  },
      se = function se(e, t) {
    var a = t || J,
        n = null == a ? void 0 : a.find(function (t) {
      return t.id === e;
    });

    if (n) {
      D(n);
      var r = sessionStorage.getItem("service-detail");
      r = r ? JSON.parse(r) : {}, sessionStorage.setItem("service-detail", JSON.stringify(Ke(Ke({}, r), {}, {
        serviceId: e
      })));
    } else {
      if ((null == a ? void 0 : a.length) > 0) if (I) if (!a.find(function (e) {
        return e.id === I.id;
      })) {
        var l = I.proId,
            i = a.find(function (e) {
          return +e.proId == +l;
        });
        i ? D(i) : D();
      }
    }
  },
      ce = function ce(e) {
    return x.find(function (t) {
      return +t._attributes_id == +e;
    });
  },
      de = function de(e, t, a, n) {
    var r,
        l = e.map(function (e) {
      var t,
          r = null === (t = e.description.match(/\d+/)) || void 0 === t ? void 0 : t[0],
          l = e.includesPreferredDate ? 0 : 10,
          i = Math.abs(Ra[a.dumpsterSize] - +r),
          o = n.find(function (t) {
        return +t._attributes_id == +e.proId;
      }),
          s = 1;
      return o && o.pr && +o.pr > 0 && +o.pr < 5 && (s = 0), Ke(Ke({}, e), {}, {
        matchScore: l + i,
        payingPro: s
      });
    });
    return "top" === t && (l = l.filter(function (e) {
      return 0 === e.payingPro && e.matchScore < 22 && e.allowBookingOnline;
    })), l = l.sort(function (e, a) {
      if ("all" === t) {
        var n = a.allowBookingOnline - e.allowBookingOnline;
        if (0 !== n) return n;
      }

      var r = e.matchScore - a.matchScore;
      if (0 !== r) return r;
      var l = e.dumpsterSize[0] - a.dumpsterSize[0];
      return 0 !== l ? l : e.price - a.price;
    }), "top" === t ? null === (r = l) || void 0 === r ? void 0 : r.slice(0, 6) : l;
  };

  return e.createElement(e.Fragment, null, e.createElement(N, {
    spacing: 4,
    container: !0,
    direction: "column"
  }, f ? e.createElement("div", {
    className: "loader-msg"
  }, e.createElement(T, {
    size: 35,
    className: "loader"
  }), e.createElement("p", {
    className: "loader-subtitle"
  }, "Getting your latest results…")) : V ? 400 === V || 404 === V ? e.createElement(Ba, null) : e.createElement(Wa, null) : h && e.createElement(e.Fragment, null, "card-details" !== P && e.createElement("div", {
    className: "header-container"
  }, e.createElement("div", {
    className: "description-container"
  }, e.createElement("div", {
    className: "av-detail"
  }, e.createElement("h4", {
    className: "font-header"
  }, "Dumpster request"), e.createElement("p", {
    className: "font-header-subtitle"
  }, "Deliver on ", [h.startDate].map(function (e) {
    var t = new Date(e),
        a = new Intl.DateTimeFormat("en-US", {
      weekday: "short",
      timeZone: "UTC"
    }).format(t),
        n = new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      timeZone: "UTC"
    }).format(t);
    return "".concat(a, ", ").concat(n);
  }), " to ", h.fullCustomer[0].firstName, " in ", h.addressData.city, ", ", (re = h.addressData.state, (null == (le = [{
    name: "Alabama",
    abbreviation: "AL"
  }, {
    name: "Alaska",
    abbreviation: "AK"
  }, {
    name: "Arizona",
    abbreviation: "AZ"
  }, {
    name: "Arkansas",
    abbreviation: "AR"
  }, {
    name: "California",
    abbreviation: "CA"
  }, {
    name: "Colorado",
    abbreviation: "CO"
  }, {
    name: "Connecticut",
    abbreviation: "CT"
  }, {
    name: "Delaware",
    abbreviation: "DE"
  }, {
    name: "District of Columbia",
    abbreviation: "DC"
  }, {
    name: "Florida",
    abbreviation: "FL"
  }, {
    name: "Georgia",
    abbreviation: "GA"
  }, {
    name: "Hawaii",
    abbreviation: "HI"
  }, {
    name: "Idaho",
    abbreviation: "ID"
  }, {
    name: "Illinois",
    abbreviation: "IL"
  }, {
    name: "Indiana",
    abbreviation: "IN"
  }, {
    name: "Iowa",
    abbreviation: "IA"
  }, {
    name: "Kansas",
    abbreviation: "KS"
  }, {
    name: "Kentucky",
    abbreviation: "KY"
  }, {
    name: "Louisiana",
    abbreviation: "LA"
  }, {
    name: "Maine",
    abbreviation: "ME"
  }, {
    name: "Maryland",
    abbreviation: "MD"
  }, {
    name: "Massachusetts",
    abbreviation: "MA"
  }, {
    name: "Michigan",
    abbreviation: "MI"
  }, {
    name: "Minnesota",
    abbreviation: "MN"
  }, {
    name: "Mississippi",
    abbreviation: "MS"
  }, {
    name: "Missouri",
    abbreviation: "MO"
  }, {
    name: "Montana",
    abbreviation: "MT"
  }, {
    name: "Nebraska",
    abbreviation: "NE"
  }, {
    name: "Nevada",
    abbreviation: "NV"
  }, {
    name: "New Hampshire",
    abbreviation: "NH"
  }, {
    name: "New Jersey",
    abbreviation: "NJ"
  }, {
    name: "New Mexico",
    abbreviation: "NM"
  }, {
    name: "New York",
    abbreviation: "NY"
  }, {
    name: "North Carolina",
    abbreviation: "NC"
  }, {
    name: "North Dakota",
    abbreviation: "ND"
  }, {
    name: "Ohio",
    abbreviation: "OH"
  }, {
    name: "Oklahoma",
    abbreviation: "OK"
  }, {
    name: "Oregon",
    abbreviation: "OR"
  }, {
    name: "Pennsylvania",
    abbreviation: "PA"
  }, {
    name: "Rhode Island",
    abbreviation: "RI"
  }, {
    name: "South Carolina",
    abbreviation: "SC"
  }, {
    name: "South Dakota",
    abbreviation: "SD"
  }, {
    name: "Tennessee",
    abbreviation: "TN"
  }, {
    name: "Texas",
    abbreviation: "TX"
  }, {
    name: "Utah",
    abbreviation: "UT"
  }, {
    name: "Vermont",
    abbreviation: "VT"
  }, {
    name: "Virginia",
    abbreviation: "VA"
  }, {
    name: "Washington",
    abbreviation: "WA"
  }, {
    name: "West Virginia",
    abbreviation: "WV"
  }, {
    name: "Wisconsin",
    abbreviation: "WI"
  }, {
    name: "Wyoming",
    abbreviation: "WY"
  }].find(function (e) {
    return e.name === re;
  })) ? void 0 : le.abbreviation) || re))))), "card-details" !== P && e.createElement("h1", {
    className: "av-title"
  }, "Top Matches for You"), "Expired" === h.status || "Canceled" === h.status ? e.createElement("div", {
    style: {
      width: "100%"
    }
  }, e.createElement("h4", {
    className: "av-subtitle"
  }, "These availability ", "Canceled" === h.status ? "request was canceled" : "results expired", ". You can still ", e.createElement("a", {
    href: "/book",
    className: "link-url"
  }, "price and book a dumpster here"), ".")) : e.createElement(e.Fragment, null, "card-details" !== P && e.createElement("h4", {
    className: "av-subtitle",
    style: {
      marginBottom: "10px"
    }
  }, 0 === (null === (r = h.notifications) || void 0 === r ? void 0 : r.length) && "No responses yet.", " ", e.createElement("a", {
    href: "javascript:location.reload()",
    className: "link-url"
  }, "Refresh for the latest results")), (null == J ? void 0 : J.length) > 0 && "card-details" === P && I ? e.createElement(ha, {
    proId: I.proId,
    apolloURL: l,
    gatsbyKey: s,
    imageStaticEnv: o,
    service: I,
    services: J.filter(function (e) {
      return e.proId === I.proId;
    }),
    placeId: w,
    changeService: se,
    currentWasteType: h.wasteType,
    onClickBook: function onClickBook() {
      var e = [].concat(at(_), [{
        key: "service",
        value: I
      }, {
        key: "template",
        value: "card-details"
      }, {
        key: "profileData",
        value: ce(I.proId)
      }, {
        key: "dumpsterSize",
        value: h.dumpsterSize
      }]);
      B && e.push(B), c(e);
    },
    changeTemplate: function changeTemplate(e) {
      L(e), "card-details" !== e && sessionStorage.removeItem("service-detail");
    },
    profileData: ce(I.proId)
  }) : (null == J ? void 0 : J.length) > 0 && e.createElement(e.Fragment, null, e.createElement("div", {
    className: "services-by-section"
  }, e.createElement(Xt, {
    cards: U,
    placeId: w,
    onCardActionClick: c,
    imageStaticEnv: o,
    isLoadingServices: f,
    finalData: _,
    handleServiceClick: oe,
    listOfPublishedPros: x,
    selectedDumpsterSize: h.dumpsterSize,
    customerData: B
  }), !ae && J.length > U.length && e.createElement("p", {
    className: "more-results",
    onClick: function onClick() {
      return ne(!0);
    }
  }, "More results >")), ae && e.createElement("div", {
    className: "services-by-section"
  }, (null == U ? void 0 : U.length) > 0 && e.createElement("h1", {
    className: "av-title",
    style: {
      paddingTop: "15px",
      paddingBottom: 0
    }
  }, "All results"), e.createElement(Xt, {
    cards: J.slice(0, G * Q),
    placeId: w,
    onCardActionClick: c,
    imageStaticEnv: o,
    isLoadingServices: f,
    finalData: _,
    handleServiceClick: oe,
    listOfPublishedPros: x,
    selectedDumpsterSize: h.dumpsterSize,
    customerData: B
  }), J.length > G * Q && e.createElement("p", {
    className: "more-results",
    onClick: function onClick() {
      Z(G + 1), 6 !== Q && ee(6);
    }
  }, "See more")))))));
}

export { Nt as GooglePlaceAutocomplete, Kt as Ondeff, Oa as OnlineBooking, _a as OrderConfirmation, It as SelectInput, Va as ServiceAvailability, ha as ServiceDetail, Ca as ServiceSeeker, Ea as createSteplessValidationSchema, Wt as createValidationSchema };